import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(client: GraphQLClient, query: string, variables?: TVariables, headers?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables, headers);
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Dimension: any;
  HexColor: any;
  JSON: any;
  Quality: any;
};

/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type Accordion = Entry & _Node & {
  __typename?: 'Accordion';
  _id: Scalars['ID'];
  accountFaqPage?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<AccordionLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
  tabsCollection?: Maybe<AccordionTabsCollection>;
  titleIntern?: Maybe<Scalars['String']>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionAccountFaqPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccordionItemFilter>;
};


/** Accordion Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordion) */
export type AccordionTitleInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AccordionCollection = {
  __typename?: 'AccordionCollection';
  items: Array<Maybe<Accordion>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AccordionFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionFilter>>>;
  accountFaqPage?: InputMaybe<Scalars['String']>;
  accountFaqPage_contains?: InputMaybe<Scalars['String']>;
  accountFaqPage_exists?: InputMaybe<Scalars['Boolean']>;
  accountFaqPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accountFaqPage_not?: InputMaybe<Scalars['String']>;
  accountFaqPage_not_contains?: InputMaybe<Scalars['String']>;
  accountFaqPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tabs?: InputMaybe<CfAccordionItemNestedFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordionItem) */
export type AccordionItem = Entry & _Node & {
  __typename?: 'AccordionItem';
  _id: Scalars['ID'];
  content?: Maybe<Rte>;
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<AccordionItemLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordionItem) */
export type AccordionItemContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<RteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordionItem) */
export type AccordionItemHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordionItem) */
export type AccordionItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/accordionItem) */
export type AccordionItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AccordionItemCollection = {
  __typename?: 'AccordionItemCollection';
  items: Array<Maybe<AccordionItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AccordionItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<AccordionItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AccordionItemFilter>>>;
  content?: InputMaybe<CfRteNestedFilter>;
  content_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AccordionItemLinkingCollections = {
  __typename?: 'AccordionItemLinkingCollections';
  accordionCollection?: Maybe<AccordionCollection>;
  entryCollection?: Maybe<EntryCollection>;
  tabModuleCollection?: Maybe<TabModuleCollection>;
};


export type AccordionItemLinkingCollectionsAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemLinkingCollectionsAccordionCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AccordionItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AccordionItemLinkingCollectionsTabModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemLinkingCollectionsTabModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AccordionItemLinkingCollectionsAccordionCollectionOrder {
  AccountFaqPageAsc = 'accountFaqPage_ASC',
  AccountFaqPageDesc = 'accountFaqPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export enum AccordionItemLinkingCollectionsTabModuleCollectionOrder {
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export enum AccordionItemOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type AccordionLinkingCollections = {
  __typename?: 'AccordionLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type AccordionLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AccordionLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AccordionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AccordionLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AccordionLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AccordionLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AccordionLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AccordionOrder {
  AccountFaqPageAsc = 'accountFaqPage_ASC',
  AccountFaqPageDesc = 'accountFaqPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export type AccordionTabsCollection = {
  __typename?: 'AccordionTabsCollection';
  items: Array<Maybe<AccordionItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum AccordionTabsCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/arPdpBox) */
export type ArPdpBox = Entry & _Node & {
  __typename?: 'ArPdpBox';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ArPdpBoxLinkingCollections>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/arPdpBox) */
export type ArPdpBoxCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/arPdpBox) */
export type ArPdpBoxHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/arPdpBox) */
export type ArPdpBoxLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/arPdpBox) */
export type ArPdpBoxTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ArPdpBoxCollection = {
  __typename?: 'ArPdpBoxCollection';
  items: Array<Maybe<ArPdpBox>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ArPdpBoxFilter = {
  AND?: InputMaybe<Array<InputMaybe<ArPdpBoxFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ArPdpBoxFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ArPdpBoxLinkingCollections = {
  __typename?: 'ArPdpBoxLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ArPdpBoxLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ArPdpBoxLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ArPdpBoxLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ArPdpBoxLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ArPdpBoxOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
  transform?: InputMaybe<ImageTransformOptions>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']>;
  contentType_contains?: InputMaybe<Scalars['String']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentType_not?: InputMaybe<Scalars['String']>;
  contentType_not_contains?: InputMaybe<Scalars['String']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName?: InputMaybe<Scalars['String']>;
  fileName_contains?: InputMaybe<Scalars['String']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fileName_not?: InputMaybe<Scalars['String']>;
  fileName_not_contains?: InputMaybe<Scalars['String']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size?: InputMaybe<Scalars['Int']>;
  size_exists?: InputMaybe<Scalars['Boolean']>;
  size_gt?: InputMaybe<Scalars['Int']>;
  size_gte?: InputMaybe<Scalars['Int']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  size_lt?: InputMaybe<Scalars['Int']>;
  size_lte?: InputMaybe<Scalars['Int']>;
  size_not?: InputMaybe<Scalars['Int']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
  url_contains?: InputMaybe<Scalars['String']>;
  url_exists?: InputMaybe<Scalars['Boolean']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url_not?: InputMaybe<Scalars['String']>;
  url_not_contains?: InputMaybe<Scalars['String']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  banderoleNesletterCollection?: Maybe<BanderoleNesletterCollection>;
  blackfridayNewsletterModuleCollection?: Maybe<BlackfridayNewsletterModuleCollection>;
  blogTeaserItemCollection?: Maybe<BlogTeaserItemCollection>;
  categorySliderModuleItemCollection?: Maybe<CategorySliderModuleItemCollection>;
  customNewsletterCollection?: Maybe<CustomNewsletterCollection>;
  editorialGalleryCollection?: Maybe<EditorialGalleryCollection>;
  entryCollection?: Maybe<EntryCollection>;
  heroStageItemCollection?: Maybe<HeroStageItemCollection>;
  imageModuleItemCollection?: Maybe<ImageModuleItemCollection>;
  logoGridCollection?: Maybe<LogoGridCollection>;
  lookbookCollection?: Maybe<LookbookCollection>;
  multiTeaserItemCollection?: Maybe<MultiTeaserItemCollection>;
  navigationListElementCollection?: Maybe<NavigationListElementCollection>;
  newsletterCollection?: Maybe<NewsletterCollection>;
  newsletterModuleCollection?: Maybe<NewsletterModuleCollection>;
  productBenefitCollection?: Maybe<ProductBenefitCollection>;
  productListPageTeaserItemCollection?: Maybe<ProductListPageTeaserItemCollection>;
  productTeaserCollection?: Maybe<ProductTeaserCollection>;
  quoteCollection?: Maybe<QuoteCollection>;
  seoCollection?: Maybe<SeoCollection>;
  shopTheLookCollection?: Maybe<ShopTheLookCollection>;
  stageCollection?: Maybe<StageCollection>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
  textImageTeaserCollection?: Maybe<TextImageTeaserCollection>;
  textPicTeaserItemCollection?: Maybe<TextPicTeaserItemCollection>;
  videoCollection?: Maybe<VideoCollection>;
};


export type AssetLinkingCollectionsBanderoleNesletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsBlackfridayNewsletterModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsBlogTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsCategorySliderModuleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsCustomNewsletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEditorialGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsHeroStageItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsImageModuleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsLogoGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsLookbookCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsMultiTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsNewsletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsNewsletterModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsProductBenefitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsProductListPageTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsProductTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsSeoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsShopTheLookCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsStageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTextImageTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsTextPicTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AssetLinkingCollectionsVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** A headline and RTE text for augmented reality popup [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/augmentedReality) */
export type AugmentedReality = Entry & _Node & {
  __typename?: 'AugmentedReality';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  ctaText?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<AugmentedRealityLinkingCollections>;
  rte?: Maybe<AugmentedRealityRte>;
  sys: Sys;
};


/** A headline and RTE text for augmented reality popup [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/augmentedReality) */
export type AugmentedRealityCtaTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A headline and RTE text for augmented reality popup [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/augmentedReality) */
export type AugmentedRealityHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A headline and RTE text for augmented reality popup [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/augmentedReality) */
export type AugmentedRealityInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A headline and RTE text for augmented reality popup [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/augmentedReality) */
export type AugmentedRealityLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A headline and RTE text for augmented reality popup [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/augmentedReality) */
export type AugmentedRealityRteArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type AugmentedRealityCollection = {
  __typename?: 'AugmentedRealityCollection';
  items: Array<Maybe<AugmentedReality>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type AugmentedRealityFilter = {
  AND?: InputMaybe<Array<InputMaybe<AugmentedRealityFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AugmentedRealityFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaText?: InputMaybe<Scalars['String']>;
  ctaText_contains?: InputMaybe<Scalars['String']>;
  ctaText_exists?: InputMaybe<Scalars['Boolean']>;
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaText_not?: InputMaybe<Scalars['String']>;
  ctaText_not_contains?: InputMaybe<Scalars['String']>;
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rte_contains?: InputMaybe<Scalars['String']>;
  rte_exists?: InputMaybe<Scalars['Boolean']>;
  rte_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
};

export type AugmentedRealityLinkingCollections = {
  __typename?: 'AugmentedRealityLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type AugmentedRealityLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type AugmentedRealityLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AugmentedRealityLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum AugmentedRealityLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum AugmentedRealityOrder {
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type AugmentedRealityRte = {
  __typename?: 'AugmentedRealityRte';
  json: Scalars['JSON'];
  links: AugmentedRealityRteLinks;
};

export type AugmentedRealityRteAssets = {
  __typename?: 'AugmentedRealityRteAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type AugmentedRealityRteEntries = {
  __typename?: 'AugmentedRealityRteEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type AugmentedRealityRteLinks = {
  __typename?: 'AugmentedRealityRteLinks';
  assets: AugmentedRealityRteAssets;
  entries: AugmentedRealityRteEntries;
  resources: AugmentedRealityRteResources;
};

export type AugmentedRealityRteResources = {
  __typename?: 'AugmentedRealityRteResources';
  block: Array<AugmentedRealityRteResourcesBlock>;
  hyperlink: Array<AugmentedRealityRteResourcesHyperlink>;
  inline: Array<AugmentedRealityRteResourcesInline>;
};

export type AugmentedRealityRteResourcesBlock = ResourceLink & {
  __typename?: 'AugmentedRealityRteResourcesBlock';
  sys: ResourceSys;
};

export type AugmentedRealityRteResourcesHyperlink = ResourceLink & {
  __typename?: 'AugmentedRealityRteResourcesHyperlink';
  sys: ResourceSys;
};

export type AugmentedRealityRteResourcesInline = ResourceLink & {
  __typename?: 'AugmentedRealityRteResourcesInline';
  sys: ResourceSys;
};

/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type Banderole = Entry & _Node & {
  __typename?: 'Banderole';
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  countDown?: Maybe<BanderoleCountDown>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BanderoleLinkingCollections>;
  sticky?: Maybe<Scalars['Boolean']>;
  sys: Sys;
  textColor?: Maybe<Scalars['String']>;
};


/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type BanderoleBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type BanderoleCountDownArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<BanderoleCountDownFilter>;
};


/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type BanderoleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type BanderoleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type BanderoleStickyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A banderole banner that displays at top of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderole) */
export type BanderoleTextColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BanderoleCollection = {
  __typename?: 'BanderoleCollection';
  items: Array<Maybe<Banderole>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDown = Entry & _Node & {
  __typename?: 'BanderoleCountDown';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  countDownDate?: Maybe<Scalars['DateTime']>;
  disableNewsletterPopup?: Maybe<Scalars['Boolean']>;
  discountCode?: Maybe<Scalars['String']>;
  fullClick?: Maybe<Scalars['String']>;
  hideCountDown?: Maybe<Scalars['Boolean']>;
  hidePdpCountdown?: Maybe<Scalars['Boolean']>;
  hidePromoCode?: Maybe<Scalars['Boolean']>;
  hideStageCountdown?: Maybe<Scalars['Boolean']>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BanderoleCountDownLinkingCollections>;
  newsletterText?: Maybe<Scalars['String']>;
  pdpCategory?: Maybe<Scalars['String']>;
  pdpText?: Maybe<Scalars['String']>;
  promoText?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownCountDownDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownDisableNewsletterPopupArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownDiscountCodeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownFullClickArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownHideCountDownArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownHidePdpCountdownArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownHidePromoCodeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownHideStageCountdownArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownNewsletterTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownPdpCategoryArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownPdpTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleCountDown) */
export type BanderoleCountDownPromoTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BanderoleCountDownCollection = {
  __typename?: 'BanderoleCountDownCollection';
  items: Array<Maybe<BanderoleCountDown>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BanderoleCountDownFilter = {
  AND?: InputMaybe<Array<InputMaybe<BanderoleCountDownFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BanderoleCountDownFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countDownDate?: InputMaybe<Scalars['DateTime']>;
  countDownDate_exists?: InputMaybe<Scalars['Boolean']>;
  countDownDate_gt?: InputMaybe<Scalars['DateTime']>;
  countDownDate_gte?: InputMaybe<Scalars['DateTime']>;
  countDownDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  countDownDate_lt?: InputMaybe<Scalars['DateTime']>;
  countDownDate_lte?: InputMaybe<Scalars['DateTime']>;
  countDownDate_not?: InputMaybe<Scalars['DateTime']>;
  countDownDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  disableNewsletterPopup?: InputMaybe<Scalars['Boolean']>;
  disableNewsletterPopup_exists?: InputMaybe<Scalars['Boolean']>;
  disableNewsletterPopup_not?: InputMaybe<Scalars['Boolean']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountCode_contains?: InputMaybe<Scalars['String']>;
  discountCode_exists?: InputMaybe<Scalars['Boolean']>;
  discountCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discountCode_not?: InputMaybe<Scalars['String']>;
  discountCode_not_contains?: InputMaybe<Scalars['String']>;
  discountCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullClick?: InputMaybe<Scalars['String']>;
  fullClick_contains?: InputMaybe<Scalars['String']>;
  fullClick_exists?: InputMaybe<Scalars['Boolean']>;
  fullClick_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullClick_not?: InputMaybe<Scalars['String']>;
  fullClick_not_contains?: InputMaybe<Scalars['String']>;
  fullClick_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hideCountDown?: InputMaybe<Scalars['Boolean']>;
  hideCountDown_exists?: InputMaybe<Scalars['Boolean']>;
  hideCountDown_not?: InputMaybe<Scalars['Boolean']>;
  hidePdpCountdown?: InputMaybe<Scalars['Boolean']>;
  hidePdpCountdown_exists?: InputMaybe<Scalars['Boolean']>;
  hidePdpCountdown_not?: InputMaybe<Scalars['Boolean']>;
  hidePromoCode?: InputMaybe<Scalars['Boolean']>;
  hidePromoCode_exists?: InputMaybe<Scalars['Boolean']>;
  hidePromoCode_not?: InputMaybe<Scalars['Boolean']>;
  hideStageCountdown?: InputMaybe<Scalars['Boolean']>;
  hideStageCountdown_exists?: InputMaybe<Scalars['Boolean']>;
  hideStageCountdown_not?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText?: InputMaybe<Scalars['String']>;
  newsletterText_contains?: InputMaybe<Scalars['String']>;
  newsletterText_exists?: InputMaybe<Scalars['Boolean']>;
  newsletterText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText_not?: InputMaybe<Scalars['String']>;
  newsletterText_not_contains?: InputMaybe<Scalars['String']>;
  newsletterText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpCategory?: InputMaybe<Scalars['String']>;
  pdpCategory_contains?: InputMaybe<Scalars['String']>;
  pdpCategory_exists?: InputMaybe<Scalars['Boolean']>;
  pdpCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpCategory_not?: InputMaybe<Scalars['String']>;
  pdpCategory_not_contains?: InputMaybe<Scalars['String']>;
  pdpCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpText?: InputMaybe<Scalars['String']>;
  pdpText_contains?: InputMaybe<Scalars['String']>;
  pdpText_exists?: InputMaybe<Scalars['Boolean']>;
  pdpText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpText_not?: InputMaybe<Scalars['String']>;
  pdpText_not_contains?: InputMaybe<Scalars['String']>;
  pdpText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  promoText?: InputMaybe<Scalars['String']>;
  promoText_contains?: InputMaybe<Scalars['String']>;
  promoText_exists?: InputMaybe<Scalars['Boolean']>;
  promoText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  promoText_not?: InputMaybe<Scalars['String']>;
  promoText_not_contains?: InputMaybe<Scalars['String']>;
  promoText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BanderoleCountDownLinkingCollections = {
  __typename?: 'BanderoleCountDownLinkingCollections';
  banderoleCollection?: Maybe<BanderoleCollection>;
  entryCollection?: Maybe<EntryCollection>;
  stageCollection?: Maybe<StageCollection>;
};


export type BanderoleCountDownLinkingCollectionsBanderoleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleCountDownLinkingCollectionsBanderoleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BanderoleCountDownLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BanderoleCountDownLinkingCollectionsStageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleCountDownLinkingCollectionsStageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BanderoleCountDownLinkingCollectionsBanderoleCollectionOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  StickyAsc = 'sticky_ASC',
  StickyDesc = 'sticky_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC'
}

export enum BanderoleCountDownLinkingCollectionsStageCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HalfWidthTextAsc = 'halfWidthText_ASC',
  HalfWidthTextDesc = 'halfWidthText_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  IsFramedAsc = 'isFramed_ASC',
  IsFramedDesc = 'isFramed_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MiniHeadlineAsc = 'miniHeadline_ASC',
  MiniHeadlineDesc = 'miniHeadline_DESC',
  MobileAlignmentAsc = 'mobileAlignment_ASC',
  MobileAlignmentDesc = 'mobileAlignment_DESC',
  NewStageAsc = 'newStage_ASC',
  NewStageDesc = 'newStage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum BanderoleCountDownOrder {
  CountDownDateAsc = 'countDownDate_ASC',
  CountDownDateDesc = 'countDownDate_DESC',
  DisableNewsletterPopupAsc = 'disableNewsletterPopup_ASC',
  DisableNewsletterPopupDesc = 'disableNewsletterPopup_DESC',
  DiscountCodeAsc = 'discountCode_ASC',
  DiscountCodeDesc = 'discountCode_DESC',
  FullClickAsc = 'fullClick_ASC',
  FullClickDesc = 'fullClick_DESC',
  HideCountDownAsc = 'hideCountDown_ASC',
  HideCountDownDesc = 'hideCountDown_DESC',
  HidePdpCountdownAsc = 'hidePdpCountdown_ASC',
  HidePdpCountdownDesc = 'hidePdpCountdown_DESC',
  HidePromoCodeAsc = 'hidePromoCode_ASC',
  HidePromoCodeDesc = 'hidePromoCode_DESC',
  HideStageCountdownAsc = 'hideStageCountdown_ASC',
  HideStageCountdownDesc = 'hideStageCountdown_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  NewsletterTextAsc = 'newsletterText_ASC',
  NewsletterTextDesc = 'newsletterText_DESC',
  PdpCategoryAsc = 'pdpCategory_ASC',
  PdpCategoryDesc = 'pdpCategory_DESC',
  PdpTextAsc = 'pdpText_ASC',
  PdpTextDesc = 'pdpText_DESC',
  PromoTextAsc = 'promoText_ASC',
  PromoTextDesc = 'promoText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BanderoleFilter = {
  AND?: InputMaybe<Array<InputMaybe<BanderoleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BanderoleFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countDown?: InputMaybe<CfBanderoleCountDownNestedFilter>;
  countDown_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  sticky_exists?: InputMaybe<Scalars['Boolean']>;
  sticky_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleItem) */
export type BanderoleItem = Entry & _Node & {
  __typename?: 'BanderoleItem';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  link?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BanderoleItemLinkingCollections>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleItem) */
export type BanderoleItemLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleItem) */
export type BanderoleItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleItem) */
export type BanderoleItemTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BanderoleItemCollection = {
  __typename?: 'BanderoleItemCollection';
  items: Array<Maybe<BanderoleItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BanderoleItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<BanderoleItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BanderoleItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  link?: InputMaybe<Scalars['String']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BanderoleItemLinkingCollections = {
  __typename?: 'BanderoleItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BanderoleItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BanderoleItemOrder {
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export type BanderoleLinkingCollections = {
  __typename?: 'BanderoleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type BanderoleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BanderoleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BanderoleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletter = Entry & _Node & {
  __typename?: 'BanderoleNesletter';
  _id: Scalars['ID'];
  activeNewsletterBlockId?: Maybe<Scalars['String']>;
  banderoleNewsletterImage?: Maybe<Asset>;
  banderoleNewsletterTitle?: Maybe<Scalars['String']>;
  banderolePopupCloseIconColor?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BanderoleNesletterLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletterActiveNewsletterBlockIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletterBanderoleNewsletterImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletterBanderoleNewsletterTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletterBanderolePopupCloseIconColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletterInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/banderoleNesletter) */
export type BanderoleNesletterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BanderoleNesletterCollection = {
  __typename?: 'BanderoleNesletterCollection';
  items: Array<Maybe<BanderoleNesletter>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BanderoleNesletterFilter = {
  AND?: InputMaybe<Array<InputMaybe<BanderoleNesletterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BanderoleNesletterFilter>>>;
  activeNewsletterBlockId?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_contains?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_exists?: InputMaybe<Scalars['Boolean']>;
  activeNewsletterBlockId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  activeNewsletterBlockId_not?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_not_contains?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderoleNewsletterImage_exists?: InputMaybe<Scalars['Boolean']>;
  banderoleNewsletterTitle?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_contains?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_exists?: InputMaybe<Scalars['Boolean']>;
  banderoleNewsletterTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderoleNewsletterTitle_not?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_not_contains?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderolePopupCloseIconColor?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_contains?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_exists?: InputMaybe<Scalars['Boolean']>;
  banderolePopupCloseIconColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderolePopupCloseIconColor_not?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_not_contains?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BanderoleNesletterLinkingCollections = {
  __typename?: 'BanderoleNesletterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type BanderoleNesletterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BanderoleNesletterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleNesletterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BanderoleNesletterLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BanderoleNesletterOrder {
  ActiveNewsletterBlockIdAsc = 'activeNewsletterBlockId_ASC',
  ActiveNewsletterBlockIdDesc = 'activeNewsletterBlockId_DESC',
  BanderoleNewsletterTitleAsc = 'banderoleNewsletterTitle_ASC',
  BanderoleNewsletterTitleDesc = 'banderoleNewsletterTitle_DESC',
  BanderolePopupCloseIconColorAsc = 'banderolePopupCloseIconColor_ASC',
  BanderolePopupCloseIconColorDesc = 'banderolePopupCloseIconColor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum BanderoleOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  StickyAsc = 'sticky_ASC',
  StickyDesc = 'sticky_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModule = Entry & _Node & {
  __typename?: 'BlackfridayNewsletterModule';
  _id: Scalars['ID'];
  bynderDesktopBackground?: Maybe<Scalars['JSON']>;
  bynderMobileBackground?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  ctaButton?: Maybe<Scalars['String']>;
  desktopBackground?: Maybe<Asset>;
  disclaimerOne?: Maybe<BlackfridayNewsletterModuleDisclaimerOne>;
  disclaimerTwo?: Maybe<BlackfridayNewsletterModuleDisclaimerTwo>;
  emailPlaceholder?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imageHeadline?: Maybe<Scalars['String']>;
  imageSubline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BlackfridayNewsletterModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  mobileBackground?: Maybe<Asset>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
  textDirection?: Maybe<Scalars['Boolean']>;
  theme?: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleBynderDesktopBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleBynderMobileBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleCtaButtonArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleDesktopBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleDisclaimerOneArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleDisclaimerTwoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleEmailPlaceholderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleImageHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleImageSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleMobileBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleTextDirectionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blackfridayNewsletterModule) */
export type BlackfridayNewsletterModuleThemeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BlackfridayNewsletterModuleCollection = {
  __typename?: 'BlackfridayNewsletterModuleCollection';
  items: Array<Maybe<BlackfridayNewsletterModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlackfridayNewsletterModuleDisclaimerOne = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOne';
  json: Scalars['JSON'];
  links: BlackfridayNewsletterModuleDisclaimerOneLinks;
};

export type BlackfridayNewsletterModuleDisclaimerOneAssets = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlackfridayNewsletterModuleDisclaimerOneEntries = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlackfridayNewsletterModuleDisclaimerOneLinks = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneLinks';
  assets: BlackfridayNewsletterModuleDisclaimerOneAssets;
  entries: BlackfridayNewsletterModuleDisclaimerOneEntries;
  resources: BlackfridayNewsletterModuleDisclaimerOneResources;
};

export type BlackfridayNewsletterModuleDisclaimerOneResources = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneResources';
  block: Array<BlackfridayNewsletterModuleDisclaimerOneResourcesBlock>;
  hyperlink: Array<BlackfridayNewsletterModuleDisclaimerOneResourcesHyperlink>;
  inline: Array<BlackfridayNewsletterModuleDisclaimerOneResourcesInline>;
};

export type BlackfridayNewsletterModuleDisclaimerOneResourcesBlock = ResourceLink & {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneResourcesBlock';
  sys: ResourceSys;
};

export type BlackfridayNewsletterModuleDisclaimerOneResourcesHyperlink = ResourceLink & {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneResourcesHyperlink';
  sys: ResourceSys;
};

export type BlackfridayNewsletterModuleDisclaimerOneResourcesInline = ResourceLink & {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerOneResourcesInline';
  sys: ResourceSys;
};

export type BlackfridayNewsletterModuleDisclaimerTwo = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwo';
  json: Scalars['JSON'];
  links: BlackfridayNewsletterModuleDisclaimerTwoLinks;
};

export type BlackfridayNewsletterModuleDisclaimerTwoAssets = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type BlackfridayNewsletterModuleDisclaimerTwoEntries = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type BlackfridayNewsletterModuleDisclaimerTwoLinks = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoLinks';
  assets: BlackfridayNewsletterModuleDisclaimerTwoAssets;
  entries: BlackfridayNewsletterModuleDisclaimerTwoEntries;
  resources: BlackfridayNewsletterModuleDisclaimerTwoResources;
};

export type BlackfridayNewsletterModuleDisclaimerTwoResources = {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoResources';
  block: Array<BlackfridayNewsletterModuleDisclaimerTwoResourcesBlock>;
  hyperlink: Array<BlackfridayNewsletterModuleDisclaimerTwoResourcesHyperlink>;
  inline: Array<BlackfridayNewsletterModuleDisclaimerTwoResourcesInline>;
};

export type BlackfridayNewsletterModuleDisclaimerTwoResourcesBlock = ResourceLink & {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoResourcesBlock';
  sys: ResourceSys;
};

export type BlackfridayNewsletterModuleDisclaimerTwoResourcesHyperlink = ResourceLink & {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoResourcesHyperlink';
  sys: ResourceSys;
};

export type BlackfridayNewsletterModuleDisclaimerTwoResourcesInline = ResourceLink & {
  __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoResourcesInline';
  sys: ResourceSys;
};

export type BlackfridayNewsletterModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlackfridayNewsletterModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlackfridayNewsletterModuleFilter>>>;
  bynderDesktopBackground_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileBackground_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaButton?: InputMaybe<Scalars['String']>;
  ctaButton_contains?: InputMaybe<Scalars['String']>;
  ctaButton_exists?: InputMaybe<Scalars['Boolean']>;
  ctaButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaButton_not?: InputMaybe<Scalars['String']>;
  ctaButton_not_contains?: InputMaybe<Scalars['String']>;
  ctaButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  desktopBackground_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerOne_contains?: InputMaybe<Scalars['String']>;
  disclaimerOne_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerOne_not_contains?: InputMaybe<Scalars['String']>;
  disclaimerTwo_contains?: InputMaybe<Scalars['String']>;
  disclaimerTwo_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerTwo_not_contains?: InputMaybe<Scalars['String']>;
  emailPlaceholder?: InputMaybe<Scalars['String']>;
  emailPlaceholder_contains?: InputMaybe<Scalars['String']>;
  emailPlaceholder_exists?: InputMaybe<Scalars['Boolean']>;
  emailPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPlaceholder_not?: InputMaybe<Scalars['String']>;
  emailPlaceholder_not_contains?: InputMaybe<Scalars['String']>;
  emailPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageHeadline?: InputMaybe<Scalars['String']>;
  imageHeadline_contains?: InputMaybe<Scalars['String']>;
  imageHeadline_exists?: InputMaybe<Scalars['Boolean']>;
  imageHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageHeadline_not?: InputMaybe<Scalars['String']>;
  imageHeadline_not_contains?: InputMaybe<Scalars['String']>;
  imageHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageSubline?: InputMaybe<Scalars['String']>;
  imageSubline_contains?: InputMaybe<Scalars['String']>;
  imageSubline_exists?: InputMaybe<Scalars['Boolean']>;
  imageSubline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageSubline_not?: InputMaybe<Scalars['String']>;
  imageSubline_not_contains?: InputMaybe<Scalars['String']>;
  imageSubline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileBackground_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  textDirection?: InputMaybe<Scalars['Boolean']>;
  textDirection_exists?: InputMaybe<Scalars['Boolean']>;
  textDirection_not?: InputMaybe<Scalars['Boolean']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme?: InputMaybe<Scalars['Boolean']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_not?: InputMaybe<Scalars['Boolean']>;
};

export type BlackfridayNewsletterModuleLinkingCollections = {
  __typename?: 'BlackfridayNewsletterModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type BlackfridayNewsletterModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlackfridayNewsletterModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlackfridayNewsletterModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BlackfridayNewsletterModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlackfridayNewsletterModuleOrder {
  CtaButtonAsc = 'ctaButton_ASC',
  CtaButtonDesc = 'ctaButton_DESC',
  EmailPlaceholderAsc = 'emailPlaceholder_ASC',
  EmailPlaceholderDesc = 'emailPlaceholder_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageHeadlineAsc = 'imageHeadline_ASC',
  ImageHeadlineDesc = 'imageHeadline_DESC',
  ImageSublineAsc = 'imageSubline_ASC',
  ImageSublineDesc = 'imageSubline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextDirectionAsc = 'textDirection_ASC',
  TextDirectionDesc = 'textDirection_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogCategory) */
export type BlogCategory = Entry & _Node & {
  __typename?: 'BlogCategory';
  _id: Scalars['ID'];
  categoryName?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BlogCategoryLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogCategory) */
export type BlogCategoryCategoryNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogCategory) */
export type BlogCategoryInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogCategory) */
export type BlogCategoryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlogCategoryCollection = {
  __typename?: 'BlogCategoryCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlogCategoryFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogCategoryFilter>>>;
  categoryName?: InputMaybe<Scalars['String']>;
  categoryName_contains?: InputMaybe<Scalars['String']>;
  categoryName_exists?: InputMaybe<Scalars['Boolean']>;
  categoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryName_not?: InputMaybe<Scalars['String']>;
  categoryName_not_contains?: InputMaybe<Scalars['String']>;
  categoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BlogCategoryLinkingCollections = {
  __typename?: 'BlogCategoryLinkingCollections';
  blogOverviewModuleCollection?: Maybe<BlogOverviewModuleCollection>;
  blogTeaserItemCollection?: Maybe<BlogTeaserItemCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type BlogCategoryLinkingCollectionsBlogOverviewModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogOverviewModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlogCategoryLinkingCollectionsBlogTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsBlogTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlogCategoryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlogCategoryLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BlogCategoryLinkingCollectionsBlogOverviewModuleCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export enum BlogCategoryLinkingCollectionsBlogTeaserItemCollectionOrder {
  BackgroundGradientAsc = 'backgroundGradient_ASC',
  BackgroundGradientDesc = 'backgroundGradient_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum BlogCategoryLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogCategoryOrder {
  CategoryNameAsc = 'categoryName_ASC',
  CategoryNameDesc = 'categoryName_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogContent) */
export type BlogContent = Entry & _Node & {
  __typename?: 'BlogContent';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BlogContentLinkingCollections>;
  sys: Sys;
  text?: Maybe<Rte>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogContent) */
export type BlogContentHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogContent) */
export type BlogContentInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogContent) */
export type BlogContentLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogContent) */
export type BlogContentTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<RteFilter>;
};

export type BlogContentCollection = {
  __typename?: 'BlogContentCollection';
  items: Array<Maybe<BlogContent>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlogContentFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogContentFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogContentFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<CfRteNestedFilter>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
};

export type BlogContentLinkingCollections = {
  __typename?: 'BlogContentLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type BlogContentLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlogContentLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogContentLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BlogContentLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogContentOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModule = Entry & _Node & {
  __typename?: 'BlogOverviewModule';
  _id: Scalars['ID'];
  categorysCollection?: Maybe<BlogOverviewModuleCategorysCollection>;
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BlogOverviewModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
  titleIntern?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModuleCategorysCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogOverviewModuleCategorysCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogOverviewModule) */
export type BlogOverviewModuleTitleInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BlogOverviewModuleCategorysCollection = {
  __typename?: 'BlogOverviewModuleCategorysCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum BlogOverviewModuleCategorysCollectionOrder {
  CategoryNameAsc = 'categoryName_ASC',
  CategoryNameDesc = 'categoryName_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlogOverviewModuleCollection = {
  __typename?: 'BlogOverviewModuleCollection';
  items: Array<Maybe<BlogOverviewModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlogOverviewModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogOverviewModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogOverviewModuleFilter>>>;
  categorys?: InputMaybe<CfBlogCategoryNestedFilter>;
  categorysCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlogOverviewModuleLinkingCollections = {
  __typename?: 'BlogOverviewModuleLinkingCollections';
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type BlogOverviewModuleLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogOverviewModuleLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlogOverviewModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type BlogOverviewModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogOverviewModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BlogOverviewModuleLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogOverviewModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BlogOverviewModuleOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItem = Entry & _Node & {
  __typename?: 'BlogTeaserItem';
  _id: Scalars['ID'];
  backgroundGradient?: Maybe<Scalars['Boolean']>;
  backgroundImage?: Maybe<Asset>;
  backgroundImageMobile?: Maybe<Asset>;
  blogCategoriesCollection?: Maybe<BlogTeaserItemBlogCategoriesCollection>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  darkText?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
  imageFocus?: Maybe<Scalars['String']>;
  imageFocusMobile?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<BlogTeaserItemLinkingCollections>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemBackgroundGradientArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemBackgroundImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemBackgroundImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemBlogCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogTeaserItemBlogCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemDarkTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemImageFocusMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/blogTeaserItem) */
export type BlogTeaserItemTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type BlogTeaserItemBlogCategoriesCollection = {
  __typename?: 'BlogTeaserItemBlogCategoriesCollection';
  items: Array<Maybe<BlogCategory>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum BlogTeaserItemBlogCategoriesCollectionOrder {
  CategoryNameAsc = 'categoryName_ASC',
  CategoryNameDesc = 'categoryName_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type BlogTeaserItemCollection = {
  __typename?: 'BlogTeaserItemCollection';
  items: Array<Maybe<BlogTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type BlogTeaserItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogTeaserItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogTeaserItemFilter>>>;
  backgroundGradient?: InputMaybe<Scalars['Boolean']>;
  backgroundGradient_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundGradient_not?: InputMaybe<Scalars['Boolean']>;
  backgroundImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundImage_exists?: InputMaybe<Scalars['Boolean']>;
  blogCategories?: InputMaybe<CfBlogCategoryNestedFilter>;
  blogCategoriesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  darkText?: InputMaybe<Scalars['Boolean']>;
  darkText_exists?: InputMaybe<Scalars['Boolean']>;
  darkText_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocusMobile?: InputMaybe<Scalars['String']>;
  imageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  imageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocusMobile_not?: InputMaybe<Scalars['String']>;
  imageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  imageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BlogTeaserItemLinkingCollections = {
  __typename?: 'BlogTeaserItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BlogTeaserItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum BlogTeaserItemOrder {
  BackgroundGradientAsc = 'backgroundGradient_ASC',
  BackgroundGradientDesc = 'backgroundGradient_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModule = Entry & _Node & {
  __typename?: 'CategorySliderModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']>;
  itemsCollection?: Maybe<CategorySliderModuleItemsCollection>;
  linkedFrom?: Maybe<CategorySliderModuleLinkingCollections>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModuleItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CategorySliderModuleItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategorySliderModuleItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModuleSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModuleSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModule) */
export type CategorySliderModuleTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CategorySliderModuleCollection = {
  __typename?: 'CategorySliderModuleCollection';
  items: Array<Maybe<CategorySliderModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CategorySliderModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategorySliderModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategorySliderModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  items?: InputMaybe<CfCategorySliderModuleItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItem = Entry & _Node & {
  __typename?: 'CategorySliderModuleItem';
  _id: Scalars['ID'];
  bynderImage?: Maybe<Scalars['JSON']>;
  bynderMobileImage?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  link?: Maybe<Scalars['String']>;
  linkExistingPage?: Maybe<Page>;
  linkedFrom?: Maybe<CategorySliderModuleItemLinkingCollections>;
  mobileImage?: Maybe<Asset>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemBynderMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemLinkExistingPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/categorySliderModuleItem) */
export type CategorySliderModuleItemTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CategorySliderModuleItemCollection = {
  __typename?: 'CategorySliderModuleItemCollection';
  items: Array<Maybe<CategorySliderModuleItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CategorySliderModuleItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<CategorySliderModuleItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CategorySliderModuleItemFilter>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  linkExistingPage?: InputMaybe<CfPageNestedFilter>;
  linkExistingPage_exists?: InputMaybe<Scalars['Boolean']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CategorySliderModuleItemLinkingCollections = {
  __typename?: 'CategorySliderModuleItemLinkingCollections';
  categorySliderModuleCollection?: Maybe<CategorySliderModuleCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CategorySliderModuleItemLinkingCollectionsCategorySliderModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CategorySliderModuleItemLinkingCollectionsCategorySliderModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CategorySliderModuleItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CategorySliderModuleItemLinkingCollectionsCategorySliderModuleCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CategorySliderModuleItemOrder {
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CategorySliderModuleItemsCollection = {
  __typename?: 'CategorySliderModuleItemsCollection';
  items: Array<Maybe<CategorySliderModuleItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CategorySliderModuleItemsCollectionOrder {
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CategorySliderModuleLinkingCollections = {
  __typename?: 'CategorySliderModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type CategorySliderModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CategorySliderModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CategorySliderModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CategorySliderModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CategorySliderModuleOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** The main navigation for the corporate website. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigation) */
export type CorporateNavigation = Entry & _Node & {
  __typename?: 'CorporateNavigation';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  firstLevelItemsCollection?: Maybe<CorporateNavigationFirstLevelItemsCollection>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CorporateNavigationLinkingCollections>;
  sys: Sys;
  teaser?: Maybe<TeaserItem>;
  titleInternal?: Maybe<Scalars['String']>;
};


/** The main navigation for the corporate website. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigation) */
export type CorporateNavigationFirstLevelItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationFirstLevelItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CorporateNavigationListElementFilter>;
};


/** The main navigation for the corporate website. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigation) */
export type CorporateNavigationInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** The main navigation for the corporate website. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigation) */
export type CorporateNavigationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The main navigation for the corporate website. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigation) */
export type CorporateNavigationTeaserArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** The main navigation for the corporate website. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigation) */
export type CorporateNavigationTitleInternalArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CorporateNavigationCollection = {
  __typename?: 'CorporateNavigationCollection';
  items: Array<Maybe<CorporateNavigation>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CorporateNavigationFilter = {
  AND?: InputMaybe<Array<InputMaybe<CorporateNavigationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateNavigationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstLevelItems?: InputMaybe<CfCorporateNavigationListElementNestedFilter>;
  firstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  teaser?: InputMaybe<CfTeaserItemNestedFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CorporateNavigationFirstLevelItemsCollection = {
  __typename?: 'CorporateNavigationFirstLevelItemsCollection';
  items: Array<Maybe<CorporateNavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CorporateNavigationFirstLevelItemsCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CorporateNavigationLinkingCollections = {
  __typename?: 'CorporateNavigationLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CorporateNavigationLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CorporateNavigationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CorporateNavigationLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElement = Entry & _Node & {
  __typename?: 'CorporateNavigationListElement';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CorporateNavigationListElementLinkingCollections>;
  navigationListItemsCollection?: Maybe<CorporateNavigationListElementNavigationListItemsCollection>;
  pageContent?: Maybe<CorporatePage>;
  sys: Sys;
  teaser?: Maybe<TeaserItem>;
  textColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementNavigationListItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationListElementNavigationListItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CorporateNavigationListElementFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementPageContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CorporatePageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementTeaserArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementTextColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporateNavigationListElement) */
export type CorporateNavigationListElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CorporateNavigationListElementCollection = {
  __typename?: 'CorporateNavigationListElementCollection';
  items: Array<Maybe<CorporateNavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CorporateNavigationListElementFilter = {
  AND?: InputMaybe<Array<InputMaybe<CorporateNavigationListElementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporateNavigationListElementFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  navigationListItems?: InputMaybe<CfCorporateNavigationListElementNestedFilter>;
  navigationListItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  pageContent?: InputMaybe<CfCorporatePageNestedFilter>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  teaser?: InputMaybe<CfTeaserItemNestedFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CorporateNavigationListElementLinkingCollections = {
  __typename?: 'CorporateNavigationListElementLinkingCollections';
  corporateNavigationCollection?: Maybe<CorporateNavigationCollection>;
  corporateNavigationListElementCollection?: Maybe<CorporateNavigationListElementCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CorporateNavigationListElementLinkingCollectionsCorporateNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationListElementLinkingCollectionsCorporateNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CorporateNavigationListElementLinkingCollectionsCorporateNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationListElementLinkingCollectionsCorporateNavigationListElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CorporateNavigationListElementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CorporateNavigationListElementLinkingCollectionsCorporateNavigationCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export enum CorporateNavigationListElementLinkingCollectionsCorporateNavigationListElementCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CorporateNavigationListElementNavigationListItemsCollection = {
  __typename?: 'CorporateNavigationListElementNavigationListItemsCollection';
  items: Array<Maybe<CorporateNavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CorporateNavigationListElementNavigationListItemsCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CorporateNavigationListElementOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CorporateNavigationOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePage = Entry & _Node & {
  __typename?: 'CorporatePage';
  _id: Scalars['ID'];
  contentModulesCollection?: Maybe<CorporatePageContentModulesCollection>;
  contentfulMetadata: ContentfulMetadata;
  footerColumns?: Maybe<CorporateNavigation>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CorporatePageLinkingCollections>;
  mainNavigation?: Maybe<CorporateNavigation>;
  meta?: Maybe<Seo>;
  slug?: Maybe<Scalars['String']>;
  stage?: Maybe<Stage>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageContentModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CorporatePageContentModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageFooterColumnsArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CorporateNavigationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageMainNavigationArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CorporateNavigationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageMetaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SeoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageStageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<StageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/corporatePage) */
export type CorporatePageTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CorporatePageCollection = {
  __typename?: 'CorporatePageCollection';
  items: Array<Maybe<CorporatePage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CorporatePageContentModulesCollection = {
  __typename?: 'CorporatePageContentModulesCollection';
  items: Array<Maybe<CorporatePageContentModulesItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CorporatePageContentModulesFilter = {
  AND?: InputMaybe<Array<InputMaybe<CorporatePageContentModulesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporatePageContentModulesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type CorporatePageContentModulesItem = Accordion | CounterModule | EditorialGallery | ImageModule | InstagramModule | JavascriptModule | LogoGrid | MultiTeaser | NewsletterModule | Quote | Stage | TeaserModule | TextImageTeaser | TextTeaser | Video;

export type CorporatePageFilter = {
  AND?: InputMaybe<Array<InputMaybe<CorporatePageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CorporatePageFilter>>>;
  contentModules?: InputMaybe<CfcontentModulesMultiTypeNestedFilter>;
  contentModulesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  footerColumns?: InputMaybe<CfCorporateNavigationNestedFilter>;
  footerColumns_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainNavigation?: InputMaybe<CfCorporateNavigationNestedFilter>;
  mainNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<CfSeoNestedFilter>;
  meta_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stage?: InputMaybe<CfStageNestedFilter>;
  stage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CorporatePageLinkingCollections = {
  __typename?: 'CorporatePageLinkingCollections';
  corporateNavigationListElementCollection?: Maybe<CorporateNavigationListElementCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CorporatePageLinkingCollectionsCorporateNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporatePageLinkingCollectionsCorporateNavigationListElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CorporatePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CorporatePageLinkingCollectionsCorporateNavigationListElementCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CorporatePageOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterElement) */
export type CounterElement = Entry & _Node & {
  __typename?: 'CounterElement';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CounterElementLinkingCollections>;
  numberCounter?: Maybe<Scalars['Int']>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterElement) */
export type CounterElementHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterElement) */
export type CounterElementInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterElement) */
export type CounterElementLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterElement) */
export type CounterElementNumberCounterArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterElement) */
export type CounterElementTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CounterElementCollection = {
  __typename?: 'CounterElementCollection';
  items: Array<Maybe<CounterElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CounterElementFilter = {
  AND?: InputMaybe<Array<InputMaybe<CounterElementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CounterElementFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  numberCounter?: InputMaybe<Scalars['Int']>;
  numberCounter_exists?: InputMaybe<Scalars['Boolean']>;
  numberCounter_gt?: InputMaybe<Scalars['Int']>;
  numberCounter_gte?: InputMaybe<Scalars['Int']>;
  numberCounter_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  numberCounter_lt?: InputMaybe<Scalars['Int']>;
  numberCounter_lte?: InputMaybe<Scalars['Int']>;
  numberCounter_not?: InputMaybe<Scalars['Int']>;
  numberCounter_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CounterElementLinkingCollections = {
  __typename?: 'CounterElementLinkingCollections';
  counterModuleCollection?: Maybe<CounterModuleCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CounterElementLinkingCollectionsCounterModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CounterElementLinkingCollectionsCounterModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CounterElementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CounterElementLinkingCollectionsCounterModuleCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CounterElementOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  NumberCounterAsc = 'numberCounter_ASC',
  NumberCounterDesc = 'numberCounter_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** Module for 2-8 counter items consisting of counter number, headline, text [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterModule) */
export type CounterModule = Entry & _Node & {
  __typename?: 'CounterModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  countersCollection?: Maybe<CounterModuleCountersCollection>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CounterModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Module for 2-8 counter items consisting of counter number, headline, text [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterModule) */
export type CounterModuleCountersCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CounterModuleCountersCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CounterElementFilter>;
};


/** Module for 2-8 counter items consisting of counter number, headline, text [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterModule) */
export type CounterModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module for 2-8 counter items consisting of counter number, headline, text [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterModule) */
export type CounterModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Module for 2-8 counter items consisting of counter number, headline, text [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterModule) */
export type CounterModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module for 2-8 counter items consisting of counter number, headline, text [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/counterModule) */
export type CounterModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CounterModuleCollection = {
  __typename?: 'CounterModuleCollection';
  items: Array<Maybe<CounterModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CounterModuleCountersCollection = {
  __typename?: 'CounterModuleCountersCollection';
  items: Array<Maybe<CounterElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum CounterModuleCountersCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  NumberCounterAsc = 'numberCounter_ASC',
  NumberCounterDesc = 'numberCounter_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export type CounterModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<CounterModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CounterModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  counters?: InputMaybe<CfCounterElementNestedFilter>;
  countersCollection_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CounterModuleLinkingCollections = {
  __typename?: 'CounterModuleLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type CounterModuleLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CounterModuleLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CounterModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CounterModuleLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CounterModuleOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type Cta = Entry & _Node & {
  __typename?: 'Cta';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  ctaStyle?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  eMailLink?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkExistingPage?: Maybe<Page>;
  linkExternalPage?: Maybe<Scalars['String']>;
  linkInternalUrl?: Maybe<Scalars['String']>;
  linkToEntry?: Maybe<CtaLinkToEntry>;
  linkedFrom?: Maybe<CtaLinkingCollections>;
  newCtaStyle?: Maybe<Scalars['String']>;
  phoneLink?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaCtaStyleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaCtaTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaEMailLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaLinkExistingPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaLinkExternalPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaLinkInternalUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaLinkToEntryArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaNewCtaStyleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaPhoneLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/cta) */
export type CtaTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CtaCollection = {
  __typename?: 'CtaCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CtaFilter = {
  AND?: InputMaybe<Array<InputMaybe<CtaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CtaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaStyle?: InputMaybe<Scalars['String']>;
  ctaStyle_contains?: InputMaybe<Scalars['String']>;
  ctaStyle_exists?: InputMaybe<Scalars['Boolean']>;
  ctaStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaStyle_not?: InputMaybe<Scalars['String']>;
  ctaStyle_not_contains?: InputMaybe<Scalars['String']>;
  ctaStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaText?: InputMaybe<Scalars['String']>;
  ctaText_contains?: InputMaybe<Scalars['String']>;
  ctaText_exists?: InputMaybe<Scalars['Boolean']>;
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaText_not?: InputMaybe<Scalars['String']>;
  ctaText_not_contains?: InputMaybe<Scalars['String']>;
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailLink?: InputMaybe<Scalars['String']>;
  eMailLink_contains?: InputMaybe<Scalars['String']>;
  eMailLink_exists?: InputMaybe<Scalars['Boolean']>;
  eMailLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailLink_not?: InputMaybe<Scalars['String']>;
  eMailLink_not_contains?: InputMaybe<Scalars['String']>;
  eMailLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkExistingPage?: InputMaybe<CfPageNestedFilter>;
  linkExistingPage_exists?: InputMaybe<Scalars['Boolean']>;
  linkExternalPage?: InputMaybe<Scalars['String']>;
  linkExternalPage_contains?: InputMaybe<Scalars['String']>;
  linkExternalPage_exists?: InputMaybe<Scalars['Boolean']>;
  linkExternalPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkExternalPage_not?: InputMaybe<Scalars['String']>;
  linkExternalPage_not_contains?: InputMaybe<Scalars['String']>;
  linkExternalPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkInternalUrl?: InputMaybe<Scalars['String']>;
  linkInternalUrl_contains?: InputMaybe<Scalars['String']>;
  linkInternalUrl_exists?: InputMaybe<Scalars['Boolean']>;
  linkInternalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkInternalUrl_not?: InputMaybe<Scalars['String']>;
  linkInternalUrl_not_contains?: InputMaybe<Scalars['String']>;
  linkInternalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkToEntry_exists?: InputMaybe<Scalars['Boolean']>;
  newCtaStyle?: InputMaybe<Scalars['String']>;
  newCtaStyle_contains?: InputMaybe<Scalars['String']>;
  newCtaStyle_exists?: InputMaybe<Scalars['Boolean']>;
  newCtaStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newCtaStyle_not?: InputMaybe<Scalars['String']>;
  newCtaStyle_not_contains?: InputMaybe<Scalars['String']>;
  newCtaStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneLink?: InputMaybe<Scalars['String']>;
  phoneLink_contains?: InputMaybe<Scalars['String']>;
  phoneLink_exists?: InputMaybe<Scalars['Boolean']>;
  phoneLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneLink_not?: InputMaybe<Scalars['String']>;
  phoneLink_not_contains?: InputMaybe<Scalars['String']>;
  phoneLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CtaLinkToEntry = Accordion | BlogOverviewModule | EditorialGallery | ImageModule | InstagramModule | NewsletterModule | ProductTeaser | Quote | Rte | ShopTheLook | Stage | TabModule | TeaserModule | TextImageTeaser | TextTeaser | Video;

export type CtaLinkingCollections = {
  __typename?: 'CtaLinkingCollections';
  arPdpBoxCollection?: Maybe<ArPdpBoxCollection>;
  blogTeaserItemCollection?: Maybe<BlogTeaserItemCollection>;
  editorialGalleryCollection?: Maybe<EditorialGalleryCollection>;
  entryCollection?: Maybe<EntryCollection>;
  heroStageItemCollection?: Maybe<HeroStageItemCollection>;
  imageModuleCollection?: Maybe<ImageModuleCollection>;
  instagramModuleCollection?: Maybe<InstagramModuleCollection>;
  multiTeaserItemCollection?: Maybe<MultiTeaserItemCollection>;
  pageCollection?: Maybe<PageCollection>;
  stageCollection?: Maybe<StageCollection>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
  textImageTeaserCollection?: Maybe<TextImageTeaserCollection>;
  textPicTeaserItemCollection?: Maybe<TextPicTeaserItemCollection>;
  textTeaserCollection?: Maybe<TextTeaserCollection>;
};


export type CtaLinkingCollectionsArPdpBoxCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsArPdpBoxCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsBlogTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsBlogTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsEditorialGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsEditorialGalleryCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsHeroStageItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsHeroStageItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsImageModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsImageModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsInstagramModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsInstagramModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsMultiTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsMultiTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsStageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsStageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsTextImageTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsTextImageTeaserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsTextPicTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsTextPicTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CtaLinkingCollectionsTextTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaLinkingCollectionsTextTeaserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CtaLinkingCollectionsArPdpBoxCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum CtaLinkingCollectionsBlogTeaserItemCollectionOrder {
  BackgroundGradientAsc = 'backgroundGradient_ASC',
  BackgroundGradientDesc = 'backgroundGradient_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum CtaLinkingCollectionsEditorialGalleryCollectionOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  BackgroundTextAsc = 'backgroundText_ASC',
  BackgroundTextDesc = 'backgroundText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CtaLinkingCollectionsHeroStageItemCollectionOrder {
  CopyTextAsc = 'copyText_ASC',
  CopyTextDesc = 'copyText_DESC',
  CountdownDateAsc = 'countdownDate_ASC',
  CountdownDateDesc = 'countdownDate_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum CtaLinkingCollectionsImageModuleCollectionOrder {
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CtaLinkingCollectionsInstagramModuleCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CtaLinkingCollectionsMultiTeaserItemCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum CtaLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CtaLinkingCollectionsStageCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HalfWidthTextAsc = 'halfWidthText_ASC',
  HalfWidthTextDesc = 'halfWidthText_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  IsFramedAsc = 'isFramed_ASC',
  IsFramedDesc = 'isFramed_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MiniHeadlineAsc = 'miniHeadline_ASC',
  MiniHeadlineDesc = 'miniHeadline_DESC',
  MobileAlignmentAsc = 'mobileAlignment_ASC',
  MobileAlignmentDesc = 'mobileAlignment_DESC',
  NewStageAsc = 'newStage_ASC',
  NewStageDesc = 'newStage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum CtaLinkingCollectionsTeaserItemCollectionOrder {
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  GradientDirectionAsc = 'gradientDirection_ASC',
  GradientDirectionDesc = 'gradientDirection_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum CtaLinkingCollectionsTextImageTeaserCollectionOrder {
  CenterTextAlignmentAsc = 'centerTextAlignment_ASC',
  CenterTextAlignmentDesc = 'centerTextAlignment_DESC',
  HandleOrganicShapeAsc = 'handleOrganicShape_ASC',
  HandleOrganicShapeDesc = 'handleOrganicShape_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageDesktopLeftAsc = 'imageDesktopLeft_ASC',
  ImageDesktopLeftDesc = 'imageDesktopLeft_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MobileImageBottomAsc = 'mobileImageBottom_ASC',
  MobileImageBottomDesc = 'mobileImageBottom_DESC',
  NoSidePaddingAsc = 'noSidePadding_ASC',
  NoSidePaddingDesc = 'noSidePadding_DESC',
  OrganicShapeColorAsc = 'organicShapeColor_ASC',
  OrganicShapeColorDesc = 'organicShapeColor_DESC',
  SelectShapeViewAsc = 'selectShapeView_ASC',
  SelectShapeViewDesc = 'selectShapeView_DESC',
  SubHeadlineAsc = 'subHeadline_ASC',
  SubHeadlineDesc = 'subHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export enum CtaLinkingCollectionsTextPicTeaserItemCollectionOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  ButtonLinkAsc = 'buttonLink_ASC',
  ButtonLinkDesc = 'buttonLink_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MarginTopAsc = 'marginTop_ASC',
  MarginTopDesc = 'marginTop_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export enum CtaLinkingCollectionsTextTeaserCollectionOrder {
  CenterWithLeftAlignAsc = 'centerWithLeftAlign_ASC',
  CenterWithLeftAlignDesc = 'centerWithLeftAlign_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC',
  TwoColumnLayoutAsc = 'twoColumnLayout_ASC',
  TwoColumnLayoutDesc = 'twoColumnLayout_DESC'
}

export enum CtaOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletter = Entry & _Node & {
  __typename?: 'CustomNewsletter';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  ctaButton?: Maybe<Scalars['String']>;
  desktopBackground?: Maybe<Asset>;
  disclaimerOne?: Maybe<CustomNewsletterDisclaimerOne>;
  disclaimerTwo?: Maybe<CustomNewsletterDisclaimerTwo>;
  emailPlaceholder?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imageHeadline?: Maybe<Scalars['String']>;
  imageSubline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<CustomNewsletterLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  mobileBackground?: Maybe<Asset>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
  textDirection?: Maybe<Scalars['Boolean']>;
  theme?: Maybe<Scalars['Boolean']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterCtaButtonArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterDesktopBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterDisclaimerOneArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterDisclaimerTwoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterEmailPlaceholderArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterImageHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterImageSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterMobileBackgroundArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterTextDirectionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Custom newsletter for Benuta's internal campaigns. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/customNewsletter) */
export type CustomNewsletterThemeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type CustomNewsletterCollection = {
  __typename?: 'CustomNewsletterCollection';
  items: Array<Maybe<CustomNewsletter>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type CustomNewsletterDisclaimerOne = {
  __typename?: 'CustomNewsletterDisclaimerOne';
  json: Scalars['JSON'];
  links: CustomNewsletterDisclaimerOneLinks;
};

export type CustomNewsletterDisclaimerOneAssets = {
  __typename?: 'CustomNewsletterDisclaimerOneAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CustomNewsletterDisclaimerOneEntries = {
  __typename?: 'CustomNewsletterDisclaimerOneEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CustomNewsletterDisclaimerOneLinks = {
  __typename?: 'CustomNewsletterDisclaimerOneLinks';
  assets: CustomNewsletterDisclaimerOneAssets;
  entries: CustomNewsletterDisclaimerOneEntries;
  resources: CustomNewsletterDisclaimerOneResources;
};

export type CustomNewsletterDisclaimerOneResources = {
  __typename?: 'CustomNewsletterDisclaimerOneResources';
  block: Array<CustomNewsletterDisclaimerOneResourcesBlock>;
  hyperlink: Array<CustomNewsletterDisclaimerOneResourcesHyperlink>;
  inline: Array<CustomNewsletterDisclaimerOneResourcesInline>;
};

export type CustomNewsletterDisclaimerOneResourcesBlock = ResourceLink & {
  __typename?: 'CustomNewsletterDisclaimerOneResourcesBlock';
  sys: ResourceSys;
};

export type CustomNewsletterDisclaimerOneResourcesHyperlink = ResourceLink & {
  __typename?: 'CustomNewsletterDisclaimerOneResourcesHyperlink';
  sys: ResourceSys;
};

export type CustomNewsletterDisclaimerOneResourcesInline = ResourceLink & {
  __typename?: 'CustomNewsletterDisclaimerOneResourcesInline';
  sys: ResourceSys;
};

export type CustomNewsletterDisclaimerTwo = {
  __typename?: 'CustomNewsletterDisclaimerTwo';
  json: Scalars['JSON'];
  links: CustomNewsletterDisclaimerTwoLinks;
};

export type CustomNewsletterDisclaimerTwoAssets = {
  __typename?: 'CustomNewsletterDisclaimerTwoAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CustomNewsletterDisclaimerTwoEntries = {
  __typename?: 'CustomNewsletterDisclaimerTwoEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CustomNewsletterDisclaimerTwoLinks = {
  __typename?: 'CustomNewsletterDisclaimerTwoLinks';
  assets: CustomNewsletterDisclaimerTwoAssets;
  entries: CustomNewsletterDisclaimerTwoEntries;
  resources: CustomNewsletterDisclaimerTwoResources;
};

export type CustomNewsletterDisclaimerTwoResources = {
  __typename?: 'CustomNewsletterDisclaimerTwoResources';
  block: Array<CustomNewsletterDisclaimerTwoResourcesBlock>;
  hyperlink: Array<CustomNewsletterDisclaimerTwoResourcesHyperlink>;
  inline: Array<CustomNewsletterDisclaimerTwoResourcesInline>;
};

export type CustomNewsletterDisclaimerTwoResourcesBlock = ResourceLink & {
  __typename?: 'CustomNewsletterDisclaimerTwoResourcesBlock';
  sys: ResourceSys;
};

export type CustomNewsletterDisclaimerTwoResourcesHyperlink = ResourceLink & {
  __typename?: 'CustomNewsletterDisclaimerTwoResourcesHyperlink';
  sys: ResourceSys;
};

export type CustomNewsletterDisclaimerTwoResourcesInline = ResourceLink & {
  __typename?: 'CustomNewsletterDisclaimerTwoResourcesInline';
  sys: ResourceSys;
};

export type CustomNewsletterFilter = {
  AND?: InputMaybe<Array<InputMaybe<CustomNewsletterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CustomNewsletterFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaButton?: InputMaybe<Scalars['String']>;
  ctaButton_contains?: InputMaybe<Scalars['String']>;
  ctaButton_exists?: InputMaybe<Scalars['Boolean']>;
  ctaButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaButton_not?: InputMaybe<Scalars['String']>;
  ctaButton_not_contains?: InputMaybe<Scalars['String']>;
  ctaButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  desktopBackground_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerOne_contains?: InputMaybe<Scalars['String']>;
  disclaimerOne_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerOne_not_contains?: InputMaybe<Scalars['String']>;
  disclaimerTwo_contains?: InputMaybe<Scalars['String']>;
  disclaimerTwo_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerTwo_not_contains?: InputMaybe<Scalars['String']>;
  emailPlaceholder?: InputMaybe<Scalars['String']>;
  emailPlaceholder_contains?: InputMaybe<Scalars['String']>;
  emailPlaceholder_exists?: InputMaybe<Scalars['Boolean']>;
  emailPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailPlaceholder_not?: InputMaybe<Scalars['String']>;
  emailPlaceholder_not_contains?: InputMaybe<Scalars['String']>;
  emailPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageHeadline?: InputMaybe<Scalars['String']>;
  imageHeadline_contains?: InputMaybe<Scalars['String']>;
  imageHeadline_exists?: InputMaybe<Scalars['Boolean']>;
  imageHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageHeadline_not?: InputMaybe<Scalars['String']>;
  imageHeadline_not_contains?: InputMaybe<Scalars['String']>;
  imageHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageSubline?: InputMaybe<Scalars['String']>;
  imageSubline_contains?: InputMaybe<Scalars['String']>;
  imageSubline_exists?: InputMaybe<Scalars['Boolean']>;
  imageSubline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageSubline_not?: InputMaybe<Scalars['String']>;
  imageSubline_not_contains?: InputMaybe<Scalars['String']>;
  imageSubline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileBackground_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  textDirection?: InputMaybe<Scalars['Boolean']>;
  textDirection_exists?: InputMaybe<Scalars['Boolean']>;
  textDirection_not?: InputMaybe<Scalars['Boolean']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme?: InputMaybe<Scalars['Boolean']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_not?: InputMaybe<Scalars['Boolean']>;
};

export type CustomNewsletterLinkingCollections = {
  __typename?: 'CustomNewsletterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type CustomNewsletterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type CustomNewsletterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CustomNewsletterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum CustomNewsletterLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CustomNewsletterOrder {
  CtaButtonAsc = 'ctaButton_ASC',
  CtaButtonDesc = 'ctaButton_DESC',
  EmailPlaceholderAsc = 'emailPlaceholder_ASC',
  EmailPlaceholderDesc = 'emailPlaceholder_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageHeadlineAsc = 'imageHeadline_ASC',
  ImageHeadlineDesc = 'imageHeadline_DESC',
  ImageSublineAsc = 'imageSubline_ASC',
  ImageSublineDesc = 'imageSubline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextDirectionAsc = 'textDirection_ASC',
  TextDirectionDesc = 'textDirection_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/dataLayerMeta) */
export type DataLayerMeta = Entry & _Node & {
  __typename?: 'DataLayerMeta';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  dataLayerMetaContent?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<DataLayerMetaLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/dataLayerMeta) */
export type DataLayerMetaDataLayerMetaContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/dataLayerMeta) */
export type DataLayerMetaLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DataLayerMetaCollection = {
  __typename?: 'DataLayerMetaCollection';
  items: Array<Maybe<DataLayerMeta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type DataLayerMetaFilter = {
  AND?: InputMaybe<Array<InputMaybe<DataLayerMetaFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DataLayerMetaFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  dataLayerMetaContent?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_contains?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_exists?: InputMaybe<Scalars['Boolean']>;
  dataLayerMetaContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataLayerMetaContent_not?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_not_contains?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type DataLayerMetaLinkingCollections = {
  __typename?: 'DataLayerMetaLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  stageCollection?: Maybe<StageCollection>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
};


export type DataLayerMetaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DataLayerMetaLinkingCollectionsStageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<DataLayerMetaLinkingCollectionsStageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type DataLayerMetaLinkingCollectionsTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<DataLayerMetaLinkingCollectionsTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum DataLayerMetaLinkingCollectionsStageCollectionOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HalfWidthTextAsc = 'halfWidthText_ASC',
  HalfWidthTextDesc = 'halfWidthText_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  IsFramedAsc = 'isFramed_ASC',
  IsFramedDesc = 'isFramed_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MiniHeadlineAsc = 'miniHeadline_ASC',
  MiniHeadlineDesc = 'miniHeadline_DESC',
  MobileAlignmentAsc = 'mobileAlignment_ASC',
  MobileAlignmentDesc = 'mobileAlignment_DESC',
  NewStageAsc = 'newStage_ASC',
  NewStageDesc = 'newStage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export enum DataLayerMetaLinkingCollectionsTeaserItemCollectionOrder {
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  GradientDirectionAsc = 'gradientDirection_ASC',
  GradientDirectionDesc = 'gradientDirection_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum DataLayerMetaOrder {
  DataLayerMetaContentAsc = 'dataLayerMetaContent_ASC',
  DataLayerMetaContentDesc = 'dataLayerMetaContent_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGallery = Entry & _Node & {
  __typename?: 'EditorialGallery';
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundText?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  headline?: Maybe<Scalars['String']>;
  image1?: Maybe<Asset>;
  image2?: Maybe<Asset>;
  image3?: Maybe<Asset>;
  image4?: Maybe<Asset>;
  image5?: Maybe<Asset>;
  image6?: Maybe<Asset>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<EditorialGalleryLinkingCollections>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryBackgroundTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryImage1Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryImage2Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryImage3Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryImage4Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryImage5Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryImage6Args = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/editorialGallery) */
export type EditorialGalleryTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type EditorialGalleryCollection = {
  __typename?: 'EditorialGalleryCollection';
  items: Array<Maybe<EditorialGallery>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EditorialGalleryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EditorialGalleryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EditorialGalleryFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundText?: InputMaybe<Scalars['String']>;
  backgroundText_contains?: InputMaybe<Scalars['String']>;
  backgroundText_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundText_not?: InputMaybe<Scalars['String']>;
  backgroundText_not_contains?: InputMaybe<Scalars['String']>;
  backgroundText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image1_exists?: InputMaybe<Scalars['Boolean']>;
  image2_exists?: InputMaybe<Scalars['Boolean']>;
  image3_exists?: InputMaybe<Scalars['Boolean']>;
  image4_exists?: InputMaybe<Scalars['Boolean']>;
  image5_exists?: InputMaybe<Scalars['Boolean']>;
  image6_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EditorialGalleryLinkingCollections = {
  __typename?: 'EditorialGalleryLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type EditorialGalleryLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EditorialGalleryLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type EditorialGalleryLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EditorialGalleryLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type EditorialGalleryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type EditorialGalleryLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EditorialGalleryLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum EditorialGalleryLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EditorialGalleryLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EditorialGalleryLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum EditorialGalleryOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  BackgroundTextAsc = 'backgroundText_ASC',
  BackgroundTextDesc = 'backgroundText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItem = Entry & _Node & {
  __typename?: 'FooterIconBarItem';
  _id: Scalars['ID'];
  boldText?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<FooterIconBarItemLinkingCollections>;
  name?: Maybe<Scalars['String']>;
  normalText?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItemBoldTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItemIconArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItemNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Represents a single item for the Footer Icon Bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerIconBarItem) */
export type FooterIconBarItemNormalTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type FooterIconBarItemCollection = {
  __typename?: 'FooterIconBarItemCollection';
  items: Array<Maybe<FooterIconBarItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FooterIconBarItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterIconBarItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterIconBarItemFilter>>>;
  boldText?: InputMaybe<Scalars['String']>;
  boldText_contains?: InputMaybe<Scalars['String']>;
  boldText_exists?: InputMaybe<Scalars['Boolean']>;
  boldText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  boldText_not?: InputMaybe<Scalars['String']>;
  boldText_not_contains?: InputMaybe<Scalars['String']>;
  boldText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']>;
  icon_contains?: InputMaybe<Scalars['String']>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_not?: InputMaybe<Scalars['String']>;
  icon_not_contains?: InputMaybe<Scalars['String']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  normalText?: InputMaybe<Scalars['String']>;
  normalText_contains?: InputMaybe<Scalars['String']>;
  normalText_exists?: InputMaybe<Scalars['Boolean']>;
  normalText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  normalText_not?: InputMaybe<Scalars['String']>;
  normalText_not_contains?: InputMaybe<Scalars['String']>;
  normalText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterIconBarItemLinkingCollections = {
  __typename?: 'FooterIconBarItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type FooterIconBarItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FooterIconBarItemLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterIconBarItemLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FooterIconBarItemLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FooterIconBarItemOrder {
  BoldTextAsc = 'boldText_ASC',
  BoldTextDesc = 'boldText_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NormalTextAsc = 'normalText_ASC',
  NormalTextDesc = 'normalText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerNewsletter) */
export type FooterNewsletter = Entry & _Node & {
  __typename?: 'FooterNewsletter';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<FooterNewsletterLinkingCollections>;
  list?: Maybe<Array<Maybe<Scalars['String']>>>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerNewsletter) */
export type FooterNewsletterHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerNewsletter) */
export type FooterNewsletterInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerNewsletter) */
export type FooterNewsletterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/footerNewsletter) */
export type FooterNewsletterListArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type FooterNewsletterCollection = {
  __typename?: 'FooterNewsletterCollection';
  items: Array<Maybe<FooterNewsletter>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type FooterNewsletterFilter = {
  AND?: InputMaybe<Array<InputMaybe<FooterNewsletterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FooterNewsletterFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type FooterNewsletterLinkingCollections = {
  __typename?: 'FooterNewsletterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type FooterNewsletterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type FooterNewsletterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterNewsletterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum FooterNewsletterLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum FooterNewsletterOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItem = Entry & _Node & {
  __typename?: 'HeroStageItem';
  _id: Scalars['ID'];
  bynderDesktopImage?: Maybe<Scalars['JSON']>;
  bynderMobileImage?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  copyText?: Maybe<Scalars['String']>;
  countdownDate?: Maybe<Scalars['DateTime']>;
  cta?: Maybe<Cta>;
  desktopImage?: Maybe<Asset>;
  headline?: Maybe<Scalars['String']>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HeroStageItemLinkingCollections>;
  mobileImage?: Maybe<Asset>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  theme?: Maybe<Scalars['String']>;
  video?: Maybe<Asset>;
  videoMobile?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemBynderDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemBynderMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemCopyTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemCountdownDateArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemThemeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemVideoArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageItem) */
export type HeroStageItemVideoMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};

export type HeroStageItemCollection = {
  __typename?: 'HeroStageItemCollection';
  items: Array<Maybe<HeroStageItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HeroStageItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroStageItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroStageItemFilter>>>;
  bynderDesktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyText?: InputMaybe<Scalars['String']>;
  copyText_contains?: InputMaybe<Scalars['String']>;
  copyText_exists?: InputMaybe<Scalars['Boolean']>;
  copyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  copyText_not?: InputMaybe<Scalars['String']>;
  copyText_not_contains?: InputMaybe<Scalars['String']>;
  copyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countdownDate?: InputMaybe<Scalars['DateTime']>;
  countdownDate_exists?: InputMaybe<Scalars['Boolean']>;
  countdownDate_gt?: InputMaybe<Scalars['DateTime']>;
  countdownDate_gte?: InputMaybe<Scalars['DateTime']>;
  countdownDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  countdownDate_lt?: InputMaybe<Scalars['DateTime']>;
  countdownDate_lte?: InputMaybe<Scalars['DateTime']>;
  countdownDate_not?: InputMaybe<Scalars['DateTime']>;
  countdownDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']>;
  theme_contains?: InputMaybe<Scalars['String']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme_not?: InputMaybe<Scalars['String']>;
  theme_not_contains?: InputMaybe<Scalars['String']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type HeroStageItemLinkingCollections = {
  __typename?: 'HeroStageItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  heroStageModuleCollection?: Maybe<HeroStageModuleCollection>;
};


export type HeroStageItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HeroStageItemLinkingCollectionsHeroStageModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroStageItemLinkingCollectionsHeroStageModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HeroStageItemLinkingCollectionsHeroStageModuleCollectionOrder {
  DisplayNavigationAsc = 'displayNavigation_ASC',
  DisplayNavigationDesc = 'displayNavigation_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum HeroStageItemOrder {
  CopyTextAsc = 'copyText_ASC',
  CopyTextDesc = 'copyText_DESC',
  CountdownDateAsc = 'countdownDate_ASC',
  CountdownDateDesc = 'countdownDate_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageModule) */
export type HeroStageModule = Entry & _Node & {
  __typename?: 'HeroStageModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  displayNavigation?: Maybe<Scalars['Boolean']>;
  heroStageItemsCollection?: Maybe<HeroStageModuleHeroStageItemsCollection>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HeroStageModuleLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageModule) */
export type HeroStageModuleDisplayNavigationArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageModule) */
export type HeroStageModuleHeroStageItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroStageModuleHeroStageItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeroStageItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageModule) */
export type HeroStageModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/heroStageModule) */
export type HeroStageModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HeroStageModuleCollection = {
  __typename?: 'HeroStageModuleCollection';
  items: Array<Maybe<HeroStageModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HeroStageModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeroStageModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeroStageModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayNavigation?: InputMaybe<Scalars['Boolean']>;
  displayNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  displayNavigation_not?: InputMaybe<Scalars['Boolean']>;
  heroStageItems?: InputMaybe<CfHeroStageItemNestedFilter>;
  heroStageItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HeroStageModuleHeroStageItemsCollection = {
  __typename?: 'HeroStageModuleHeroStageItemsCollection';
  items: Array<Maybe<HeroStageItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum HeroStageModuleHeroStageItemsCollectionOrder {
  CopyTextAsc = 'copyText_ASC',
  CopyTextDesc = 'copyText_DESC',
  CountdownDateAsc = 'countdownDate_ASC',
  CountdownDateDesc = 'countdownDate_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export type HeroStageModuleLinkingCollections = {
  __typename?: 'HeroStageModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type HeroStageModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HeroStageModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroStageModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HeroStageModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HeroStageModuleOrder {
  DisplayNavigationAsc = 'displayNavigation_ASC',
  DisplayNavigationDesc = 'displayNavigation_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/hiddenHeadingH1) */
export type HiddenHeadingH1 = Entry & _Node & {
  __typename?: 'HiddenHeadingH1';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  hiddenH1Item?: Maybe<Scalars['String']>;
  hiddenH1Title?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<HiddenHeadingH1LinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/hiddenHeadingH1) */
export type HiddenHeadingH1HiddenH1ItemArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/hiddenHeadingH1) */
export type HiddenHeadingH1HiddenH1TitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/hiddenHeadingH1) */
export type HiddenHeadingH1LinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type HiddenHeadingH1Collection = {
  __typename?: 'HiddenHeadingH1Collection';
  items: Array<Maybe<HiddenHeadingH1>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type HiddenHeadingH1Filter = {
  AND?: InputMaybe<Array<InputMaybe<HiddenHeadingH1Filter>>>;
  OR?: InputMaybe<Array<InputMaybe<HiddenHeadingH1Filter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  hiddenH1Item?: InputMaybe<Scalars['String']>;
  hiddenH1Item_contains?: InputMaybe<Scalars['String']>;
  hiddenH1Item_exists?: InputMaybe<Scalars['Boolean']>;
  hiddenH1Item_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hiddenH1Item_not?: InputMaybe<Scalars['String']>;
  hiddenH1Item_not_contains?: InputMaybe<Scalars['String']>;
  hiddenH1Item_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hiddenH1Title?: InputMaybe<Scalars['String']>;
  hiddenH1Title_contains?: InputMaybe<Scalars['String']>;
  hiddenH1Title_exists?: InputMaybe<Scalars['Boolean']>;
  hiddenH1Title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hiddenH1Title_not?: InputMaybe<Scalars['String']>;
  hiddenH1Title_not_contains?: InputMaybe<Scalars['String']>;
  hiddenH1Title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type HiddenHeadingH1LinkingCollections = {
  __typename?: 'HiddenHeadingH1LinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type HiddenHeadingH1LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type HiddenHeadingH1LinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HiddenHeadingH1LinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum HiddenHeadingH1LinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum HiddenHeadingH1Order {
  HiddenH1ItemAsc = 'hiddenH1Item_ASC',
  HiddenH1ItemDesc = 'hiddenH1Item_DESC',
  HiddenH1TitleAsc = 'hiddenH1Title_ASC',
  HiddenH1TitleDesc = 'hiddenH1Title_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModule = Entry & _Node & {
  __typename?: 'ImageModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  headline?: Maybe<Scalars['String']>;
  headlineIntern?: Maybe<Scalars['String']>;
  imageAspectRatio?: Maybe<Scalars['String']>;
  imageCaption?: Maybe<Scalars['String']>;
  imagesCollection?: Maybe<ImageModuleImagesCollection>;
  linkedFrom?: Maybe<ImageModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  richText?: Maybe<ImageModuleRichText>;
  sys: Sys;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleHeadlineInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleImageAspectRatioArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleImagesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ImageModuleItemFilter>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display images as 1, 2, or many more as a carousel. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModule) */
export type ImageModuleRichTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ImageModuleCollection = {
  __typename?: 'ImageModuleCollection';
  items: Array<Maybe<ImageModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ImageModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headlineIntern?: InputMaybe<Scalars['String']>;
  headlineIntern_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_exists?: InputMaybe<Scalars['Boolean']>;
  headlineIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIntern_not?: InputMaybe<Scalars['String']>;
  headlineIntern_not_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageAspectRatio?: InputMaybe<Scalars['String']>;
  imageAspectRatio_contains?: InputMaybe<Scalars['String']>;
  imageAspectRatio_exists?: InputMaybe<Scalars['Boolean']>;
  imageAspectRatio_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageAspectRatio_not?: InputMaybe<Scalars['String']>;
  imageAspectRatio_not_contains?: InputMaybe<Scalars['String']>;
  imageAspectRatio_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageCaption_contains?: InputMaybe<Scalars['String']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  images?: InputMaybe<CfImageModuleItemNestedFilter>;
  imagesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  richText_contains?: InputMaybe<Scalars['String']>;
  richText_exists?: InputMaybe<Scalars['Boolean']>;
  richText_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
};

export type ImageModuleImagesCollection = {
  __typename?: 'ImageModuleImagesCollection';
  items: Array<Maybe<ImageModuleItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ImageModuleImagesCollectionOrder {
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextDirectionAsc = 'textDirection_ASC',
  TextDirectionDesc = 'textDirection_DESC'
}

/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItem = Entry & _Node & {
  __typename?: 'ImageModuleItem';
  _id: Scalars['ID'];
  bynderImage?: Maybe<Scalars['JSON']>;
  bynderImageMobile?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  imageCaption?: Maybe<Scalars['String']>;
  imageFocus?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<Asset>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ImageModuleItemLinkingCollections>;
  rteField?: Maybe<Rte>;
  sys: Sys;
  textDirection?: Maybe<Scalars['String']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemBynderImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemRteFieldArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<RteFilter>;
};


/** An image item to be used in the Image Module. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/imageModuleItem) */
export type ImageModuleItemTextDirectionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ImageModuleItemCollection = {
  __typename?: 'ImageModuleItemCollection';
  items: Array<Maybe<ImageModuleItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ImageModuleItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ImageModuleItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ImageModuleItemFilter>>>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageCaption_contains?: InputMaybe<Scalars['String']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rteField?: InputMaybe<CfRteNestedFilter>;
  rteField_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  textDirection?: InputMaybe<Scalars['String']>;
  textDirection_contains?: InputMaybe<Scalars['String']>;
  textDirection_exists?: InputMaybe<Scalars['Boolean']>;
  textDirection_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textDirection_not?: InputMaybe<Scalars['String']>;
  textDirection_not_contains?: InputMaybe<Scalars['String']>;
  textDirection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ImageModuleItemLinkingCollections = {
  __typename?: 'ImageModuleItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  imageModuleCollection?: Maybe<ImageModuleCollection>;
};


export type ImageModuleItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ImageModuleItemLinkingCollectionsImageModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleItemLinkingCollectionsImageModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ImageModuleItemLinkingCollectionsImageModuleCollectionOrder {
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageModuleItemOrder {
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextDirectionAsc = 'textDirection_ASC',
  TextDirectionDesc = 'textDirection_DESC'
}

export type ImageModuleLinkingCollections = {
  __typename?: 'ImageModuleLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ImageModuleLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ImageModuleLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ImageModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ImageModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ImageModuleLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ImageModuleLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ImageModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ImageModuleOrder {
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageAspectRatioAsc = 'imageAspectRatio_ASC',
  ImageAspectRatioDesc = 'imageAspectRatio_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ImageModuleRichText = {
  __typename?: 'ImageModuleRichText';
  json: Scalars['JSON'];
  links: ImageModuleRichTextLinks;
};

export type ImageModuleRichTextAssets = {
  __typename?: 'ImageModuleRichTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ImageModuleRichTextEntries = {
  __typename?: 'ImageModuleRichTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ImageModuleRichTextLinks = {
  __typename?: 'ImageModuleRichTextLinks';
  assets: ImageModuleRichTextAssets;
  entries: ImageModuleRichTextEntries;
  resources: ImageModuleRichTextResources;
};

export type ImageModuleRichTextResources = {
  __typename?: 'ImageModuleRichTextResources';
  block: Array<ImageModuleRichTextResourcesBlock>;
  hyperlink: Array<ImageModuleRichTextResourcesHyperlink>;
  inline: Array<ImageModuleRichTextResourcesInline>;
};

export type ImageModuleRichTextResourcesBlock = ResourceLink & {
  __typename?: 'ImageModuleRichTextResourcesBlock';
  sys: ResourceSys;
};

export type ImageModuleRichTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ImageModuleRichTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ImageModuleRichTextResourcesInline = ResourceLink & {
  __typename?: 'ImageModuleRichTextResourcesInline';
  sys: ResourceSys;
};

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']>;
};

/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModule = Entry & _Node & {
  __typename?: 'InstagramModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<InstagramModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Instagram module for landing page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/instagramModule) */
export type InstagramModuleSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type InstagramModuleCollection = {
  __typename?: 'InstagramModuleCollection';
  items: Array<Maybe<InstagramModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type InstagramModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<InstagramModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InstagramModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type InstagramModuleLinkingCollections = {
  __typename?: 'InstagramModuleLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type InstagramModuleLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<InstagramModuleLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InstagramModuleLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<InstagramModuleLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InstagramModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type InstagramModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<InstagramModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum InstagramModuleLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum InstagramModuleLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum InstagramModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum InstagramModuleOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModule = Entry & _Node & {
  __typename?: 'JavascriptModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  customHeight?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  inlineScript?: Maybe<Scalars['String']>;
  internalTitle?: Maybe<Scalars['String']>;
  isIframe?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<JavascriptModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  scriptUrl?: Maybe<Scalars['String']>;
  strategy?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleCustomHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleInlineScriptArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleIsIframeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleScriptUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Javascript module that injects an inline or remote javascript code to the page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/javascriptModule) */
export type JavascriptModuleStrategyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type JavascriptModuleCollection = {
  __typename?: 'JavascriptModuleCollection';
  items: Array<Maybe<JavascriptModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type JavascriptModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<JavascriptModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<JavascriptModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  customHeight?: InputMaybe<Scalars['Int']>;
  customHeight_exists?: InputMaybe<Scalars['Boolean']>;
  customHeight_gt?: InputMaybe<Scalars['Int']>;
  customHeight_gte?: InputMaybe<Scalars['Int']>;
  customHeight_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  customHeight_lt?: InputMaybe<Scalars['Int']>;
  customHeight_lte?: InputMaybe<Scalars['Int']>;
  customHeight_not?: InputMaybe<Scalars['Int']>;
  customHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inlineScript?: InputMaybe<Scalars['String']>;
  inlineScript_contains?: InputMaybe<Scalars['String']>;
  inlineScript_exists?: InputMaybe<Scalars['Boolean']>;
  inlineScript_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inlineScript_not?: InputMaybe<Scalars['String']>;
  inlineScript_not_contains?: InputMaybe<Scalars['String']>;
  inlineScript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isIframe?: InputMaybe<Scalars['Boolean']>;
  isIframe_exists?: InputMaybe<Scalars['Boolean']>;
  isIframe_not?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scriptUrl?: InputMaybe<Scalars['String']>;
  scriptUrl_contains?: InputMaybe<Scalars['String']>;
  scriptUrl_exists?: InputMaybe<Scalars['Boolean']>;
  scriptUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  scriptUrl_not?: InputMaybe<Scalars['String']>;
  scriptUrl_not_contains?: InputMaybe<Scalars['String']>;
  scriptUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  strategy?: InputMaybe<Scalars['String']>;
  strategy_contains?: InputMaybe<Scalars['String']>;
  strategy_exists?: InputMaybe<Scalars['Boolean']>;
  strategy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  strategy_not?: InputMaybe<Scalars['String']>;
  strategy_not_contains?: InputMaybe<Scalars['String']>;
  strategy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type JavascriptModuleLinkingCollections = {
  __typename?: 'JavascriptModuleLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type JavascriptModuleLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<JavascriptModuleLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type JavascriptModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum JavascriptModuleLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum JavascriptModuleOrder {
  CustomHeightAsc = 'customHeight_ASC',
  CustomHeightDesc = 'customHeight_DESC',
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  IsIframeAsc = 'isIframe_ASC',
  IsIframeDesc = 'isIframe_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  StrategyAsc = 'strategy_ASC',
  StrategyDesc = 'strategy_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGrid = Entry & _Node & {
  __typename?: 'LogoGrid';
  _id: Scalars['ID'];
  bynderImages?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  imagesCollection?: Maybe<AssetCollection>;
  linkedFrom?: Maybe<LogoGridLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
  titleIntern?: Maybe<Scalars['String']>;
};


/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGridBynderImagesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGridImagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGridLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGridMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGridMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** LogoGrid Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/logoGrid) */
export type LogoGridTitleInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type LogoGridCollection = {
  __typename?: 'LogoGridCollection';
  items: Array<Maybe<LogoGrid>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type LogoGridFilter = {
  AND?: InputMaybe<Array<InputMaybe<LogoGridFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LogoGridFilter>>>;
  bynderImages_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imagesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LogoGridLinkingCollections = {
  __typename?: 'LogoGridLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type LogoGridLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LogoGridLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LogoGridLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LogoGridLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LogoGridLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum LogoGridLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LogoGridLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LogoGridOrder {
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type Lookbook = Entry & _Node & {
  __typename?: 'Lookbook';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  height?: Maybe<Scalars['Int']>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<LookbookLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  pagesCollection?: Maybe<AssetCollection>;
  sys: Sys;
  width?: Maybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookHeightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookPagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/lookbook) */
export type LookbookWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type LookbookCollection = {
  __typename?: 'LookbookCollection';
  items: Array<Maybe<Lookbook>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type LookbookFilter = {
  AND?: InputMaybe<Array<InputMaybe<LookbookFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<LookbookFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  height?: InputMaybe<Scalars['Int']>;
  height_exists?: InputMaybe<Scalars['Boolean']>;
  height_gt?: InputMaybe<Scalars['Int']>;
  height_gte?: InputMaybe<Scalars['Int']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  height_lt?: InputMaybe<Scalars['Int']>;
  height_lte?: InputMaybe<Scalars['Int']>;
  height_not?: InputMaybe<Scalars['Int']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  width?: InputMaybe<Scalars['Int']>;
  width_exists?: InputMaybe<Scalars['Boolean']>;
  width_gt?: InputMaybe<Scalars['Int']>;
  width_gte?: InputMaybe<Scalars['Int']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  width_lt?: InputMaybe<Scalars['Int']>;
  width_lte?: InputMaybe<Scalars['Int']>;
  width_not?: InputMaybe<Scalars['Int']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type LookbookLinkingCollections = {
  __typename?: 'LookbookLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type LookbookLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type LookbookLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LookbookLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum LookbookLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LookbookOrder {
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** The main mega navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/megaNavigation) */
export type MegaNavigation = Entry & _Node & {
  __typename?: 'MegaNavigation';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  firstLevelItemsCollection?: Maybe<MegaNavigationFirstLevelItemsCollection>;
  linkedFrom?: Maybe<MegaNavigationLinkingCollections>;
  mobileFirstLevelItemsCollection?: Maybe<MegaNavigationMobileFirstLevelItemsCollection>;
  sys: Sys;
  theme?: Maybe<Scalars['String']>;
  titleInternal?: Maybe<Scalars['String']>;
};


/** The main mega navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/megaNavigation) */
export type MegaNavigationFirstLevelItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MegaNavigationFirstLevelItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationElementWithSubElementsFilter>;
};


/** The main mega navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/megaNavigation) */
export type MegaNavigationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The main mega navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/megaNavigation) */
export type MegaNavigationMobileFirstLevelItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MegaNavigationMobileFirstLevelItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationElementWithSubElementsFilter>;
};


/** The main mega navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/megaNavigation) */
export type MegaNavigationThemeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** The main mega navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/megaNavigation) */
export type MegaNavigationTitleInternalArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type MegaNavigationCollection = {
  __typename?: 'MegaNavigationCollection';
  items: Array<Maybe<MegaNavigation>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type MegaNavigationFilter = {
  AND?: InputMaybe<Array<InputMaybe<MegaNavigationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MegaNavigationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstLevelItems?: InputMaybe<CfNavigationElementWithSubElementsNestedFilter>;
  firstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  mobileFirstLevelItems?: InputMaybe<CfNavigationElementWithSubElementsNestedFilter>;
  mobileFirstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']>;
  theme_contains?: InputMaybe<Scalars['String']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme_not?: InputMaybe<Scalars['String']>;
  theme_not_contains?: InputMaybe<Scalars['String']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MegaNavigationFirstLevelItemsCollection = {
  __typename?: 'MegaNavigationFirstLevelItemsCollection';
  items: Array<Maybe<NavigationElementWithSubElements>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum MegaNavigationFirstLevelItemsCollectionOrder {
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type MegaNavigationLinkingCollections = {
  __typename?: 'MegaNavigationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type MegaNavigationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type MegaNavigationLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MegaNavigationLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum MegaNavigationLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type MegaNavigationMobileFirstLevelItemsCollection = {
  __typename?: 'MegaNavigationMobileFirstLevelItemsCollection';
  items: Array<Maybe<NavigationElementWithSubElements>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum MegaNavigationMobileFirstLevelItemsCollectionOrder {
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum MegaNavigationOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaser = Entry & _Node & {
  __typename?: 'MultiTeaser';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<MultiTeaserLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  multiTeaserItemsCollection?: Maybe<MultiTeaserMultiTeaserItemsCollection>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserMultiTeaserItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MultiTeaserMultiTeaserItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MultiTeaserItemFilter>;
};


/** Module for 2-6 teaser items consisting of image, headline, text, CTA [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaser) */
export type MultiTeaserSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type MultiTeaserCollection = {
  __typename?: 'MultiTeaserCollection';
  items: Array<Maybe<MultiTeaser>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type MultiTeaserFilter = {
  AND?: InputMaybe<Array<InputMaybe<MultiTeaserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiTeaserFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  multiTeaserItems?: InputMaybe<CfMultiTeaserItemNestedFilter>;
  multiTeaserItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItem = Entry & _Node & {
  __typename?: 'MultiTeaserItem';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  headline?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<MultiTeaserItemLinkingCollections>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItemCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItemHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItemImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Items for the Multi Teaser Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/multiTeaserItem) */
export type MultiTeaserItemSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type MultiTeaserItemCollection = {
  __typename?: 'MultiTeaserItemCollection';
  items: Array<Maybe<MultiTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type MultiTeaserItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<MultiTeaserItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<MultiTeaserItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type MultiTeaserItemLinkingCollections = {
  __typename?: 'MultiTeaserItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  multiTeaserCollection?: Maybe<MultiTeaserCollection>;
};


export type MultiTeaserItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type MultiTeaserItemLinkingCollectionsMultiTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MultiTeaserItemLinkingCollectionsMultiTeaserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum MultiTeaserItemLinkingCollectionsMultiTeaserCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MultiTeaserItemOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type MultiTeaserLinkingCollections = {
  __typename?: 'MultiTeaserLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type MultiTeaserLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MultiTeaserLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type MultiTeaserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum MultiTeaserLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type MultiTeaserMultiTeaserItemsCollection = {
  __typename?: 'MultiTeaserMultiTeaserItemsCollection';
  items: Array<Maybe<MultiTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum MultiTeaserMultiTeaserItemsCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MultiTeaserOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navCategoryWithElements) */
export type NavCategoryWithElements = Entry & _Node & {
  __typename?: 'NavCategoryWithElements';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavCategoryWithElementsLinkingCollections>;
  pageContent?: Maybe<Page>;
  subElementsCollection?: Maybe<NavCategoryWithElementsSubElementsCollection>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navCategoryWithElements) */
export type NavCategoryWithElementsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navCategoryWithElements) */
export type NavCategoryWithElementsPageContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navCategoryWithElements) */
export type NavCategoryWithElementsSubElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavCategoryWithElementsSubElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationElementFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navCategoryWithElements) */
export type NavCategoryWithElementsSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navCategoryWithElements) */
export type NavCategoryWithElementsTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavCategoryWithElementsCollection = {
  __typename?: 'NavCategoryWithElementsCollection';
  items: Array<Maybe<NavCategoryWithElements>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NavCategoryWithElementsFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavCategoryWithElementsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavCategoryWithElementsFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  pageContent?: InputMaybe<CfPageNestedFilter>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  subElements?: InputMaybe<CfNavigationElementNestedFilter>;
  subElementsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavCategoryWithElementsLinkingCollections = {
  __typename?: 'NavCategoryWithElementsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navigationColumnCollection?: Maybe<NavigationColumnCollection>;
};


export type NavCategoryWithElementsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavCategoryWithElementsLinkingCollectionsNavigationColumnCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavCategoryWithElementsLinkingCollectionsNavigationColumnCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavCategoryWithElementsLinkingCollectionsNavigationColumnCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavCategoryWithElementsOrder {
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavCategoryWithElementsSubElementsCollection = {
  __typename?: 'NavCategoryWithElementsSubElementsCollection';
  items: Array<Maybe<NavigationElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavCategoryWithElementsSubElementsCollectionOrder {
  ColorHexAsc = 'colorHex_ASC',
  ColorHexDesc = 'colorHex_DESC',
  ColorfulAsc = 'colorful_ASC',
  ColorfulDesc = 'colorful_DESC',
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** The main navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigation) */
export type Navigation = Entry & _Node & {
  __typename?: 'Navigation';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  firstLevelItemsCollection?: Maybe<NavigationFirstLevelItemsCollection>;
  linkedFrom?: Maybe<NavigationLinkingCollections>;
  mobileFirstLevelItemsCollection?: Maybe<NavigationMobileFirstLevelItemsCollection>;
  sys: Sys;
  teaser?: Maybe<TeaserItem>;
  titleInternal?: Maybe<Scalars['String']>;
};


/** The main navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigation) */
export type NavigationFirstLevelItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationFirstLevelItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationListElementFilter>;
};


/** The main navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigation) */
export type NavigationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The main navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigation) */
export type NavigationMobileFirstLevelItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationMobileFirstLevelItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationListElementFilter>;
};


/** The main navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigation) */
export type NavigationTeaserArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** The main navigation. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigation) */
export type NavigationTitleInternalArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavigationCollection = {
  __typename?: 'NavigationCollection';
  items: Array<Maybe<Navigation>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationColumn) */
export type NavigationColumn = Entry & _Node & {
  __typename?: 'NavigationColumn';
  _id: Scalars['ID'];
  categoriesCollection?: Maybe<NavigationColumnCategoriesCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<NavigationColumnLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationColumn) */
export type NavigationColumnCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavCategoryWithElementsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationColumn) */
export type NavigationColumnLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationColumn) */
export type NavigationColumnTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavigationColumnCategoriesCollection = {
  __typename?: 'NavigationColumnCategoriesCollection';
  items: Array<Maybe<NavCategoryWithElements>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationColumnCategoriesCollectionOrder {
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationColumnCollection = {
  __typename?: 'NavigationColumnCollection';
  items: Array<Maybe<NavigationColumn>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NavigationColumnFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationColumnFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationColumnFilter>>>;
  categories?: InputMaybe<CfNavCategoryWithElementsNestedFilter>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavigationColumnLinkingCollections = {
  __typename?: 'NavigationColumnLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navigationElementWithSubElementsCollection?: Maybe<NavigationElementWithSubElementsCollection>;
};


export type NavigationColumnLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationColumnLinkingCollectionsNavigationElementWithSubElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnLinkingCollectionsNavigationElementWithSubElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavigationColumnLinkingCollectionsNavigationElementWithSubElementsCollectionOrder {
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationColumnOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElement = Entry & _Node & {
  __typename?: 'NavigationElement';
  _id: Scalars['ID'];
  colorHex?: Maybe<Scalars['String']>;
  colorful?: Maybe<Scalars['Boolean']>;
  contentfulMetadata: ContentfulMetadata;
  highlightedColor?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NavigationElementLinkingCollections>;
  pageContent?: Maybe<Page>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementColorHexArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementColorfulArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementHighlightedColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementPageContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElement) */
export type NavigationElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavigationElementCollection = {
  __typename?: 'NavigationElementCollection';
  items: Array<Maybe<NavigationElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NavigationElementFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationElementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationElementFilter>>>;
  colorHex?: InputMaybe<Scalars['String']>;
  colorHex_contains?: InputMaybe<Scalars['String']>;
  colorHex_exists?: InputMaybe<Scalars['Boolean']>;
  colorHex_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  colorHex_not?: InputMaybe<Scalars['String']>;
  colorHex_not_contains?: InputMaybe<Scalars['String']>;
  colorHex_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  colorful?: InputMaybe<Scalars['Boolean']>;
  colorful_exists?: InputMaybe<Scalars['Boolean']>;
  colorful_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  highlightedColor?: InputMaybe<Scalars['String']>;
  highlightedColor_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_exists?: InputMaybe<Scalars['Boolean']>;
  highlightedColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  highlightedColor_not?: InputMaybe<Scalars['String']>;
  highlightedColor_not_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageContent?: InputMaybe<CfPageNestedFilter>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavigationElementLinkingCollections = {
  __typename?: 'NavigationElementLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navCategoryWithElementsCollection?: Maybe<NavCategoryWithElementsCollection>;
  navigationElementWithSubElementsCollection?: Maybe<NavigationElementWithSubElementsCollection>;
};


export type NavigationElementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationElementLinkingCollectionsNavCategoryWithElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationElementLinkingCollectionsNavCategoryWithElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationElementLinkingCollectionsNavigationElementWithSubElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationElementLinkingCollectionsNavigationElementWithSubElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavigationElementLinkingCollectionsNavCategoryWithElementsCollectionOrder {
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationElementLinkingCollectionsNavigationElementWithSubElementsCollectionOrder {
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationElementOrder {
  ColorHexAsc = 'colorHex_ASC',
  ColorHexDesc = 'colorHex_DESC',
  ColorfulAsc = 'colorful_ASC',
  ColorfulDesc = 'colorful_DESC',
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElements = Entry & _Node & {
  __typename?: 'NavigationElementWithSubElements';
  _id: Scalars['ID'];
  bottomElement?: Maybe<NavigationElement>;
  contentfulMetadata: ContentfulMetadata;
  highlightedColor?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NavigationElementWithSubElementsLinkingCollections>;
  pageContent?: Maybe<Page>;
  subElementsCollection?: Maybe<NavigationElementWithSubElementsSubElementsCollection>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsBottomElementArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<NavigationElementFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsHighlightedColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsPageContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsSubElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationElementWithSubElementsSubElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationColumnFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationElementWithSubElements) */
export type NavigationElementWithSubElementsTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavigationElementWithSubElementsCollection = {
  __typename?: 'NavigationElementWithSubElementsCollection';
  items: Array<Maybe<NavigationElementWithSubElements>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NavigationElementWithSubElementsFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationElementWithSubElementsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationElementWithSubElementsFilter>>>;
  bottomElement?: InputMaybe<CfNavigationElementNestedFilter>;
  bottomElement_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  highlightedColor?: InputMaybe<Scalars['String']>;
  highlightedColor_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_exists?: InputMaybe<Scalars['Boolean']>;
  highlightedColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  highlightedColor_not?: InputMaybe<Scalars['String']>;
  highlightedColor_not_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageContent?: InputMaybe<CfPageNestedFilter>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  subElements?: InputMaybe<CfNavigationColumnNestedFilter>;
  subElementsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavigationElementWithSubElementsLinkingCollections = {
  __typename?: 'NavigationElementWithSubElementsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  megaNavigationCollection?: Maybe<MegaNavigationCollection>;
};


export type NavigationElementWithSubElementsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationElementWithSubElementsLinkingCollectionsMegaNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationElementWithSubElementsLinkingCollectionsMegaNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavigationElementWithSubElementsLinkingCollectionsMegaNavigationCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export enum NavigationElementWithSubElementsOrder {
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationElementWithSubElementsSubElementsCollection = {
  __typename?: 'NavigationElementWithSubElementsSubElementsCollection';
  items: Array<Maybe<NavigationColumn>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationElementWithSubElementsSubElementsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstLevelItems?: InputMaybe<CfNavigationListElementNestedFilter>;
  firstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  mobileFirstLevelItems?: InputMaybe<CfNavigationListElementNestedFilter>;
  mobileFirstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  teaser?: InputMaybe<CfTeaserItemNestedFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavigationFirstLevelItemsCollection = {
  __typename?: 'NavigationFirstLevelItemsCollection';
  items: Array<Maybe<NavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationFirstLevelItemsCollectionOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationLinkingCollections = {
  __typename?: 'NavigationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type NavigationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavigationLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElement = Entry & _Node & {
  __typename?: 'NavigationListElement';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  isBrandsItem?: Maybe<Scalars['Boolean']>;
  isColorItem?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<NavigationListElementLinkingCollections>;
  mobileThirdLevelMenuImage?: Maybe<Asset>;
  navigationListItemsCollection?: Maybe<NavigationListElementNavigationListItemsCollection>;
  pageContent?: Maybe<Page>;
  portraitImage?: Maybe<Scalars['Boolean']>;
  productImage?: Maybe<Asset>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  teaser?: Maybe<TeaserItem>;
  textColor?: Maybe<Scalars['String']>;
  thirdLevelImage?: Maybe<Asset>;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementIsBrandsItemArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementIsColorItemArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementMobileThirdLevelMenuImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementNavigationListItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationListElementNavigationListItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationListElementFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementPageContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementPortraitImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementProductImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementTeaserArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementTextColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementThirdLevelImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/navigationListElement) */
export type NavigationListElementTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NavigationListElementCollection = {
  __typename?: 'NavigationListElementCollection';
  items: Array<Maybe<NavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NavigationListElementFilter = {
  AND?: InputMaybe<Array<InputMaybe<NavigationListElementFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NavigationListElementFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  isBrandsItem?: InputMaybe<Scalars['Boolean']>;
  isBrandsItem_exists?: InputMaybe<Scalars['Boolean']>;
  isBrandsItem_not?: InputMaybe<Scalars['Boolean']>;
  isColorItem?: InputMaybe<Scalars['Boolean']>;
  isColorItem_exists?: InputMaybe<Scalars['Boolean']>;
  isColorItem_not?: InputMaybe<Scalars['Boolean']>;
  mobileThirdLevelMenuImage_exists?: InputMaybe<Scalars['Boolean']>;
  navigationListItems?: InputMaybe<CfNavigationListElementNestedFilter>;
  navigationListItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  pageContent?: InputMaybe<CfPageNestedFilter>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  portraitImage?: InputMaybe<Scalars['Boolean']>;
  portraitImage_exists?: InputMaybe<Scalars['Boolean']>;
  portraitImage_not?: InputMaybe<Scalars['Boolean']>;
  productImage_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  teaser?: InputMaybe<CfTeaserItemNestedFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thirdLevelImage_exists?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NavigationListElementLinkingCollections = {
  __typename?: 'NavigationListElementLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  navigationCollection?: Maybe<NavigationCollection>;
  navigationListElementCollection?: Maybe<NavigationListElementCollection>;
};


export type NavigationListElementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationListElementLinkingCollectionsNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationListElementLinkingCollectionsNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NavigationListElementLinkingCollectionsNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationListElementLinkingCollectionsNavigationListElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NavigationListElementLinkingCollectionsNavigationCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export enum NavigationListElementLinkingCollectionsNavigationListElementCollectionOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationListElementNavigationListItemsCollection = {
  __typename?: 'NavigationListElementNavigationListItemsCollection';
  items: Array<Maybe<NavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationListElementNavigationListItemsCollectionOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationListElementOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type NavigationMobileFirstLevelItemsCollection = {
  __typename?: 'NavigationMobileFirstLevelItemsCollection';
  items: Array<Maybe<NavigationListElement>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum NavigationMobileFirstLevelItemsCollectionOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NavigationOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type Newsletter = Entry & _Node & {
  __typename?: 'Newsletter';
  _id: Scalars['ID'];
  bynderImageDesktop?: Maybe<Scalars['JSON']>;
  bynderImageMobile?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  disclaimer?: Maybe<NewsletterDisclaimer>;
  headline?: Maybe<Scalars['String']>;
  imageDesktop?: Maybe<Asset>;
  imageMobile?: Maybe<Asset>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NewsletterLinkingCollections>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  subscriptionBenefits?: Maybe<Array<Maybe<Scalars['String']>>>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterBynderImageDesktopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterBynderImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterImageDesktopArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletter) */
export type NewsletterSubscriptionBenefitsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NewsletterCollection = {
  __typename?: 'NewsletterCollection';
  items: Array<Maybe<Newsletter>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NewsletterDisclaimer = {
  __typename?: 'NewsletterDisclaimer';
  json: Scalars['JSON'];
  links: NewsletterDisclaimerLinks;
};

export type NewsletterDisclaimerAssets = {
  __typename?: 'NewsletterDisclaimerAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type NewsletterDisclaimerEntries = {
  __typename?: 'NewsletterDisclaimerEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type NewsletterDisclaimerLinks = {
  __typename?: 'NewsletterDisclaimerLinks';
  assets: NewsletterDisclaimerAssets;
  entries: NewsletterDisclaimerEntries;
  resources: NewsletterDisclaimerResources;
};

export type NewsletterDisclaimerResources = {
  __typename?: 'NewsletterDisclaimerResources';
  block: Array<NewsletterDisclaimerResourcesBlock>;
  hyperlink: Array<NewsletterDisclaimerResourcesHyperlink>;
  inline: Array<NewsletterDisclaimerResourcesInline>;
};

export type NewsletterDisclaimerResourcesBlock = ResourceLink & {
  __typename?: 'NewsletterDisclaimerResourcesBlock';
  sys: ResourceSys;
};

export type NewsletterDisclaimerResourcesHyperlink = ResourceLink & {
  __typename?: 'NewsletterDisclaimerResourcesHyperlink';
  sys: ResourceSys;
};

export type NewsletterDisclaimerResourcesInline = ResourceLink & {
  __typename?: 'NewsletterDisclaimerResourcesInline';
  sys: ResourceSys;
};

export type NewsletterFilter = {
  AND?: InputMaybe<Array<InputMaybe<NewsletterFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsletterFilter>>>;
  bynderImageDesktop_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer_contains?: InputMaybe<Scalars['String']>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimer_not_contains?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageDesktop_exists?: InputMaybe<Scalars['Boolean']>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type NewsletterLinkingCollections = {
  __typename?: 'NewsletterLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type NewsletterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NewsletterLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsletterLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NewsletterLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModule = Entry & _Node & {
  __typename?: 'NewsletterModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  disclaimer?: Maybe<Scalars['String']>;
  disclaimerRte?: Maybe<NewsletterModuleDisclaimerRte>;
  hasOrganicShape?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
  headlineStyle?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  imageMobile?: Maybe<Asset>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<NewsletterModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  organicShapeColor?: Maybe<Scalars['String']>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleDisclaimerArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleDisclaimerRteArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleHasOrganicShapeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleHeadlineStyleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleOrganicShapeColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/newsletterModule) */
export type NewsletterModuleSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type NewsletterModuleCollection = {
  __typename?: 'NewsletterModuleCollection';
  items: Array<Maybe<NewsletterModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type NewsletterModuleDisclaimerRte = {
  __typename?: 'NewsletterModuleDisclaimerRte';
  json: Scalars['JSON'];
  links: NewsletterModuleDisclaimerRteLinks;
};

export type NewsletterModuleDisclaimerRteAssets = {
  __typename?: 'NewsletterModuleDisclaimerRteAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type NewsletterModuleDisclaimerRteEntries = {
  __typename?: 'NewsletterModuleDisclaimerRteEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type NewsletterModuleDisclaimerRteLinks = {
  __typename?: 'NewsletterModuleDisclaimerRteLinks';
  assets: NewsletterModuleDisclaimerRteAssets;
  entries: NewsletterModuleDisclaimerRteEntries;
  resources: NewsletterModuleDisclaimerRteResources;
};

export type NewsletterModuleDisclaimerRteResources = {
  __typename?: 'NewsletterModuleDisclaimerRteResources';
  block: Array<NewsletterModuleDisclaimerRteResourcesBlock>;
  hyperlink: Array<NewsletterModuleDisclaimerRteResourcesHyperlink>;
  inline: Array<NewsletterModuleDisclaimerRteResourcesInline>;
};

export type NewsletterModuleDisclaimerRteResourcesBlock = ResourceLink & {
  __typename?: 'NewsletterModuleDisclaimerRteResourcesBlock';
  sys: ResourceSys;
};

export type NewsletterModuleDisclaimerRteResourcesHyperlink = ResourceLink & {
  __typename?: 'NewsletterModuleDisclaimerRteResourcesHyperlink';
  sys: ResourceSys;
};

export type NewsletterModuleDisclaimerRteResourcesInline = ResourceLink & {
  __typename?: 'NewsletterModuleDisclaimerRteResourcesInline';
  sys: ResourceSys;
};

export type NewsletterModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<NewsletterModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsletterModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer?: InputMaybe<Scalars['String']>;
  disclaimerRte_contains?: InputMaybe<Scalars['String']>;
  disclaimerRte_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimerRte_not_contains?: InputMaybe<Scalars['String']>;
  disclaimer_contains?: InputMaybe<Scalars['String']>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimer_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  disclaimer_not?: InputMaybe<Scalars['String']>;
  disclaimer_not_contains?: InputMaybe<Scalars['String']>;
  disclaimer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasOrganicShape?: InputMaybe<Scalars['Boolean']>;
  hasOrganicShape_exists?: InputMaybe<Scalars['Boolean']>;
  hasOrganicShape_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headlineStyle?: InputMaybe<Scalars['String']>;
  headlineStyle_contains?: InputMaybe<Scalars['String']>;
  headlineStyle_exists?: InputMaybe<Scalars['Boolean']>;
  headlineStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineStyle_not?: InputMaybe<Scalars['String']>;
  headlineStyle_not_contains?: InputMaybe<Scalars['String']>;
  headlineStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organicShapeColor?: InputMaybe<Scalars['String']>;
  organicShapeColor_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_exists?: InputMaybe<Scalars['Boolean']>;
  organicShapeColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organicShapeColor_not?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type NewsletterModuleLinkingCollections = {
  __typename?: 'NewsletterModuleLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type NewsletterModuleLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsletterModuleLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NewsletterModuleLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsletterModuleLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NewsletterModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type NewsletterModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsletterModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum NewsletterModuleLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterModuleLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum NewsletterModuleOrder {
  HasOrganicShapeAsc = 'hasOrganicShape_ASC',
  HasOrganicShapeDesc = 'hasOrganicShape_DESC',
  HeadlineStyleAsc = 'headlineStyle_ASC',
  HeadlineStyleDesc = 'headlineStyle_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  OrganicShapeColorAsc = 'organicShapeColor_ASC',
  OrganicShapeColorDesc = 'organicShapeColor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum NewsletterOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type Page = Entry & _Node & {
  __typename?: 'Page';
  _id: Scalars['ID'];
  arBox?: Maybe<ArPdpBox>;
  banderole?: Maybe<Banderole>;
  banderoleNewsletter?: Maybe<BanderoleNesletter>;
  chatEnabled?: Maybe<Scalars['Boolean']>;
  checkoutFooterLinksCollection?: Maybe<PageCheckoutFooterLinksCollection>;
  cioCollectionId?: Maybe<Scalars['String']>;
  cioGroupId?: Maybe<Scalars['String']>;
  cioShowVariationsStrategy?: Maybe<Scalars['String']>;
  contentModulesCollection?: Maybe<PageContentModulesCollection>;
  contentfulMetadata: ContentfulMetadata;
  crossSellProducts?: Maybe<Array<Maybe<Scalars['String']>>>;
  deliveryDays?: Maybe<Scalars['String']>;
  faqAccountCollection?: Maybe<PageFaqAccountCollection>;
  footerColumnsCollection?: Maybe<PageFooterColumnsCollection>;
  footerIconBarCollection?: Maybe<PageFooterIconBarCollection>;
  footerMetaLinksCollection?: Maybe<PageFooterMetaLinksCollection>;
  footerNewsletterText?: Maybe<FooterNewsletter>;
  footerNote?: Maybe<Rte>;
  linkedFrom?: Maybe<PageLinkingCollections>;
  logoGridNewsletterSuccessPage?: Maybe<LogoGrid>;
  mainMegaNavigation?: Maybe<MegaNavigation>;
  mainNavigation?: Maybe<Navigation>;
  meta?: Maybe<Seo>;
  navigationTheme?: Maybe<Scalars['String']>;
  newsletterConfirmationHelpLinksCollection?: Maybe<PageNewsletterConfirmationHelpLinksCollection>;
  pageNewsletter?: Maybe<Newsletter>;
  preventIndexing?: Maybe<Scalars['Boolean']>;
  productAugmentedReality?: Maybe<AugmentedReality>;
  productBenefitsCollection?: Maybe<PageProductBenefitsCollection>;
  relatedPage?: Maybe<Page>;
  searchHelpLinksCollection?: Maybe<PageSearchHelpLinksCollection>;
  secondaryBanderole?: Maybe<SecondaryBanderole>;
  slug?: Maybe<Scalars['String']>;
  socialFooterIconsCollection?: Maybe<PageSocialFooterIconsCollection>;
  stage?: Maybe<Stage>;
  stageModule?: Maybe<HeroStageModule>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageArBoxArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<ArPdpBoxFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageBanderoleArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<BanderoleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageBanderoleNewsletterArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<BanderoleNesletterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageChatEnabledArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageCheckoutFooterLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageCheckoutFooterLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageCioCollectionIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageCioGroupIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageCioShowVariationsStrategyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageContentModulesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageContentModulesFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageCrossSellProductsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageDeliveryDaysArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageFaqAccountCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageFaqAccountCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccordionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageFooterColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageFooterColumnsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageFooterIconBarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageFooterIconBarCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterIconBarItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageFooterMetaLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageFooterMetaLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageFooterNewsletterTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<FooterNewsletterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageFooterNoteArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<RteFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageLogoGridNewsletterSuccessPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LogoGridFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageMainMegaNavigationArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<MegaNavigationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageMainNavigationArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<NavigationFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageMetaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SeoFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageNavigationThemeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageNewsletterConfirmationHelpLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageNewsletterConfirmationHelpLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PagePageNewsletterArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<NewsletterFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PagePreventIndexingArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageProductAugmentedRealityArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<AugmentedRealityFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageProductBenefitsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageProductBenefitsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductBenefitFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageRelatedPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageSearchHelpLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageSearchHelpLinksCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageSecondaryBanderoleArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SecondaryBanderoleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageSlugArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageSocialFooterIconsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageSocialFooterIconsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SocialIconFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageStageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<StageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageStageModuleArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<HeroStageModuleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/page) */
export type PageTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type PageCheckoutFooterLinksCollection = {
  __typename?: 'PageCheckoutFooterLinksCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageCheckoutFooterLinksCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PageCollection = {
  __typename?: 'PageCollection';
  items: Array<Maybe<Page>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PageContentModulesCollection = {
  __typename?: 'PageContentModulesCollection';
  items: Array<Maybe<PageContentModulesItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type PageContentModulesFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageContentModulesFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageContentModulesFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type PageContentModulesItem = Accordion | BlackfridayNewsletterModule | BlogCategory | BlogContent | BlogOverviewModule | CategorySliderModule | CustomNewsletter | EditorialGallery | HiddenHeadingH1 | ImageModule | InstagramModule | LogoGrid | Lookbook | Newsletter | NewsletterModule | ProductListPageTeaser | ProductTeaser | ProductsSlider | Quote | SeoHeadingModule | SeoTextModule | ShopTheLook | Stage | TabModule | TeaserModule | TextImageTeaser | TextPicModule | TextTeaser | TocModule | Video;

export type PageFaqAccountCollection = {
  __typename?: 'PageFaqAccountCollection';
  items: Array<Maybe<Accordion>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageFaqAccountCollectionOrder {
  AccountFaqPageAsc = 'accountFaqPage_ASC',
  AccountFaqPageDesc = 'accountFaqPage_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export type PageFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageFilter>>>;
  arBox?: InputMaybe<CfArPdpBoxNestedFilter>;
  arBox_exists?: InputMaybe<Scalars['Boolean']>;
  banderole?: InputMaybe<CfBanderoleNestedFilter>;
  banderoleNewsletter?: InputMaybe<CfBanderoleNesletterNestedFilter>;
  banderoleNewsletter_exists?: InputMaybe<Scalars['Boolean']>;
  banderole_exists?: InputMaybe<Scalars['Boolean']>;
  chatEnabled?: InputMaybe<Scalars['Boolean']>;
  chatEnabled_exists?: InputMaybe<Scalars['Boolean']>;
  chatEnabled_not?: InputMaybe<Scalars['Boolean']>;
  checkoutFooterLinks?: InputMaybe<CfCtaNestedFilter>;
  checkoutFooterLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  cioCollectionId?: InputMaybe<Scalars['String']>;
  cioCollectionId_contains?: InputMaybe<Scalars['String']>;
  cioCollectionId_exists?: InputMaybe<Scalars['Boolean']>;
  cioCollectionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioCollectionId_not?: InputMaybe<Scalars['String']>;
  cioCollectionId_not_contains?: InputMaybe<Scalars['String']>;
  cioCollectionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioGroupId?: InputMaybe<Scalars['String']>;
  cioGroupId_contains?: InputMaybe<Scalars['String']>;
  cioGroupId_exists?: InputMaybe<Scalars['Boolean']>;
  cioGroupId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioGroupId_not?: InputMaybe<Scalars['String']>;
  cioGroupId_not_contains?: InputMaybe<Scalars['String']>;
  cioGroupId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioShowVariationsStrategy?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_contains?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_exists?: InputMaybe<Scalars['Boolean']>;
  cioShowVariationsStrategy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioShowVariationsStrategy_not?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_not_contains?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentModules?: InputMaybe<CfcontentModulesMultiTypeNestedFilter>;
  contentModulesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  crossSellProducts_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellProducts_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellProducts_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellProducts_exists?: InputMaybe<Scalars['Boolean']>;
  deliveryDays?: InputMaybe<Scalars['String']>;
  deliveryDays_contains?: InputMaybe<Scalars['String']>;
  deliveryDays_exists?: InputMaybe<Scalars['Boolean']>;
  deliveryDays_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryDays_not?: InputMaybe<Scalars['String']>;
  deliveryDays_not_contains?: InputMaybe<Scalars['String']>;
  deliveryDays_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faqAccount?: InputMaybe<CfAccordionNestedFilter>;
  faqAccountCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerColumns?: InputMaybe<CfNavigationNestedFilter>;
  footerColumnsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerIconBar?: InputMaybe<CfFooterIconBarItemNestedFilter>;
  footerIconBarCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerMetaLinks?: InputMaybe<CfCtaNestedFilter>;
  footerMetaLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerNewsletterText?: InputMaybe<CfFooterNewsletterNestedFilter>;
  footerNewsletterText_exists?: InputMaybe<Scalars['Boolean']>;
  footerNote?: InputMaybe<CfRteNestedFilter>;
  footerNote_exists?: InputMaybe<Scalars['Boolean']>;
  logoGridNewsletterSuccessPage?: InputMaybe<CfLogoGridNestedFilter>;
  logoGridNewsletterSuccessPage_exists?: InputMaybe<Scalars['Boolean']>;
  mainMegaNavigation?: InputMaybe<CfMegaNavigationNestedFilter>;
  mainMegaNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  mainNavigation?: InputMaybe<CfNavigationNestedFilter>;
  mainNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  meta?: InputMaybe<CfSeoNestedFilter>;
  meta_exists?: InputMaybe<Scalars['Boolean']>;
  navigationTheme?: InputMaybe<Scalars['String']>;
  navigationTheme_contains?: InputMaybe<Scalars['String']>;
  navigationTheme_exists?: InputMaybe<Scalars['Boolean']>;
  navigationTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  navigationTheme_not?: InputMaybe<Scalars['String']>;
  navigationTheme_not_contains?: InputMaybe<Scalars['String']>;
  navigationTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterConfirmationHelpLinks?: InputMaybe<CfCtaNestedFilter>;
  newsletterConfirmationHelpLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  pageNewsletter?: InputMaybe<CfNewsletterNestedFilter>;
  pageNewsletter_exists?: InputMaybe<Scalars['Boolean']>;
  preventIndexing?: InputMaybe<Scalars['Boolean']>;
  preventIndexing_exists?: InputMaybe<Scalars['Boolean']>;
  preventIndexing_not?: InputMaybe<Scalars['Boolean']>;
  productAugmentedReality?: InputMaybe<CfAugmentedRealityNestedFilter>;
  productAugmentedReality_exists?: InputMaybe<Scalars['Boolean']>;
  productBenefits?: InputMaybe<CfProductBenefitNestedFilter>;
  productBenefitsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  relatedPage?: InputMaybe<CfPageNestedFilter>;
  relatedPage_exists?: InputMaybe<Scalars['Boolean']>;
  searchHelpLinks?: InputMaybe<CfCtaNestedFilter>;
  searchHelpLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  secondaryBanderole?: InputMaybe<CfSecondaryBanderoleNestedFilter>;
  secondaryBanderole_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  socialFooterIcons?: InputMaybe<CfSocialIconNestedFilter>;
  socialFooterIconsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  stage?: InputMaybe<CfStageNestedFilter>;
  stageModule?: InputMaybe<CfHeroStageModuleNestedFilter>;
  stageModule_exists?: InputMaybe<Scalars['Boolean']>;
  stage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageFooterColumnsCollection = {
  __typename?: 'PageFooterColumnsCollection';
  items: Array<Maybe<Navigation>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageFooterColumnsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export type PageFooterIconBarCollection = {
  __typename?: 'PageFooterIconBarCollection';
  items: Array<Maybe<FooterIconBarItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageFooterIconBarCollectionOrder {
  BoldTextAsc = 'boldText_ASC',
  BoldTextDesc = 'boldText_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  NormalTextAsc = 'normalText_ASC',
  NormalTextDesc = 'normalText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PageFooterMetaLinksCollection = {
  __typename?: 'PageFooterMetaLinksCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageFooterMetaLinksCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PageLinkingCollections = {
  __typename?: 'PageLinkingCollections';
  categorySliderModuleItemCollection?: Maybe<CategorySliderModuleItemCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  navCategoryWithElementsCollection?: Maybe<NavCategoryWithElementsCollection>;
  navigationElementCollection?: Maybe<NavigationElementCollection>;
  navigationElementWithSubElementsCollection?: Maybe<NavigationElementWithSubElementsCollection>;
  navigationListElementCollection?: Maybe<NavigationListElementCollection>;
  pageCollection?: Maybe<PageCollection>;
  productListPageTeaserItemCollection?: Maybe<ProductListPageTeaserItemCollection>;
};


export type PageLinkingCollectionsCategorySliderModuleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsCategorySliderModuleItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsNavCategoryWithElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavCategoryWithElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsNavigationElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsNavigationElementWithSubElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationElementWithSubElementsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsNavigationListElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type PageLinkingCollectionsProductListPageTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageLinkingCollectionsProductListPageTeaserItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum PageLinkingCollectionsCategorySliderModuleItemCollectionOrder {
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsNavCategoryWithElementsCollectionOrder {
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsNavigationElementCollectionOrder {
  ColorHexAsc = 'colorHex_ASC',
  ColorHexDesc = 'colorHex_DESC',
  ColorfulAsc = 'colorful_ASC',
  ColorfulDesc = 'colorful_DESC',
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsNavigationElementWithSubElementsCollectionOrder {
  HighlightedColorAsc = 'highlightedColor_ASC',
  HighlightedColorDesc = 'highlightedColor_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsNavigationListElementCollectionOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageLinkingCollectionsProductListPageTeaserItemCollectionOrder {
  CategoryUrlAsc = 'categoryUrl_ASC',
  CategoryUrlDesc = 'categoryUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PageNewsletterConfirmationHelpLinksCollection = {
  __typename?: 'PageNewsletterConfirmationHelpLinksCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageNewsletterConfirmationHelpLinksCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PageOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PageProductBenefitsCollection = {
  __typename?: 'PageProductBenefitsCollection';
  items: Array<Maybe<ProductBenefit>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageProductBenefitsCollectionOrder {
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PageSearchHelpLinksCollection = {
  __typename?: 'PageSearchHelpLinksCollection';
  items: Array<Maybe<Cta>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageSearchHelpLinksCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type PageSocialFooterIconsCollection = {
  __typename?: 'PageSocialFooterIconsCollection';
  items: Array<Maybe<SocialIcon>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PageSocialFooterIconsCollectionOrder {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  InternTitileAsc = 'internTitile_ASC',
  InternTitileDesc = 'internTitile_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** A magento product [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/product) */
export type Product = Entry & _Node & {
  __typename?: 'Product';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ProductLinkingCollections>;
  skUs?: Maybe<Array<Maybe<Scalars['String']>>>;
  sys: Sys;
};


/** A magento product [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/product) */
export type ProductInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A magento product [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/product) */
export type ProductLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A magento product [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/product) */
export type ProductSkUsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

/** A field to show the benefits of the product, e.g free shipping. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productBenefit) */
export type ProductBenefit = Entry & _Node & {
  __typename?: 'ProductBenefit';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headlineIntern?: Maybe<Scalars['String']>;
  icon?: Maybe<Asset>;
  linkedFrom?: Maybe<ProductBenefitLinkingCollections>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


/** A field to show the benefits of the product, e.g free shipping. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productBenefit) */
export type ProductBenefitHeadlineInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A field to show the benefits of the product, e.g free shipping. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productBenefit) */
export type ProductBenefitIconArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** A field to show the benefits of the product, e.g free shipping. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productBenefit) */
export type ProductBenefitLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A field to show the benefits of the product, e.g free shipping. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productBenefit) */
export type ProductBenefitTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A field to show the benefits of the product, e.g free shipping. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productBenefit) */
export type ProductBenefitTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ProductBenefitCollection = {
  __typename?: 'ProductBenefitCollection';
  items: Array<Maybe<ProductBenefit>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductBenefitFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductBenefitFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductBenefitFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineIntern?: InputMaybe<Scalars['String']>;
  headlineIntern_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_exists?: InputMaybe<Scalars['Boolean']>;
  headlineIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIntern_not?: InputMaybe<Scalars['String']>;
  headlineIntern_not_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductBenefitLinkingCollections = {
  __typename?: 'ProductBenefitLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ProductBenefitLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductBenefitLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductBenefitLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ProductBenefitLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductBenefitOrder {
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ProductCollection = {
  __typename?: 'ProductCollection';
  items: Array<Maybe<Product>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skUs_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skUs_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skUs_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skUs_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type ProductLinkingCollections = {
  __typename?: 'ProductLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type ProductLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

/** Module to be used on the top of product list page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaser) */
export type ProductListPageTeaser = Entry & _Node & {
  __typename?: 'ProductListPageTeaser';
  _id: Scalars['ID'];
  categoriesCollection?: Maybe<ProductListPageTeaserCategoriesCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<ProductListPageTeaserLinkingCollections>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** Module to be used on the top of product list page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaser) */
export type ProductListPageTeaserCategoriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductListPageTeaserCategoriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductListPageTeaserItemFilter>;
};


/** Module to be used on the top of product list page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaser) */
export type ProductListPageTeaserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Module to be used on the top of product list page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaser) */
export type ProductListPageTeaserSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module to be used on the top of product list page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaser) */
export type ProductListPageTeaserSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Module to be used on the top of product list page [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaser) */
export type ProductListPageTeaserTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ProductListPageTeaserCategoriesCollection = {
  __typename?: 'ProductListPageTeaserCategoriesCollection';
  items: Array<Maybe<ProductListPageTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ProductListPageTeaserCategoriesCollectionOrder {
  CategoryUrlAsc = 'categoryUrl_ASC',
  CategoryUrlDesc = 'categoryUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ProductListPageTeaserCollection = {
  __typename?: 'ProductListPageTeaserCollection';
  items: Array<Maybe<ProductListPageTeaser>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductListPageTeaserFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductListPageTeaserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductListPageTeaserFilter>>>;
  categories?: InputMaybe<CfProductListPageTeaserItemNestedFilter>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItem = Entry & _Node & {
  __typename?: 'ProductListPageTeaserItem';
  _id: Scalars['ID'];
  bynderDesktopImage?: Maybe<Scalars['JSON']>;
  bynderMobileImage?: Maybe<Scalars['JSON']>;
  categoryUrl?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  desktopImage?: Maybe<Asset>;
  linkExistingPage?: Maybe<Page>;
  linkedFrom?: Maybe<ProductListPageTeaserItemLinkingCollections>;
  mobileImage?: Maybe<Asset>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemBynderDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemBynderMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemCategoryUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemLinkExistingPageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productListPageTeaserItem) */
export type ProductListPageTeaserItemTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ProductListPageTeaserItemCollection = {
  __typename?: 'ProductListPageTeaserItemCollection';
  items: Array<Maybe<ProductListPageTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductListPageTeaserItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductListPageTeaserItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductListPageTeaserItemFilter>>>;
  bynderDesktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  categoryUrl?: InputMaybe<Scalars['String']>;
  categoryUrl_contains?: InputMaybe<Scalars['String']>;
  categoryUrl_exists?: InputMaybe<Scalars['Boolean']>;
  categoryUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryUrl_not?: InputMaybe<Scalars['String']>;
  categoryUrl_not_contains?: InputMaybe<Scalars['String']>;
  categoryUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  linkExistingPage?: InputMaybe<CfPageNestedFilter>;
  linkExistingPage_exists?: InputMaybe<Scalars['Boolean']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ProductListPageTeaserItemLinkingCollections = {
  __typename?: 'ProductListPageTeaserItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  productListPageTeaserCollection?: Maybe<ProductListPageTeaserCollection>;
};


export type ProductListPageTeaserItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductListPageTeaserItemLinkingCollectionsProductListPageTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductListPageTeaserItemLinkingCollectionsProductListPageTeaserCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ProductListPageTeaserItemLinkingCollectionsProductListPageTeaserCollectionOrder {
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductListPageTeaserItemOrder {
  CategoryUrlAsc = 'categoryUrl_ASC',
  CategoryUrlDesc = 'categoryUrl_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ProductListPageTeaserLinkingCollections = {
  __typename?: 'ProductListPageTeaserLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ProductListPageTeaserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductListPageTeaserLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductListPageTeaserLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ProductListPageTeaserLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductListPageTeaserOrder {
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaser = Entry & _Node & {
  __typename?: 'ProductTeaser';
  _id: Scalars['ID'];
  bynderImage?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  descriptionHeadline?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  imageIsRight?: Maybe<Scalars['Boolean']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ProductTeaserLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
  urlKey?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserDescriptionHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserDescriptionTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserImageIsRightArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to display 1-2 products with editorial content. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productTeaser) */
export type ProductTeaserUrlKeyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ProductTeaserCollection = {
  __typename?: 'ProductTeaserCollection';
  items: Array<Maybe<ProductTeaser>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductTeaserFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductTeaserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductTeaserFilter>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  descriptionHeadline?: InputMaybe<Scalars['String']>;
  descriptionHeadline_contains?: InputMaybe<Scalars['String']>;
  descriptionHeadline_exists?: InputMaybe<Scalars['Boolean']>;
  descriptionHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionHeadline_not?: InputMaybe<Scalars['String']>;
  descriptionHeadline_not_contains?: InputMaybe<Scalars['String']>;
  descriptionHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionText?: InputMaybe<Scalars['String']>;
  descriptionText_contains?: InputMaybe<Scalars['String']>;
  descriptionText_exists?: InputMaybe<Scalars['Boolean']>;
  descriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  descriptionText_not?: InputMaybe<Scalars['String']>;
  descriptionText_not_contains?: InputMaybe<Scalars['String']>;
  descriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageIsRight?: InputMaybe<Scalars['Boolean']>;
  imageIsRight_exists?: InputMaybe<Scalars['Boolean']>;
  imageIsRight_not?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  urlKey_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlKey_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlKey_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlKey_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ProductTeaserLinkingCollections = {
  __typename?: 'ProductTeaserLinkingCollections';
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ProductTeaserLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductTeaserLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductTeaserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductTeaserLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductTeaserLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ProductTeaserLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductTeaserLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductTeaserOrder {
  DescriptionHeadlineAsc = 'descriptionHeadline_ASC',
  DescriptionHeadlineDesc = 'descriptionHeadline_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageIsRightAsc = 'imageIsRight_ASC',
  ImageIsRightDesc = 'imageIsRight_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSlider = Entry & _Node & {
  __typename?: 'ProductsSlider';
  _id: Scalars['ID'];
  cioRecommendationsFilterName?: Maybe<Scalars['String']>;
  cioRecommendationsFilterValue?: Maybe<Scalars['String']>;
  cioRecommendationsId?: Maybe<Scalars['String']>;
  cioRecommendationsResultsLimit?: Maybe<Scalars['Int']>;
  contentfulMetadata: ContentfulMetadata;
  firstTeaser?: Maybe<TeaserItem>;
  h1Headline?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
  headlineIntern?: Maybe<Scalars['String']>;
  lastTeaser?: Maybe<TeaserItem>;
  link?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ProductsSliderLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  skus?: Maybe<Array<Maybe<Scalars['String']>>>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  sys: Sys;
  urlKey?: Maybe<Array<Maybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderCioRecommendationsFilterNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderCioRecommendationsFilterValueArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderCioRecommendationsIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderCioRecommendationsResultsLimitArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderFirstTeaserArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderH1HeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderHeadlineInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderLastTeaserArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderSkusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/productsSlider) */
export type ProductsSliderUrlKeyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ProductsSliderCollection = {
  __typename?: 'ProductsSliderCollection';
  items: Array<Maybe<ProductsSlider>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductsSliderFilter = {
  AND?: InputMaybe<Array<InputMaybe<ProductsSliderFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ProductsSliderFilter>>>;
  cioRecommendationsFilterName?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterName_contains?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterName_exists?: InputMaybe<Scalars['Boolean']>;
  cioRecommendationsFilterName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioRecommendationsFilterName_not?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterName_not_contains?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioRecommendationsFilterValue?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterValue_contains?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterValue_exists?: InputMaybe<Scalars['Boolean']>;
  cioRecommendationsFilterValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioRecommendationsFilterValue_not?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterValue_not_contains?: InputMaybe<Scalars['String']>;
  cioRecommendationsFilterValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioRecommendationsId?: InputMaybe<Scalars['String']>;
  cioRecommendationsId_contains?: InputMaybe<Scalars['String']>;
  cioRecommendationsId_exists?: InputMaybe<Scalars['Boolean']>;
  cioRecommendationsId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioRecommendationsId_not?: InputMaybe<Scalars['String']>;
  cioRecommendationsId_not_contains?: InputMaybe<Scalars['String']>;
  cioRecommendationsId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioRecommendationsResultsLimit?: InputMaybe<Scalars['Int']>;
  cioRecommendationsResultsLimit_exists?: InputMaybe<Scalars['Boolean']>;
  cioRecommendationsResultsLimit_gt?: InputMaybe<Scalars['Int']>;
  cioRecommendationsResultsLimit_gte?: InputMaybe<Scalars['Int']>;
  cioRecommendationsResultsLimit_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  cioRecommendationsResultsLimit_lt?: InputMaybe<Scalars['Int']>;
  cioRecommendationsResultsLimit_lte?: InputMaybe<Scalars['Int']>;
  cioRecommendationsResultsLimit_not?: InputMaybe<Scalars['Int']>;
  cioRecommendationsResultsLimit_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstTeaser?: InputMaybe<CfTeaserItemNestedFilter>;
  firstTeaser_exists?: InputMaybe<Scalars['Boolean']>;
  h1Headline?: InputMaybe<Scalars['Boolean']>;
  h1Headline_exists?: InputMaybe<Scalars['Boolean']>;
  h1Headline_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headlineIntern?: InputMaybe<Scalars['String']>;
  headlineIntern_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_exists?: InputMaybe<Scalars['Boolean']>;
  headlineIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIntern_not?: InputMaybe<Scalars['String']>;
  headlineIntern_not_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lastTeaser?: InputMaybe<CfTeaserItemNestedFilter>;
  lastTeaser_exists?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skus_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skus_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skus_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skus_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  urlKey_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlKey_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlKey_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  urlKey_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ProductsSliderLinkingCollections = {
  __typename?: 'ProductsSliderLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ProductsSliderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ProductsSliderLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductsSliderLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ProductsSliderLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ProductsSliderOrder {
  CioRecommendationsFilterNameAsc = 'cioRecommendationsFilterName_ASC',
  CioRecommendationsFilterNameDesc = 'cioRecommendationsFilterName_DESC',
  CioRecommendationsFilterValueAsc = 'cioRecommendationsFilterValue_ASC',
  CioRecommendationsFilterValueDesc = 'cioRecommendationsFilterValue_DESC',
  CioRecommendationsIdAsc = 'cioRecommendationsId_ASC',
  CioRecommendationsIdDesc = 'cioRecommendationsId_DESC',
  CioRecommendationsResultsLimitAsc = 'cioRecommendationsResultsLimit_ASC',
  CioRecommendationsResultsLimitDesc = 'cioRecommendationsResultsLimit_DESC',
  H1HeadlineAsc = 'h1Headline_ASC',
  H1HeadlineDesc = 'h1Headline_DESC',
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  accordion?: Maybe<Accordion>;
  accordionCollection?: Maybe<AccordionCollection>;
  accordionItem?: Maybe<AccordionItem>;
  accordionItemCollection?: Maybe<AccordionItemCollection>;
  arPdpBox?: Maybe<ArPdpBox>;
  arPdpBoxCollection?: Maybe<ArPdpBoxCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  augmentedReality?: Maybe<AugmentedReality>;
  augmentedRealityCollection?: Maybe<AugmentedRealityCollection>;
  banderole?: Maybe<Banderole>;
  banderoleCollection?: Maybe<BanderoleCollection>;
  banderoleCountDown?: Maybe<BanderoleCountDown>;
  banderoleCountDownCollection?: Maybe<BanderoleCountDownCollection>;
  banderoleItem?: Maybe<BanderoleItem>;
  banderoleItemCollection?: Maybe<BanderoleItemCollection>;
  banderoleNesletter?: Maybe<BanderoleNesletter>;
  banderoleNesletterCollection?: Maybe<BanderoleNesletterCollection>;
  blackfridayNewsletterModule?: Maybe<BlackfridayNewsletterModule>;
  blackfridayNewsletterModuleCollection?: Maybe<BlackfridayNewsletterModuleCollection>;
  blogCategory?: Maybe<BlogCategory>;
  blogCategoryCollection?: Maybe<BlogCategoryCollection>;
  blogContent?: Maybe<BlogContent>;
  blogContentCollection?: Maybe<BlogContentCollection>;
  blogOverviewModule?: Maybe<BlogOverviewModule>;
  blogOverviewModuleCollection?: Maybe<BlogOverviewModuleCollection>;
  blogTeaserItem?: Maybe<BlogTeaserItem>;
  blogTeaserItemCollection?: Maybe<BlogTeaserItemCollection>;
  categorySliderModule?: Maybe<CategorySliderModule>;
  categorySliderModuleCollection?: Maybe<CategorySliderModuleCollection>;
  categorySliderModuleItem?: Maybe<CategorySliderModuleItem>;
  categorySliderModuleItemCollection?: Maybe<CategorySliderModuleItemCollection>;
  corporateNavigation?: Maybe<CorporateNavigation>;
  corporateNavigationCollection?: Maybe<CorporateNavigationCollection>;
  corporateNavigationListElement?: Maybe<CorporateNavigationListElement>;
  corporateNavigationListElementCollection?: Maybe<CorporateNavigationListElementCollection>;
  corporatePage?: Maybe<CorporatePage>;
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  counterElement?: Maybe<CounterElement>;
  counterElementCollection?: Maybe<CounterElementCollection>;
  counterModule?: Maybe<CounterModule>;
  counterModuleCollection?: Maybe<CounterModuleCollection>;
  cta?: Maybe<Cta>;
  ctaCollection?: Maybe<CtaCollection>;
  customNewsletter?: Maybe<CustomNewsletter>;
  customNewsletterCollection?: Maybe<CustomNewsletterCollection>;
  dataLayerMeta?: Maybe<DataLayerMeta>;
  dataLayerMetaCollection?: Maybe<DataLayerMetaCollection>;
  editorialGallery?: Maybe<EditorialGallery>;
  editorialGalleryCollection?: Maybe<EditorialGalleryCollection>;
  entryCollection?: Maybe<EntryCollection>;
  footerIconBarItem?: Maybe<FooterIconBarItem>;
  footerIconBarItemCollection?: Maybe<FooterIconBarItemCollection>;
  footerNewsletter?: Maybe<FooterNewsletter>;
  footerNewsletterCollection?: Maybe<FooterNewsletterCollection>;
  heroStageItem?: Maybe<HeroStageItem>;
  heroStageItemCollection?: Maybe<HeroStageItemCollection>;
  heroStageModule?: Maybe<HeroStageModule>;
  heroStageModuleCollection?: Maybe<HeroStageModuleCollection>;
  hiddenHeadingH1?: Maybe<HiddenHeadingH1>;
  hiddenHeadingH1Collection?: Maybe<HiddenHeadingH1Collection>;
  imageModule?: Maybe<ImageModule>;
  imageModuleCollection?: Maybe<ImageModuleCollection>;
  imageModuleItem?: Maybe<ImageModuleItem>;
  imageModuleItemCollection?: Maybe<ImageModuleItemCollection>;
  instagramModule?: Maybe<InstagramModule>;
  instagramModuleCollection?: Maybe<InstagramModuleCollection>;
  javascriptModule?: Maybe<JavascriptModule>;
  javascriptModuleCollection?: Maybe<JavascriptModuleCollection>;
  logoGrid?: Maybe<LogoGrid>;
  logoGridCollection?: Maybe<LogoGridCollection>;
  lookbook?: Maybe<Lookbook>;
  lookbookCollection?: Maybe<LookbookCollection>;
  megaNavigation?: Maybe<MegaNavigation>;
  megaNavigationCollection?: Maybe<MegaNavigationCollection>;
  multiTeaser?: Maybe<MultiTeaser>;
  multiTeaserCollection?: Maybe<MultiTeaserCollection>;
  multiTeaserItem?: Maybe<MultiTeaserItem>;
  multiTeaserItemCollection?: Maybe<MultiTeaserItemCollection>;
  navCategoryWithElements?: Maybe<NavCategoryWithElements>;
  navCategoryWithElementsCollection?: Maybe<NavCategoryWithElementsCollection>;
  navigation?: Maybe<Navigation>;
  navigationCollection?: Maybe<NavigationCollection>;
  navigationColumn?: Maybe<NavigationColumn>;
  navigationColumnCollection?: Maybe<NavigationColumnCollection>;
  navigationElement?: Maybe<NavigationElement>;
  navigationElementCollection?: Maybe<NavigationElementCollection>;
  navigationElementWithSubElements?: Maybe<NavigationElementWithSubElements>;
  navigationElementWithSubElementsCollection?: Maybe<NavigationElementWithSubElementsCollection>;
  navigationListElement?: Maybe<NavigationListElement>;
  navigationListElementCollection?: Maybe<NavigationListElementCollection>;
  newsletter?: Maybe<Newsletter>;
  newsletterCollection?: Maybe<NewsletterCollection>;
  newsletterModule?: Maybe<NewsletterModule>;
  newsletterModuleCollection?: Maybe<NewsletterModuleCollection>;
  page?: Maybe<Page>;
  pageCollection?: Maybe<PageCollection>;
  product?: Maybe<Product>;
  productBenefit?: Maybe<ProductBenefit>;
  productBenefitCollection?: Maybe<ProductBenefitCollection>;
  productCollection?: Maybe<ProductCollection>;
  productListPageTeaser?: Maybe<ProductListPageTeaser>;
  productListPageTeaserCollection?: Maybe<ProductListPageTeaserCollection>;
  productListPageTeaserItem?: Maybe<ProductListPageTeaserItem>;
  productListPageTeaserItemCollection?: Maybe<ProductListPageTeaserItemCollection>;
  productTeaser?: Maybe<ProductTeaser>;
  productTeaserCollection?: Maybe<ProductTeaserCollection>;
  productsSlider?: Maybe<ProductsSlider>;
  productsSliderCollection?: Maybe<ProductsSliderCollection>;
  quote?: Maybe<Quote>;
  quoteCollection?: Maybe<QuoteCollection>;
  rte?: Maybe<Rte>;
  rteCollection?: Maybe<RteCollection>;
  secondaryBanderole?: Maybe<SecondaryBanderole>;
  secondaryBanderoleCollection?: Maybe<SecondaryBanderoleCollection>;
  secondaryBanderoleItem?: Maybe<SecondaryBanderoleItem>;
  secondaryBanderoleItemCollection?: Maybe<SecondaryBanderoleItemCollection>;
  seo?: Maybe<Seo>;
  seoCollection?: Maybe<SeoCollection>;
  seoHeadingModule?: Maybe<SeoHeadingModule>;
  seoHeadingModuleCollection?: Maybe<SeoHeadingModuleCollection>;
  seoText?: Maybe<SeoText>;
  seoTextCollection?: Maybe<SeoTextCollection>;
  seoTextModule?: Maybe<SeoTextModule>;
  seoTextModuleCollection?: Maybe<SeoTextModuleCollection>;
  shopTheLook?: Maybe<ShopTheLook>;
  shopTheLookCollection?: Maybe<ShopTheLookCollection>;
  shopTheLookItem?: Maybe<ShopTheLookItem>;
  shopTheLookItemCollection?: Maybe<ShopTheLookItemCollection>;
  socialIcon?: Maybe<SocialIcon>;
  socialIconCollection?: Maybe<SocialIconCollection>;
  stage?: Maybe<Stage>;
  stageCollection?: Maybe<StageCollection>;
  tabModule?: Maybe<TabModule>;
  tabModuleCollection?: Maybe<TabModuleCollection>;
  teaserItem?: Maybe<TeaserItem>;
  teaserItemCollection?: Maybe<TeaserItemCollection>;
  teaserModule?: Maybe<TeaserModule>;
  teaserModuleCollection?: Maybe<TeaserModuleCollection>;
  textImageTeaser?: Maybe<TextImageTeaser>;
  textImageTeaserCollection?: Maybe<TextImageTeaserCollection>;
  textPicModule?: Maybe<TextPicModule>;
  textPicModuleCollection?: Maybe<TextPicModuleCollection>;
  textPicTeaserItem?: Maybe<TextPicTeaserItem>;
  textPicTeaserItemCollection?: Maybe<TextPicTeaserItemCollection>;
  textTeaser?: Maybe<TextTeaser>;
  textTeaserCollection?: Maybe<TextTeaserCollection>;
  tocModule?: Maybe<TocModule>;
  tocModuleCollection?: Maybe<TocModuleCollection>;
  video?: Maybe<Video>;
  videoCollection?: Maybe<VideoCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAccordionArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAccordionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccordionFilter>;
};


export type QueryAccordionItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AccordionItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccordionItemFilter>;
};


export type QueryArPdpBoxArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryArPdpBoxCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ArPdpBoxOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ArPdpBoxFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryAugmentedRealityArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAugmentedRealityCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<AugmentedRealityOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AugmentedRealityFilter>;
};


export type QueryBanderoleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBanderoleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BanderoleFilter>;
};


export type QueryBanderoleCountDownArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBanderoleCountDownCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleCountDownOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BanderoleCountDownFilter>;
};


export type QueryBanderoleItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBanderoleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BanderoleItemFilter>;
};


export type QueryBanderoleNesletterArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBanderoleNesletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BanderoleNesletterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BanderoleNesletterFilter>;
};


export type QueryBlackfridayNewsletterModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBlackfridayNewsletterModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlackfridayNewsletterModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlackfridayNewsletterModuleFilter>;
};


export type QueryBlogCategoryArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBlogCategoryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogCategoryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogCategoryFilter>;
};


export type QueryBlogContentArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBlogContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogContentOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogContentFilter>;
};


export type QueryBlogOverviewModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBlogOverviewModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogOverviewModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogOverviewModuleFilter>;
};


export type QueryBlogTeaserItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryBlogTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<BlogTeaserItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BlogTeaserItemFilter>;
};


export type QueryCategorySliderModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategorySliderModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CategorySliderModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategorySliderModuleFilter>;
};


export type QueryCategorySliderModuleItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCategorySliderModuleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CategorySliderModuleItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategorySliderModuleItemFilter>;
};


export type QueryCorporateNavigationArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCorporateNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CorporateNavigationFilter>;
};


export type QueryCorporateNavigationListElementArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCorporateNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporateNavigationListElementOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CorporateNavigationListElementFilter>;
};


export type QueryCorporatePageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CorporatePageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CorporatePageFilter>;
};


export type QueryCounterElementArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCounterElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CounterElementOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CounterElementFilter>;
};


export type QueryCounterModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCounterModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CounterModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CounterModuleFilter>;
};


export type QueryCtaArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CtaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CtaFilter>;
};


export type QueryCustomNewsletterArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCustomNewsletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<CustomNewsletterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomNewsletterFilter>;
};


export type QueryDataLayerMetaArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDataLayerMetaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<DataLayerMetaOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DataLayerMetaFilter>;
};


export type QueryEditorialGalleryArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEditorialGalleryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EditorialGalleryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EditorialGalleryFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryFooterIconBarItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFooterIconBarItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterIconBarItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterIconBarItemFilter>;
};


export type QueryFooterNewsletterArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFooterNewsletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<FooterNewsletterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FooterNewsletterFilter>;
};


export type QueryHeroStageItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeroStageItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroStageItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeroStageItemFilter>;
};


export type QueryHeroStageModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHeroStageModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HeroStageModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HeroStageModuleFilter>;
};


export type QueryHiddenHeadingH1Args = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHiddenHeadingH1CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<HiddenHeadingH1Order>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HiddenHeadingH1Filter>;
};


export type QueryImageModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryImageModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ImageModuleFilter>;
};


export type QueryImageModuleItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryImageModuleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ImageModuleItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ImageModuleItemFilter>;
};


export type QueryInstagramModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInstagramModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<InstagramModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InstagramModuleFilter>;
};


export type QueryJavascriptModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryJavascriptModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<JavascriptModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JavascriptModuleFilter>;
};


export type QueryLogoGridArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLogoGridCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LogoGridOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LogoGridFilter>;
};


export type QueryLookbookArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLookbookCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<LookbookOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LookbookFilter>;
};


export type QueryMegaNavigationArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMegaNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MegaNavigationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MegaNavigationFilter>;
};


export type QueryMultiTeaserArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMultiTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MultiTeaserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MultiTeaserFilter>;
};


export type QueryMultiTeaserItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMultiTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<MultiTeaserItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MultiTeaserItemFilter>;
};


export type QueryNavCategoryWithElementsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavCategoryWithElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavCategoryWithElementsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavCategoryWithElementsFilter>;
};


export type QueryNavigationArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationFilter>;
};


export type QueryNavigationColumnArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavigationColumnCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationColumnOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationColumnFilter>;
};


export type QueryNavigationElementArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavigationElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationElementOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationElementFilter>;
};


export type QueryNavigationElementWithSubElementsArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavigationElementWithSubElementsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationElementWithSubElementsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationElementWithSubElementsFilter>;
};


export type QueryNavigationListElementArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NavigationListElementOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NavigationListElementFilter>;
};


export type QueryNewsletterArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNewsletterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsletterOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NewsletterFilter>;
};


export type QueryNewsletterModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNewsletterModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<NewsletterModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NewsletterModuleFilter>;
};


export type QueryPageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<PageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageFilter>;
};


export type QueryProductArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductBenefitArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductBenefitCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductBenefitOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductBenefitFilter>;
};


export type QueryProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFilter>;
};


export type QueryProductListPageTeaserArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductListPageTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductListPageTeaserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductListPageTeaserFilter>;
};


export type QueryProductListPageTeaserItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductListPageTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductListPageTeaserItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductListPageTeaserItemFilter>;
};


export type QueryProductTeaserArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductTeaserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductTeaserFilter>;
};


export type QueryProductsSliderArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryProductsSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ProductsSliderOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsSliderFilter>;
};


export type QueryQuoteArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<QuoteOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuoteFilter>;
};


export type QueryRteArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RteOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RteFilter>;
};


export type QuerySecondaryBanderoleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySecondaryBanderoleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SecondaryBanderoleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryBanderoleFilter>;
};


export type QuerySecondaryBanderoleItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySecondaryBanderoleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SecondaryBanderoleItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryBanderoleItemFilter>;
};


export type QuerySeoArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoFilter>;
};


export type QuerySeoHeadingModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeoHeadingModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoHeadingModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoHeadingModuleFilter>;
};


export type QuerySeoTextArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeoTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoTextOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoTextFilter>;
};


export type QuerySeoTextModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeoTextModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoTextModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoTextModuleFilter>;
};


export type QueryShopTheLookArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryShopTheLookCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopTheLookFilter>;
};


export type QueryShopTheLookItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryShopTheLookItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopTheLookItemFilter>;
};


export type QuerySocialIconArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySocialIconCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SocialIconOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SocialIconFilter>;
};


export type QueryStageArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<StageOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StageFilter>;
};


export type QueryTabModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTabModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TabModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TabModuleFilter>;
};


export type QueryTeaserItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeaserItemFilter>;
};


export type QueryTeaserModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTeaserModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeaserModuleFilter>;
};


export type QueryTextImageTeaserArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTextImageTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextImageTeaserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextImageTeaserFilter>;
};


export type QueryTextPicModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTextPicModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextPicModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextPicModuleFilter>;
};


export type QueryTextPicTeaserItemArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTextPicTeaserItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextPicTeaserItemOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextPicTeaserItemFilter>;
};


export type QueryTextTeaserArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTextTeaserCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextTeaserOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextTeaserFilter>;
};


export type QueryTocModuleArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTocModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TocModuleOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TocModuleFilter>;
};


export type QueryVideoArgs = {
  id: Scalars['String'];
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


export type QueryVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoFilter>;
};

/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type Quote = Entry & _Node & {
  __typename?: 'Quote';
  _id: Scalars['ID'];
  bynderImage?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  image?: Maybe<Asset>;
  isSimpleVariant?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<QuoteLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organicShapeColor?: Maybe<Scalars['String']>;
  quoteAuthorInfo?: Maybe<Scalars['String']>;
  quoteAuthorName?: Maybe<Scalars['String']>;
  quoteText?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteIsSimpleVariantArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteOrganicShapeColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteQuoteAuthorInfoArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteQuoteAuthorNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A module to show a quote. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/quote) */
export type QuoteQuoteTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type QuoteCollection = {
  __typename?: 'QuoteCollection';
  items: Array<Maybe<Quote>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type QuoteFilter = {
  AND?: InputMaybe<Array<InputMaybe<QuoteFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<QuoteFilter>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  isSimpleVariant?: InputMaybe<Scalars['Boolean']>;
  isSimpleVariant_exists?: InputMaybe<Scalars['Boolean']>;
  isSimpleVariant_not?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organicShapeColor?: InputMaybe<Scalars['String']>;
  organicShapeColor_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_exists?: InputMaybe<Scalars['Boolean']>;
  organicShapeColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organicShapeColor_not?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteAuthorInfo?: InputMaybe<Scalars['String']>;
  quoteAuthorInfo_contains?: InputMaybe<Scalars['String']>;
  quoteAuthorInfo_exists?: InputMaybe<Scalars['Boolean']>;
  quoteAuthorInfo_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteAuthorInfo_not?: InputMaybe<Scalars['String']>;
  quoteAuthorInfo_not_contains?: InputMaybe<Scalars['String']>;
  quoteAuthorInfo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteAuthorName?: InputMaybe<Scalars['String']>;
  quoteAuthorName_contains?: InputMaybe<Scalars['String']>;
  quoteAuthorName_exists?: InputMaybe<Scalars['Boolean']>;
  quoteAuthorName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteAuthorName_not?: InputMaybe<Scalars['String']>;
  quoteAuthorName_not_contains?: InputMaybe<Scalars['String']>;
  quoteAuthorName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteText?: InputMaybe<Scalars['String']>;
  quoteText_contains?: InputMaybe<Scalars['String']>;
  quoteText_exists?: InputMaybe<Scalars['Boolean']>;
  quoteText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  quoteText_not?: InputMaybe<Scalars['String']>;
  quoteText_not_contains?: InputMaybe<Scalars['String']>;
  quoteText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type QuoteLinkingCollections = {
  __typename?: 'QuoteLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type QuoteLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuoteLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuoteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuoteLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<QuoteLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum QuoteLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum QuoteOrder {
  IsSimpleVariantAsc = 'isSimpleVariant_ASC',
  IsSimpleVariantDesc = 'isSimpleVariant_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OrganicShapeColorAsc = 'organicShapeColor_ASC',
  OrganicShapeColorDesc = 'organicShapeColor_DESC',
  QuoteAuthorInfoAsc = 'quoteAuthorInfo_ASC',
  QuoteAuthorInfoDesc = 'quoteAuthorInfo_DESC',
  QuoteAuthorNameAsc = 'quoteAuthorName_ASC',
  QuoteAuthorNameDesc = 'quoteAuthorName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String'];
  urn: Scalars['String'];
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/rte) */
export type Rte = Entry & _Node & {
  __typename?: 'Rte';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<RteLinkingCollections>;
  rte?: Maybe<RteRte>;
  sys: Sys;
  titleIntern?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/rte) */
export type RteLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/rte) */
export type RteRteArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/rte) */
export type RteTitleInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type RteCollection = {
  __typename?: 'RteCollection';
  items: Array<Maybe<Rte>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type RteFilter = {
  AND?: InputMaybe<Array<InputMaybe<RteFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<RteFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  rte_contains?: InputMaybe<Scalars['String']>;
  rte_exists?: InputMaybe<Scalars['Boolean']>;
  rte_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RteLinkingCollections = {
  __typename?: 'RteLinkingCollections';
  accordionItemCollection?: Maybe<AccordionItemCollection>;
  blogContentCollection?: Maybe<BlogContentCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  imageModuleItemCollection?: Maybe<ImageModuleItemCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type RteLinkingCollectionsAccordionItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RteLinkingCollectionsAccordionItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RteLinkingCollectionsBlogContentCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RteLinkingCollectionsBlogContentCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RteLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RteLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RteLinkingCollectionsImageModuleItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RteLinkingCollectionsImageModuleItemCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RteLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<RteLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum RteLinkingCollectionsAccordionItemCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum RteLinkingCollectionsBlogContentCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum RteLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum RteLinkingCollectionsImageModuleItemCollectionOrder {
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextDirectionAsc = 'textDirection_ASC',
  TextDirectionDesc = 'textDirection_DESC'
}

export enum RteLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum RteOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export type RteRte = {
  __typename?: 'RteRte';
  json: Scalars['JSON'];
  links: RteRteLinks;
};

export type RteRteAssets = {
  __typename?: 'RteRteAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type RteRteEntries = {
  __typename?: 'RteRteEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type RteRteLinks = {
  __typename?: 'RteRteLinks';
  assets: RteRteAssets;
  entries: RteRteEntries;
  resources: RteRteResources;
};

export type RteRteResources = {
  __typename?: 'RteRteResources';
  block: Array<RteRteResourcesBlock>;
  hyperlink: Array<RteRteResourcesHyperlink>;
  inline: Array<RteRteResourcesInline>;
};

export type RteRteResourcesBlock = ResourceLink & {
  __typename?: 'RteRteResourcesBlock';
  sys: ResourceSys;
};

export type RteRteResourcesHyperlink = ResourceLink & {
  __typename?: 'RteRteResourcesHyperlink';
  sys: ResourceSys;
};

export type RteRteResourcesInline = ResourceLink & {
  __typename?: 'RteRteResourcesInline';
  sys: ResourceSys;
};

/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderole = Entry & _Node & {
  __typename?: 'SecondaryBanderole';
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  banderoleContent?: Maybe<SecondaryBanderoleItem>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SecondaryBanderoleLinkingCollections>;
  sticky?: Maybe<Scalars['Boolean']>;
  sys: Sys;
  textColor?: Maybe<Scalars['String']>;
};


/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderoleBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderoleBanderoleContentArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<SecondaryBanderoleItemFilter>;
};


/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderoleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderoleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderoleStickyArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A banderole banner that displays at bottom of the navigation bar. [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderole) */
export type SecondaryBanderoleTextColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SecondaryBanderoleCollection = {
  __typename?: 'SecondaryBanderoleCollection';
  items: Array<Maybe<SecondaryBanderole>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SecondaryBanderoleFilter = {
  AND?: InputMaybe<Array<InputMaybe<SecondaryBanderoleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SecondaryBanderoleFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderoleContent?: InputMaybe<CfSecondaryBanderoleItemNestedFilter>;
  banderoleContent_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  sticky_exists?: InputMaybe<Scalars['Boolean']>;
  sticky_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderoleItem) */
export type SecondaryBanderoleItem = Entry & _Node & {
  __typename?: 'SecondaryBanderoleItem';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SecondaryBanderoleItemLinkingCollections>;
  newsletterText?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderoleItem) */
export type SecondaryBanderoleItemInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderoleItem) */
export type SecondaryBanderoleItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/secondaryBanderoleItem) */
export type SecondaryBanderoleItemNewsletterTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SecondaryBanderoleItemCollection = {
  __typename?: 'SecondaryBanderoleItemCollection';
  items: Array<Maybe<SecondaryBanderoleItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SecondaryBanderoleItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<SecondaryBanderoleItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SecondaryBanderoleItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText?: InputMaybe<Scalars['String']>;
  newsletterText_contains?: InputMaybe<Scalars['String']>;
  newsletterText_exists?: InputMaybe<Scalars['Boolean']>;
  newsletterText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText_not?: InputMaybe<Scalars['String']>;
  newsletterText_not_contains?: InputMaybe<Scalars['String']>;
  newsletterText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SecondaryBanderoleItemLinkingCollections = {
  __typename?: 'SecondaryBanderoleItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  secondaryBanderoleCollection?: Maybe<SecondaryBanderoleCollection>;
};


export type SecondaryBanderoleItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SecondaryBanderoleItemLinkingCollectionsSecondaryBanderoleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SecondaryBanderoleItemLinkingCollectionsSecondaryBanderoleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SecondaryBanderoleItemLinkingCollectionsSecondaryBanderoleCollectionOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  StickyAsc = 'sticky_ASC',
  StickyDesc = 'sticky_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC'
}

export enum SecondaryBanderoleItemOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  NewsletterTextAsc = 'newsletterText_ASC',
  NewsletterTextDesc = 'newsletterText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SecondaryBanderoleLinkingCollections = {
  __typename?: 'SecondaryBanderoleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SecondaryBanderoleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SecondaryBanderoleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SecondaryBanderoleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SecondaryBanderoleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SecondaryBanderoleOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  StickyAsc = 'sticky_ASC',
  StickyDesc = 'sticky_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type Seo = Entry & _Node & {
  __typename?: 'Seo';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  eMailSubject?: Maybe<Scalars['String']>;
  eMailText?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SeoLinkingCollections>;
  ogImage?: Maybe<Asset>;
  ogLocale?: Maybe<Scalars['String']>;
  ogSitename?: Maybe<Scalars['String']>;
  ogTwitterDescription?: Maybe<Scalars['String']>;
  ogTwitterTitle?: Maybe<Scalars['String']>;
  ogUrl?: Maybe<Scalars['String']>;
  seoCanonicalUrl?: Maybe<Scalars['String']>;
  seoDescription?: Maybe<Scalars['String']>;
  seoKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  seoNoFollow?: Maybe<Scalars['Boolean']>;
  seoNoIndex?: Maybe<Scalars['Boolean']>;
  seoTitle?: Maybe<Scalars['String']>;
  sys: Sys;
  twitterCreatorId?: Maybe<Scalars['String']>;
  twitterImage?: Maybe<Asset>;
  twitterTweetText?: Maybe<Scalars['String']>;
  whatsappImage?: Maybe<Asset>;
  whatsappText?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoEMailSubjectArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoEMailTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoOgImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoOgLocaleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoOgSitenameArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoOgTwitterDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoOgTwitterTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoOgUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoSeoCanonicalUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoSeoDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoSeoKeywordsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoSeoNoFollowArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoSeoNoIndexArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoSeoTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoTwitterCreatorIdArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoTwitterImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoTwitterTweetTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoWhatsappImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seo) */
export type SeoWhatsappTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SeoCollection = {
  __typename?: 'SeoCollection';
  items: Array<Maybe<Seo>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SeoFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eMailSubject?: InputMaybe<Scalars['String']>;
  eMailSubject_contains?: InputMaybe<Scalars['String']>;
  eMailSubject_exists?: InputMaybe<Scalars['Boolean']>;
  eMailSubject_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailSubject_not?: InputMaybe<Scalars['String']>;
  eMailSubject_not_contains?: InputMaybe<Scalars['String']>;
  eMailSubject_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailText?: InputMaybe<Scalars['String']>;
  eMailText_contains?: InputMaybe<Scalars['String']>;
  eMailText_exists?: InputMaybe<Scalars['Boolean']>;
  eMailText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailText_not?: InputMaybe<Scalars['String']>;
  eMailText_not_contains?: InputMaybe<Scalars['String']>;
  eMailText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']>;
  ogLocale?: InputMaybe<Scalars['String']>;
  ogLocale_contains?: InputMaybe<Scalars['String']>;
  ogLocale_exists?: InputMaybe<Scalars['Boolean']>;
  ogLocale_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogLocale_not?: InputMaybe<Scalars['String']>;
  ogLocale_not_contains?: InputMaybe<Scalars['String']>;
  ogLocale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogSitename?: InputMaybe<Scalars['String']>;
  ogSitename_contains?: InputMaybe<Scalars['String']>;
  ogSitename_exists?: InputMaybe<Scalars['Boolean']>;
  ogSitename_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogSitename_not?: InputMaybe<Scalars['String']>;
  ogSitename_not_contains?: InputMaybe<Scalars['String']>;
  ogSitename_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterDescription?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_contains?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_exists?: InputMaybe<Scalars['Boolean']>;
  ogTwitterDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterDescription_not?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_not_contains?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterTitle?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_contains?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_exists?: InputMaybe<Scalars['Boolean']>;
  ogTwitterTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterTitle_not?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_not_contains?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogUrl?: InputMaybe<Scalars['String']>;
  ogUrl_contains?: InputMaybe<Scalars['String']>;
  ogUrl_exists?: InputMaybe<Scalars['Boolean']>;
  ogUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogUrl_not?: InputMaybe<Scalars['String']>;
  ogUrl_not_contains?: InputMaybe<Scalars['String']>;
  ogUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_contains?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_exists?: InputMaybe<Scalars['Boolean']>;
  seoCanonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoCanonicalUrl_not?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_not_contains?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoDescription_contains?: InputMaybe<Scalars['String']>;
  seoDescription_exists?: InputMaybe<Scalars['Boolean']>;
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoDescription_not?: InputMaybe<Scalars['String']>;
  seoDescription_not_contains?: InputMaybe<Scalars['String']>;
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_exists?: InputMaybe<Scalars['Boolean']>;
  seoNoFollow?: InputMaybe<Scalars['Boolean']>;
  seoNoFollow_exists?: InputMaybe<Scalars['Boolean']>;
  seoNoFollow_not?: InputMaybe<Scalars['Boolean']>;
  seoNoIndex?: InputMaybe<Scalars['Boolean']>;
  seoNoIndex_exists?: InputMaybe<Scalars['Boolean']>;
  seoNoIndex_not?: InputMaybe<Scalars['Boolean']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  seoTitle_contains?: InputMaybe<Scalars['String']>;
  seoTitle_exists?: InputMaybe<Scalars['Boolean']>;
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoTitle_not?: InputMaybe<Scalars['String']>;
  seoTitle_not_contains?: InputMaybe<Scalars['String']>;
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  twitterCreatorId?: InputMaybe<Scalars['String']>;
  twitterCreatorId_contains?: InputMaybe<Scalars['String']>;
  twitterCreatorId_exists?: InputMaybe<Scalars['Boolean']>;
  twitterCreatorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterCreatorId_not?: InputMaybe<Scalars['String']>;
  twitterCreatorId_not_contains?: InputMaybe<Scalars['String']>;
  twitterCreatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterImage_exists?: InputMaybe<Scalars['Boolean']>;
  twitterTweetText?: InputMaybe<Scalars['String']>;
  twitterTweetText_contains?: InputMaybe<Scalars['String']>;
  twitterTweetText_exists?: InputMaybe<Scalars['Boolean']>;
  twitterTweetText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterTweetText_not?: InputMaybe<Scalars['String']>;
  twitterTweetText_not_contains?: InputMaybe<Scalars['String']>;
  twitterTweetText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whatsappImage_exists?: InputMaybe<Scalars['Boolean']>;
  whatsappText?: InputMaybe<Scalars['String']>;
  whatsappText_contains?: InputMaybe<Scalars['String']>;
  whatsappText_exists?: InputMaybe<Scalars['Boolean']>;
  whatsappText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whatsappText_not?: InputMaybe<Scalars['String']>;
  whatsappText_not_contains?: InputMaybe<Scalars['String']>;
  whatsappText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModule = Entry & _Node & {
  __typename?: 'SeoHeadingModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SeoHeadingModuleLinkingCollections>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModuleDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModuleSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModuleSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoHeadingModule) */
export type SeoHeadingModuleSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SeoHeadingModuleCollection = {
  __typename?: 'SeoHeadingModuleCollection';
  items: Array<Maybe<SeoHeadingModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SeoHeadingModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoHeadingModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoHeadingModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_exists?: InputMaybe<Scalars['Boolean']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  description_not?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SeoHeadingModuleLinkingCollections = {
  __typename?: 'SeoHeadingModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SeoHeadingModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SeoHeadingModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoHeadingModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SeoHeadingModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SeoHeadingModuleOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SeoLinkingCollections = {
  __typename?: 'SeoLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SeoLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SeoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SeoLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SeoLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SeoLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SeoOrder {
  EMailSubjectAsc = 'eMailSubject_ASC',
  EMailSubjectDesc = 'eMailSubject_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  OgLocaleAsc = 'ogLocale_ASC',
  OgLocaleDesc = 'ogLocale_DESC',
  OgSitenameAsc = 'ogSitename_ASC',
  OgSitenameDesc = 'ogSitename_DESC',
  OgTwitterTitleAsc = 'ogTwitterTitle_ASC',
  OgTwitterTitleDesc = 'ogTwitterTitle_DESC',
  OgUrlAsc = 'ogUrl_ASC',
  OgUrlDesc = 'ogUrl_DESC',
  SeoCanonicalUrlAsc = 'seoCanonicalUrl_ASC',
  SeoCanonicalUrlDesc = 'seoCanonicalUrl_DESC',
  SeoNoFollowAsc = 'seoNoFollow_ASC',
  SeoNoFollowDesc = 'seoNoFollow_DESC',
  SeoNoIndexAsc = 'seoNoIndex_ASC',
  SeoNoIndexDesc = 'seoNoIndex_DESC',
  SeoTitleAsc = 'seoTitle_ASC',
  SeoTitleDesc = 'seoTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TwitterCreatorIdAsc = 'twitterCreatorId_ASC',
  TwitterCreatorIdDesc = 'twitterCreatorId_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoText) */
export type SeoText = Entry & _Node & {
  __typename?: 'SeoText';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SeoTextLinkingCollections>;
  seoText?: Maybe<SeoTextSeoText>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoText) */
export type SeoTextHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoText) */
export type SeoTextInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoText) */
export type SeoTextLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoText) */
export type SeoTextSeoTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SeoTextCollection = {
  __typename?: 'SeoTextCollection';
  items: Array<Maybe<SeoText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SeoTextFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoTextFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoTextFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoText_contains?: InputMaybe<Scalars['String']>;
  seoText_exists?: InputMaybe<Scalars['Boolean']>;
  seoText_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
};

export type SeoTextLinkingCollections = {
  __typename?: 'SeoTextLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  seoTextModuleCollection?: Maybe<SeoTextModuleCollection>;
};


export type SeoTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SeoTextLinkingCollectionsSeoTextModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoTextLinkingCollectionsSeoTextModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SeoTextLinkingCollectionsSeoTextModuleCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoTextModule) */
export type SeoTextModule = Entry & _Node & {
  __typename?: 'SeoTextModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SeoTextModuleLinkingCollections>;
  seoTextsCollection?: Maybe<SeoTextModuleSeoTextsCollection>;
  spacingBottom?: Maybe<Scalars['String']>;
  spacingTop?: Maybe<Scalars['String']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoTextModule) */
export type SeoTextModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoTextModule) */
export type SeoTextModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoTextModule) */
export type SeoTextModuleSeoTextsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoTextModuleSeoTextsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SeoTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoTextModule) */
export type SeoTextModuleSpacingBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/seoTextModule) */
export type SeoTextModuleSpacingTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SeoTextModuleCollection = {
  __typename?: 'SeoTextModuleCollection';
  items: Array<Maybe<SeoTextModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SeoTextModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<SeoTextModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SeoTextModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoTexts?: InputMaybe<CfSeoTextNestedFilter>;
  seoTextsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type SeoTextModuleLinkingCollections = {
  __typename?: 'SeoTextModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SeoTextModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SeoTextModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SeoTextModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SeoTextModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SeoTextModuleOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SeoTextModuleSeoTextsCollection = {
  __typename?: 'SeoTextModuleSeoTextsCollection';
  items: Array<Maybe<SeoText>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum SeoTextModuleSeoTextsCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SeoTextOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SeoTextSeoText = {
  __typename?: 'SeoTextSeoText';
  json: Scalars['JSON'];
  links: SeoTextSeoTextLinks;
};

export type SeoTextSeoTextAssets = {
  __typename?: 'SeoTextSeoTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SeoTextSeoTextEntries = {
  __typename?: 'SeoTextSeoTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SeoTextSeoTextLinks = {
  __typename?: 'SeoTextSeoTextLinks';
  assets: SeoTextSeoTextAssets;
  entries: SeoTextSeoTextEntries;
  resources: SeoTextSeoTextResources;
};

export type SeoTextSeoTextResources = {
  __typename?: 'SeoTextSeoTextResources';
  block: Array<SeoTextSeoTextResourcesBlock>;
  hyperlink: Array<SeoTextSeoTextResourcesHyperlink>;
  inline: Array<SeoTextSeoTextResourcesInline>;
};

export type SeoTextSeoTextResourcesBlock = ResourceLink & {
  __typename?: 'SeoTextSeoTextResourcesBlock';
  sys: ResourceSys;
};

export type SeoTextSeoTextResourcesHyperlink = ResourceLink & {
  __typename?: 'SeoTextSeoTextResourcesHyperlink';
  sys: ResourceSys;
};

export type SeoTextSeoTextResourcesInline = ResourceLink & {
  __typename?: 'SeoTextSeoTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLook = Entry & _Node & {
  __typename?: 'ShopTheLook';
  _id: Scalars['ID'];
  bynderFirstImage?: Maybe<Scalars['JSON']>;
  bynderFourthImage?: Maybe<Scalars['JSON']>;
  bynderSecondImage?: Maybe<Scalars['JSON']>;
  bynderThirdImage?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  firstImage?: Maybe<Asset>;
  firstImageFocus?: Maybe<Scalars['String']>;
  firstImageFocusMobile?: Maybe<Scalars['String']>;
  firstImageProductButtonsCollection?: Maybe<ShopTheLookFirstImageProductButtonsCollection>;
  fourthImage?: Maybe<Asset>;
  fourthImageFocus?: Maybe<Scalars['String']>;
  fourthImageFocusMobile?: Maybe<Scalars['String']>;
  fourthImageProductButtonsCollection?: Maybe<ShopTheLookFourthImageProductButtonsCollection>;
  headline?: Maybe<Scalars['String']>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ShopTheLookLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  secondImage?: Maybe<Asset>;
  secondImageFocus?: Maybe<Scalars['String']>;
  secondImageFocusMobile?: Maybe<Scalars['String']>;
  secondImageProductButtonsCollection?: Maybe<ShopTheLookSecondImageProductButtonsCollection>;
  sys: Sys;
  thirdImage?: Maybe<Asset>;
  thirdImageFocus?: Maybe<Scalars['String']>;
  thirdImageFocusMobile?: Maybe<Scalars['String']>;
  thirdImageProductButtonsCollection?: Maybe<ShopTheLookThirdImageProductButtonsCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookBynderFirstImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookBynderFourthImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookBynderSecondImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookBynderThirdImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFirstImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFirstImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFirstImageFocusMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFirstImageProductButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookFirstImageProductButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopTheLookItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFourthImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFourthImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFourthImageFocusMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookFourthImageProductButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookFourthImageProductButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopTheLookItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookSecondImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookSecondImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookSecondImageFocusMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookSecondImageProductButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookSecondImageProductButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopTheLookItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookThirdImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookThirdImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookThirdImageFocusMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLook) */
export type ShopTheLookThirdImageProductButtonsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookThirdImageProductButtonsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopTheLookItemFilter>;
};

export type ShopTheLookCollection = {
  __typename?: 'ShopTheLookCollection';
  items: Array<Maybe<ShopTheLook>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ShopTheLookFilter = {
  AND?: InputMaybe<Array<InputMaybe<ShopTheLookFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ShopTheLookFilter>>>;
  bynderFirstImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderFourthImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderSecondImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderThirdImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstImageFocus?: InputMaybe<Scalars['String']>;
  firstImageFocusMobile?: InputMaybe<Scalars['String']>;
  firstImageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  firstImageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  firstImageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstImageFocusMobile_not?: InputMaybe<Scalars['String']>;
  firstImageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  firstImageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstImageFocus_contains?: InputMaybe<Scalars['String']>;
  firstImageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  firstImageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstImageFocus_not?: InputMaybe<Scalars['String']>;
  firstImageFocus_not_contains?: InputMaybe<Scalars['String']>;
  firstImageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstImageProductButtons?: InputMaybe<CfShopTheLookItemNestedFilter>;
  firstImageProductButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  firstImage_exists?: InputMaybe<Scalars['Boolean']>;
  fourthImageFocus?: InputMaybe<Scalars['String']>;
  fourthImageFocusMobile?: InputMaybe<Scalars['String']>;
  fourthImageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  fourthImageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  fourthImageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fourthImageFocusMobile_not?: InputMaybe<Scalars['String']>;
  fourthImageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  fourthImageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fourthImageFocus_contains?: InputMaybe<Scalars['String']>;
  fourthImageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  fourthImageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fourthImageFocus_not?: InputMaybe<Scalars['String']>;
  fourthImageFocus_not_contains?: InputMaybe<Scalars['String']>;
  fourthImageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fourthImageProductButtons?: InputMaybe<CfShopTheLookItemNestedFilter>;
  fourthImageProductButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  fourthImage_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondImageFocus?: InputMaybe<Scalars['String']>;
  secondImageFocusMobile?: InputMaybe<Scalars['String']>;
  secondImageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  secondImageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  secondImageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondImageFocusMobile_not?: InputMaybe<Scalars['String']>;
  secondImageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  secondImageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondImageFocus_contains?: InputMaybe<Scalars['String']>;
  secondImageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  secondImageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondImageFocus_not?: InputMaybe<Scalars['String']>;
  secondImageFocus_not_contains?: InputMaybe<Scalars['String']>;
  secondImageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  secondImageProductButtons?: InputMaybe<CfShopTheLookItemNestedFilter>;
  secondImageProductButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  secondImage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  thirdImageFocus?: InputMaybe<Scalars['String']>;
  thirdImageFocusMobile?: InputMaybe<Scalars['String']>;
  thirdImageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  thirdImageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  thirdImageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thirdImageFocusMobile_not?: InputMaybe<Scalars['String']>;
  thirdImageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  thirdImageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thirdImageFocus_contains?: InputMaybe<Scalars['String']>;
  thirdImageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  thirdImageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thirdImageFocus_not?: InputMaybe<Scalars['String']>;
  thirdImageFocus_not_contains?: InputMaybe<Scalars['String']>;
  thirdImageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thirdImageProductButtons?: InputMaybe<CfShopTheLookItemNestedFilter>;
  thirdImageProductButtonsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  thirdImage_exists?: InputMaybe<Scalars['Boolean']>;
};

export type ShopTheLookFirstImageProductButtonsCollection = {
  __typename?: 'ShopTheLookFirstImageProductButtonsCollection';
  items: Array<Maybe<ShopTheLookItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ShopTheLookFirstImageProductButtonsCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SkuAsc = 'sku_ASC',
  SkuDesc = 'sku_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  XAxisMobileAsc = 'xAxisMobile_ASC',
  XAxisMobileDesc = 'xAxisMobile_DESC',
  XAxisAsc = 'xAxis_ASC',
  XAxisDesc = 'xAxis_DESC',
  YAxisMobileAsc = 'yAxisMobile_ASC',
  YAxisMobileDesc = 'yAxisMobile_DESC',
  YAxisAsc = 'yAxis_ASC',
  YAxisDesc = 'yAxis_DESC'
}

export type ShopTheLookFourthImageProductButtonsCollection = {
  __typename?: 'ShopTheLookFourthImageProductButtonsCollection';
  items: Array<Maybe<ShopTheLookItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ShopTheLookFourthImageProductButtonsCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SkuAsc = 'sku_ASC',
  SkuDesc = 'sku_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  XAxisMobileAsc = 'xAxisMobile_ASC',
  XAxisMobileDesc = 'xAxisMobile_DESC',
  XAxisAsc = 'xAxis_ASC',
  XAxisDesc = 'xAxis_DESC',
  YAxisMobileAsc = 'yAxisMobile_ASC',
  YAxisMobileDesc = 'yAxisMobile_DESC',
  YAxisAsc = 'yAxis_ASC',
  YAxisDesc = 'yAxis_DESC'
}

/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItem = Entry & _Node & {
  __typename?: 'ShopTheLookItem';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<ShopTheLookItemLinkingCollections>;
  sku?: Maybe<Scalars['String']>;
  sys: Sys;
  xAxis?: Maybe<Scalars['Int']>;
  xAxisMobile?: Maybe<Scalars['Int']>;
  yAxis?: Maybe<Scalars['Int']>;
  yAxisMobile?: Maybe<Scalars['Int']>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemSkuArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemXAxisArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemXAxisMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemYAxisArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Product Item that is placed on an image in the Shop-the-Look Module [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/shopTheLookItem) */
export type ShopTheLookItemYAxisMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type ShopTheLookItemCollection = {
  __typename?: 'ShopTheLookItemCollection';
  items: Array<Maybe<ShopTheLookItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type ShopTheLookItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<ShopTheLookItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ShopTheLookItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sku?: InputMaybe<Scalars['String']>;
  sku_contains?: InputMaybe<Scalars['String']>;
  sku_exists?: InputMaybe<Scalars['Boolean']>;
  sku_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sku_not?: InputMaybe<Scalars['String']>;
  sku_not_contains?: InputMaybe<Scalars['String']>;
  sku_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  xAxis?: InputMaybe<Scalars['Int']>;
  xAxisMobile?: InputMaybe<Scalars['Int']>;
  xAxisMobile_exists?: InputMaybe<Scalars['Boolean']>;
  xAxisMobile_gt?: InputMaybe<Scalars['Int']>;
  xAxisMobile_gte?: InputMaybe<Scalars['Int']>;
  xAxisMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  xAxisMobile_lt?: InputMaybe<Scalars['Int']>;
  xAxisMobile_lte?: InputMaybe<Scalars['Int']>;
  xAxisMobile_not?: InputMaybe<Scalars['Int']>;
  xAxisMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  xAxis_exists?: InputMaybe<Scalars['Boolean']>;
  xAxis_gt?: InputMaybe<Scalars['Int']>;
  xAxis_gte?: InputMaybe<Scalars['Int']>;
  xAxis_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  xAxis_lt?: InputMaybe<Scalars['Int']>;
  xAxis_lte?: InputMaybe<Scalars['Int']>;
  xAxis_not?: InputMaybe<Scalars['Int']>;
  xAxis_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxis?: InputMaybe<Scalars['Int']>;
  yAxisMobile?: InputMaybe<Scalars['Int']>;
  yAxisMobile_exists?: InputMaybe<Scalars['Boolean']>;
  yAxisMobile_gt?: InputMaybe<Scalars['Int']>;
  yAxisMobile_gte?: InputMaybe<Scalars['Int']>;
  yAxisMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxisMobile_lt?: InputMaybe<Scalars['Int']>;
  yAxisMobile_lte?: InputMaybe<Scalars['Int']>;
  yAxisMobile_not?: InputMaybe<Scalars['Int']>;
  yAxisMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxis_exists?: InputMaybe<Scalars['Boolean']>;
  yAxis_gt?: InputMaybe<Scalars['Int']>;
  yAxis_gte?: InputMaybe<Scalars['Int']>;
  yAxis_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxis_lt?: InputMaybe<Scalars['Int']>;
  yAxis_lte?: InputMaybe<Scalars['Int']>;
  yAxis_not?: InputMaybe<Scalars['Int']>;
  yAxis_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ShopTheLookItemLinkingCollections = {
  __typename?: 'ShopTheLookItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  shopTheLookCollection?: Maybe<ShopTheLookCollection>;
};


export type ShopTheLookItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ShopTheLookItemLinkingCollectionsShopTheLookCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookItemLinkingCollectionsShopTheLookCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ShopTheLookItemLinkingCollectionsShopTheLookCollectionOrder {
  FirstImageFocusMobileAsc = 'firstImageFocusMobile_ASC',
  FirstImageFocusMobileDesc = 'firstImageFocusMobile_DESC',
  FirstImageFocusAsc = 'firstImageFocus_ASC',
  FirstImageFocusDesc = 'firstImageFocus_DESC',
  FourthImageFocusMobileAsc = 'fourthImageFocusMobile_ASC',
  FourthImageFocusMobileDesc = 'fourthImageFocusMobile_DESC',
  FourthImageFocusAsc = 'fourthImageFocus_ASC',
  FourthImageFocusDesc = 'fourthImageFocus_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SecondImageFocusMobileAsc = 'secondImageFocusMobile_ASC',
  SecondImageFocusMobileDesc = 'secondImageFocusMobile_DESC',
  SecondImageFocusAsc = 'secondImageFocus_ASC',
  SecondImageFocusDesc = 'secondImageFocus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThirdImageFocusMobileAsc = 'thirdImageFocusMobile_ASC',
  ThirdImageFocusMobileDesc = 'thirdImageFocusMobile_DESC',
  ThirdImageFocusAsc = 'thirdImageFocus_ASC',
  ThirdImageFocusDesc = 'thirdImageFocus_DESC'
}

export enum ShopTheLookItemOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SkuAsc = 'sku_ASC',
  SkuDesc = 'sku_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  XAxisMobileAsc = 'xAxisMobile_ASC',
  XAxisMobileDesc = 'xAxisMobile_DESC',
  XAxisAsc = 'xAxis_ASC',
  XAxisDesc = 'xAxis_DESC',
  YAxisMobileAsc = 'yAxisMobile_ASC',
  YAxisMobileDesc = 'yAxisMobile_DESC',
  YAxisAsc = 'yAxis_ASC',
  YAxisDesc = 'yAxis_DESC'
}

export type ShopTheLookLinkingCollections = {
  __typename?: 'ShopTheLookLinkingCollections';
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type ShopTheLookLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ShopTheLookLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type ShopTheLookLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<ShopTheLookLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum ShopTheLookLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ShopTheLookLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ShopTheLookOrder {
  FirstImageFocusMobileAsc = 'firstImageFocusMobile_ASC',
  FirstImageFocusMobileDesc = 'firstImageFocusMobile_DESC',
  FirstImageFocusAsc = 'firstImageFocus_ASC',
  FirstImageFocusDesc = 'firstImageFocus_DESC',
  FourthImageFocusMobileAsc = 'fourthImageFocusMobile_ASC',
  FourthImageFocusMobileDesc = 'fourthImageFocusMobile_DESC',
  FourthImageFocusAsc = 'fourthImageFocus_ASC',
  FourthImageFocusDesc = 'fourthImageFocus_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SecondImageFocusMobileAsc = 'secondImageFocusMobile_ASC',
  SecondImageFocusMobileDesc = 'secondImageFocusMobile_DESC',
  SecondImageFocusAsc = 'secondImageFocus_ASC',
  SecondImageFocusDesc = 'secondImageFocus_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThirdImageFocusMobileAsc = 'thirdImageFocusMobile_ASC',
  ThirdImageFocusMobileDesc = 'thirdImageFocusMobile_DESC',
  ThirdImageFocusAsc = 'thirdImageFocus_ASC',
  ThirdImageFocusDesc = 'thirdImageFocus_DESC'
}

export type ShopTheLookSecondImageProductButtonsCollection = {
  __typename?: 'ShopTheLookSecondImageProductButtonsCollection';
  items: Array<Maybe<ShopTheLookItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ShopTheLookSecondImageProductButtonsCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SkuAsc = 'sku_ASC',
  SkuDesc = 'sku_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  XAxisMobileAsc = 'xAxisMobile_ASC',
  XAxisMobileDesc = 'xAxisMobile_DESC',
  XAxisAsc = 'xAxis_ASC',
  XAxisDesc = 'xAxis_DESC',
  YAxisMobileAsc = 'yAxisMobile_ASC',
  YAxisMobileDesc = 'yAxisMobile_DESC',
  YAxisAsc = 'yAxis_ASC',
  YAxisDesc = 'yAxis_DESC'
}

export type ShopTheLookThirdImageProductButtonsCollection = {
  __typename?: 'ShopTheLookThirdImageProductButtonsCollection';
  items: Array<Maybe<ShopTheLookItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum ShopTheLookThirdImageProductButtonsCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SkuAsc = 'sku_ASC',
  SkuDesc = 'sku_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  XAxisMobileAsc = 'xAxisMobile_ASC',
  XAxisMobileDesc = 'xAxisMobile_DESC',
  XAxisAsc = 'xAxis_ASC',
  XAxisDesc = 'xAxis_DESC',
  YAxisMobileAsc = 'yAxisMobile_ASC',
  YAxisMobileDesc = 'yAxisMobile_DESC',
  YAxisAsc = 'yAxis_ASC',
  YAxisDesc = 'yAxis_DESC'
}

/** A social media link and Icon [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/socialIcon) */
export type SocialIcon = Entry & _Node & {
  __typename?: 'SocialIcon';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Scalars['String']>;
  internTitile?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<SocialIconLinkingCollections>;
  sys: Sys;
  title?: Maybe<Scalars['String']>;
};


/** A social media link and Icon [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/socialIcon) */
export type SocialIconIconArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A social media link and Icon [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/socialIcon) */
export type SocialIconInternTitileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A social media link and Icon [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/socialIcon) */
export type SocialIconLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** A social media link and Icon [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/socialIcon) */
export type SocialIconLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** A social media link and Icon [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/socialIcon) */
export type SocialIconTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type SocialIconCollection = {
  __typename?: 'SocialIconCollection';
  items: Array<Maybe<SocialIcon>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type SocialIconFilter = {
  AND?: InputMaybe<Array<InputMaybe<SocialIconFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SocialIconFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']>;
  icon_contains?: InputMaybe<Scalars['String']>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_not?: InputMaybe<Scalars['String']>;
  icon_not_contains?: InputMaybe<Scalars['String']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitile?: InputMaybe<Scalars['String']>;
  internTitile_contains?: InputMaybe<Scalars['String']>;
  internTitile_exists?: InputMaybe<Scalars['Boolean']>;
  internTitile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitile_not?: InputMaybe<Scalars['String']>;
  internTitile_not_contains?: InputMaybe<Scalars['String']>;
  internTitile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link?: InputMaybe<Scalars['String']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type SocialIconLinkingCollections = {
  __typename?: 'SocialIconLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type SocialIconLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type SocialIconLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<SocialIconLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum SocialIconLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SocialIconOrder {
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  InternTitileAsc = 'internTitile_ASC',
  InternTitileDesc = 'internTitile_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type Stage = Entry & _Node & {
  __typename?: 'Stage';
  _id: Scalars['ID'];
  alignment?: Maybe<Scalars['String']>;
  bynderImage?: Maybe<Scalars['JSON']>;
  bynderImageMobile?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  countDown?: Maybe<BanderoleCountDown>;
  cta?: Maybe<Cta>;
  darkText?: Maybe<Scalars['Boolean']>;
  halfWidthText?: Maybe<Scalars['Boolean']>;
  hasBackgroundGradient?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  imageFocus?: Maybe<Scalars['String']>;
  imageFocusMobile?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<Asset>;
  internTitle?: Maybe<Scalars['String']>;
  isFramed?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<StageLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  metaContentName?: Maybe<DataLayerMeta>;
  metaContentType?: Maybe<DataLayerMeta>;
  miniHeadline?: Maybe<Scalars['String']>;
  mobileAlignment?: Maybe<Scalars['String']>;
  newStage?: Maybe<Scalars['Boolean']>;
  promoCreativeName?: Maybe<DataLayerMeta>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  type?: Maybe<Scalars['String']>;
  video?: Maybe<Asset>;
  videoMobile?: Maybe<Asset>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageBynderImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageCountDownArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<BanderoleCountDownFilter>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageDarkTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageHalfWidthTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageHasBackgroundGradientArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageImageFocusMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageIsFramedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageMetaContentNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<DataLayerMetaFilter>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageMetaContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<DataLayerMetaFilter>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageMiniHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageMobileAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageNewStageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StagePromoCreativeNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<DataLayerMetaFilter>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageVideoArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** Variants: Large, Small [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/stage) */
export type StageVideoMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};

export type StageCollection = {
  __typename?: 'StageCollection';
  items: Array<Maybe<Stage>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type StageFilter = {
  AND?: InputMaybe<Array<InputMaybe<StageFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<StageFilter>>>;
  alignment?: InputMaybe<Scalars['String']>;
  alignment_contains?: InputMaybe<Scalars['String']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alignment_not?: InputMaybe<Scalars['String']>;
  alignment_not_contains?: InputMaybe<Scalars['String']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countDown?: InputMaybe<CfBanderoleCountDownNestedFilter>;
  countDown_exists?: InputMaybe<Scalars['Boolean']>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  darkText?: InputMaybe<Scalars['Boolean']>;
  darkText_exists?: InputMaybe<Scalars['Boolean']>;
  darkText_not?: InputMaybe<Scalars['Boolean']>;
  halfWidthText?: InputMaybe<Scalars['Boolean']>;
  halfWidthText_exists?: InputMaybe<Scalars['Boolean']>;
  halfWidthText_not?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_exists?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocusMobile?: InputMaybe<Scalars['String']>;
  imageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  imageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocusMobile_not?: InputMaybe<Scalars['String']>;
  imageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  imageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isFramed?: InputMaybe<Scalars['Boolean']>;
  isFramed_exists?: InputMaybe<Scalars['Boolean']>;
  isFramed_not?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaContentName?: InputMaybe<CfDataLayerMetaNestedFilter>;
  metaContentName_exists?: InputMaybe<Scalars['Boolean']>;
  metaContentType?: InputMaybe<CfDataLayerMetaNestedFilter>;
  metaContentType_exists?: InputMaybe<Scalars['Boolean']>;
  miniHeadline?: InputMaybe<Scalars['String']>;
  miniHeadline_contains?: InputMaybe<Scalars['String']>;
  miniHeadline_exists?: InputMaybe<Scalars['Boolean']>;
  miniHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  miniHeadline_not?: InputMaybe<Scalars['String']>;
  miniHeadline_not_contains?: InputMaybe<Scalars['String']>;
  miniHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileAlignment?: InputMaybe<Scalars['String']>;
  mobileAlignment_contains?: InputMaybe<Scalars['String']>;
  mobileAlignment_exists?: InputMaybe<Scalars['Boolean']>;
  mobileAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileAlignment_not?: InputMaybe<Scalars['String']>;
  mobileAlignment_not_contains?: InputMaybe<Scalars['String']>;
  mobileAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newStage?: InputMaybe<Scalars['Boolean']>;
  newStage_exists?: InputMaybe<Scalars['Boolean']>;
  newStage_not?: InputMaybe<Scalars['Boolean']>;
  promoCreativeName?: InputMaybe<CfDataLayerMetaNestedFilter>;
  promoCreativeName_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type StageLinkingCollections = {
  __typename?: 'StageLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type StageLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<StageLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type StageLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<StageLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type StageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type StageLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<StageLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum StageLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StageLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StageLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum StageOrder {
  AlignmentAsc = 'alignment_ASC',
  AlignmentDesc = 'alignment_DESC',
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  HalfWidthTextAsc = 'halfWidthText_ASC',
  HalfWidthTextDesc = 'halfWidthText_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageFocusMobileAsc = 'imageFocusMobile_ASC',
  ImageFocusMobileDesc = 'imageFocusMobile_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  IsFramedAsc = 'isFramed_ASC',
  IsFramedDesc = 'isFramed_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MiniHeadlineAsc = 'miniHeadline_ASC',
  MiniHeadlineDesc = 'miniHeadline_DESC',
  MobileAlignmentAsc = 'mobileAlignment_ASC',
  MobileAlignmentDesc = 'mobileAlignment_DESC',
  NewStageAsc = 'newStage_ASC',
  NewStageDesc = 'newStage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String'];
  firstPublishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  publishedVersion?: Maybe<Scalars['Int']>;
  spaceId: Scalars['String'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  id?: InputMaybe<Scalars['String']>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_exists?: InputMaybe<Scalars['Boolean']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id_not?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tabModule) */
export type TabModule = Entry & _Node & {
  __typename?: 'TabModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom?: Maybe<TabModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
  tabsCollection?: Maybe<TabModuleTabsCollection>;
  titleIntern?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tabModule) */
export type TabModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tabModule) */
export type TabModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tabModule) */
export type TabModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tabModule) */
export type TabModuleTabsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TabModuleTabsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccordionItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tabModule) */
export type TabModuleTitleInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TabModuleCollection = {
  __typename?: 'TabModuleCollection';
  items: Array<Maybe<TabModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TabModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<TabModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TabModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tabs?: InputMaybe<CfAccordionItemNestedFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TabModuleLinkingCollections = {
  __typename?: 'TabModuleLinkingCollections';
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TabModuleLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TabModuleLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TabModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TabModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TabModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TabModuleLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TabModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TabModuleOrder {
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export type TabModuleTabsCollection = {
  __typename?: 'TabModuleTabsCollection';
  items: Array<Maybe<AccordionItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TabModuleTabsCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']>;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItem = Entry & _Node & {
  __typename?: 'TeaserItem';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  darkText?: Maybe<Scalars['Boolean']>;
  gradientDirection?: Maybe<Scalars['Boolean']>;
  hasBackgroundGradient?: Maybe<Scalars['Boolean']>;
  headline?: Maybe<Scalars['String']>;
  icon?: Maybe<Asset>;
  image?: Maybe<Asset>;
  imageCaption?: Maybe<Scalars['String']>;
  imageFocus?: Maybe<Scalars['String']>;
  imageMobile?: Maybe<Asset>;
  internTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TeaserItemLinkingCollections>;
  metaContentName?: Maybe<DataLayerMeta>;
  metaContentType?: Maybe<DataLayerMeta>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemDarkTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemGradientDirectionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemHasBackgroundGradientArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemIconArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemImageFocusArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemInternTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemMetaContentNameArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<DataLayerMetaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemMetaContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<DataLayerMetaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserItem) */
export type TeaserItemTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TeaserItemCollection = {
  __typename?: 'TeaserItemCollection';
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TeaserItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeaserItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeaserItemFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  darkText?: InputMaybe<Scalars['Boolean']>;
  darkText_exists?: InputMaybe<Scalars['Boolean']>;
  darkText_not?: InputMaybe<Scalars['Boolean']>;
  gradientDirection?: InputMaybe<Scalars['Boolean']>;
  gradientDirection_exists?: InputMaybe<Scalars['Boolean']>;
  gradientDirection_not?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_exists?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageCaption_contains?: InputMaybe<Scalars['String']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaContentName?: InputMaybe<CfDataLayerMetaNestedFilter>;
  metaContentName_exists?: InputMaybe<Scalars['Boolean']>;
  metaContentType?: InputMaybe<CfDataLayerMetaNestedFilter>;
  metaContentType_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeaserItemLinkingCollections = {
  __typename?: 'TeaserItemLinkingCollections';
  corporateNavigationCollection?: Maybe<CorporateNavigationCollection>;
  corporateNavigationListElementCollection?: Maybe<CorporateNavigationListElementCollection>;
  entryCollection?: Maybe<EntryCollection>;
  navigationCollection?: Maybe<NavigationCollection>;
  navigationListElementCollection?: Maybe<NavigationListElementCollection>;
  productsSliderCollection?: Maybe<ProductsSliderCollection>;
  teaserModuleCollection?: Maybe<TeaserModuleCollection>;
};


export type TeaserItemLinkingCollectionsCorporateNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsCorporateNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserItemLinkingCollectionsCorporateNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsCorporateNavigationListElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserItemLinkingCollectionsNavigationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsNavigationCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserItemLinkingCollectionsNavigationListElementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsNavigationListElementCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserItemLinkingCollectionsProductsSliderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsProductsSliderCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserItemLinkingCollectionsTeaserModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserItemLinkingCollectionsTeaserModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TeaserItemLinkingCollectionsCorporateNavigationCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export enum TeaserItemLinkingCollectionsCorporateNavigationListElementCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TeaserItemLinkingCollectionsNavigationCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export enum TeaserItemLinkingCollectionsNavigationListElementCollectionOrder {
  IsBrandsItemAsc = 'isBrandsItem_ASC',
  IsBrandsItemDesc = 'isBrandsItem_DESC',
  IsColorItemAsc = 'isColorItem_ASC',
  IsColorItemDesc = 'isColorItem_DESC',
  PortraitImageAsc = 'portraitImage_ASC',
  PortraitImageDesc = 'portraitImage_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TeaserItemLinkingCollectionsProductsSliderCollectionOrder {
  CioRecommendationsFilterNameAsc = 'cioRecommendationsFilterName_ASC',
  CioRecommendationsFilterNameDesc = 'cioRecommendationsFilterName_DESC',
  CioRecommendationsFilterValueAsc = 'cioRecommendationsFilterValue_ASC',
  CioRecommendationsFilterValueDesc = 'cioRecommendationsFilterValue_DESC',
  CioRecommendationsIdAsc = 'cioRecommendationsId_ASC',
  CioRecommendationsIdDesc = 'cioRecommendationsId_DESC',
  CioRecommendationsResultsLimitAsc = 'cioRecommendationsResultsLimit_ASC',
  CioRecommendationsResultsLimitDesc = 'cioRecommendationsResultsLimit_DESC',
  H1HeadlineAsc = 'h1Headline_ASC',
  H1HeadlineDesc = 'h1Headline_DESC',
  HeadlineInternAsc = 'headlineIntern_ASC',
  HeadlineInternDesc = 'headlineIntern_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SpacingBottomAsc = 'spacingBottom_ASC',
  SpacingBottomDesc = 'spacingBottom_DESC',
  SpacingTopAsc = 'spacingTop_ASC',
  SpacingTopDesc = 'spacingTop_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TeaserItemLinkingCollectionsTeaserModuleCollectionOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export enum TeaserItemOrder {
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  GradientDirectionAsc = 'gradientDirection_ASC',
  GradientDirectionDesc = 'gradientDirection_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModule = Entry & _Node & {
  __typename?: 'TeaserModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TeaserModuleLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  sys: Sys;
  teaserItemsCollection?: Maybe<TeaserModuleTeaserItemsCollection>;
  titleIntern?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModuleHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModuleMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModuleMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModuleTeaserItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserModuleTeaserItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TeaserItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/teaserModule) */
export type TeaserModuleTitleInternArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TeaserModuleCollection = {
  __typename?: 'TeaserModuleCollection';
  items: Array<Maybe<TeaserModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TeaserModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<TeaserModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TeaserModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  teaserItems?: InputMaybe<CfTeaserItemNestedFilter>;
  teaserItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TeaserModuleLinkingCollections = {
  __typename?: 'TeaserModuleLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TeaserModuleLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserModuleLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserModuleLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserModuleLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TeaserModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TeaserModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TeaserModuleLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TeaserModuleLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TeaserModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TeaserModuleOrder {
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternAsc = 'titleIntern_ASC',
  TitleInternDesc = 'titleIntern_DESC'
}

export type TeaserModuleTeaserItemsCollection = {
  __typename?: 'TeaserModuleTeaserItemsCollection';
  items: Array<Maybe<TeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TeaserModuleTeaserItemsCollectionOrder {
  DarkTextAsc = 'darkText_ASC',
  DarkTextDesc = 'darkText_DESC',
  GradientDirectionAsc = 'gradientDirection_ASC',
  GradientDirectionDesc = 'gradientDirection_DESC',
  HasBackgroundGradientAsc = 'hasBackgroundGradient_ASC',
  HasBackgroundGradientDesc = 'hasBackgroundGradient_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageFocusAsc = 'imageFocus_ASC',
  ImageFocusDesc = 'imageFocus_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaser = Entry & _Node & {
  __typename?: 'TextImageTeaser';
  _id: Scalars['ID'];
  bynderImage?: Maybe<Scalars['JSON']>;
  bynderImageMobile?: Maybe<Scalars['JSON']>;
  centerTextAlignment?: Maybe<Scalars['Boolean']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  handleOrganicShape?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  icon?: Maybe<Asset>;
  image?: Maybe<Asset>;
  imageCaption?: Maybe<Scalars['String']>;
  imageDesktopLeft?: Maybe<Scalars['Boolean']>;
  imageMobile?: Maybe<Asset>;
  linkedFrom?: Maybe<TextImageTeaserLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  mobileImageBottom?: Maybe<Scalars['Boolean']>;
  mobileText?: Maybe<TextImageTeaserMobileText>;
  noSidePadding?: Maybe<Scalars['Boolean']>;
  organicShapeColor?: Maybe<Scalars['String']>;
  selectShapeView?: Maybe<Scalars['String']>;
  subHeadline?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<TextImageTeaserText>;
  titleInternal?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserBynderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserBynderImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserCenterTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserHandleOrganicShapeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserIconArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserImageCaptionArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserImageDesktopLeftArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserImageMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserMobileImageBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserMobileTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserNoSidePaddingArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserOrganicShapeColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserSelectShapeViewArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserSubHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textImageTeaser) */
export type TextImageTeaserTitleInternalArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TextImageTeaserCollection = {
  __typename?: 'TextImageTeaserCollection';
  items: Array<Maybe<TextImageTeaser>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TextImageTeaserFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextImageTeaserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextImageTeaserFilter>>>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  centerTextAlignment?: InputMaybe<Scalars['Boolean']>;
  centerTextAlignment_exists?: InputMaybe<Scalars['Boolean']>;
  centerTextAlignment_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  handleOrganicShape?: InputMaybe<Scalars['String']>;
  handleOrganicShape_contains?: InputMaybe<Scalars['String']>;
  handleOrganicShape_exists?: InputMaybe<Scalars['Boolean']>;
  handleOrganicShape_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  handleOrganicShape_not?: InputMaybe<Scalars['String']>;
  handleOrganicShape_not_contains?: InputMaybe<Scalars['String']>;
  handleOrganicShape_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageCaption_contains?: InputMaybe<Scalars['String']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageDesktopLeft?: InputMaybe<Scalars['Boolean']>;
  imageDesktopLeft_exists?: InputMaybe<Scalars['Boolean']>;
  imageDesktopLeft_not?: InputMaybe<Scalars['Boolean']>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImageBottom?: InputMaybe<Scalars['Boolean']>;
  mobileImageBottom_exists?: InputMaybe<Scalars['Boolean']>;
  mobileImageBottom_not?: InputMaybe<Scalars['Boolean']>;
  mobileText_contains?: InputMaybe<Scalars['String']>;
  mobileText_exists?: InputMaybe<Scalars['Boolean']>;
  mobileText_not_contains?: InputMaybe<Scalars['String']>;
  noSidePadding?: InputMaybe<Scalars['Boolean']>;
  noSidePadding_exists?: InputMaybe<Scalars['Boolean']>;
  noSidePadding_not?: InputMaybe<Scalars['Boolean']>;
  organicShapeColor?: InputMaybe<Scalars['String']>;
  organicShapeColor_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_exists?: InputMaybe<Scalars['Boolean']>;
  organicShapeColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organicShapeColor_not?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectShapeView?: InputMaybe<Scalars['String']>;
  selectShapeView_contains?: InputMaybe<Scalars['String']>;
  selectShapeView_exists?: InputMaybe<Scalars['Boolean']>;
  selectShapeView_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectShapeView_not?: InputMaybe<Scalars['String']>;
  selectShapeView_not_contains?: InputMaybe<Scalars['String']>;
  selectShapeView_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subHeadline?: InputMaybe<Scalars['String']>;
  subHeadline_contains?: InputMaybe<Scalars['String']>;
  subHeadline_exists?: InputMaybe<Scalars['Boolean']>;
  subHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subHeadline_not?: InputMaybe<Scalars['String']>;
  subHeadline_not_contains?: InputMaybe<Scalars['String']>;
  subHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TextImageTeaserLinkingCollections = {
  __typename?: 'TextImageTeaserLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TextImageTeaserLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextImageTeaserLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextImageTeaserLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextImageTeaserLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextImageTeaserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextImageTeaserLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextImageTeaserLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TextImageTeaserLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TextImageTeaserLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TextImageTeaserLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TextImageTeaserMobileText = {
  __typename?: 'TextImageTeaserMobileText';
  json: Scalars['JSON'];
  links: TextImageTeaserMobileTextLinks;
};

export type TextImageTeaserMobileTextAssets = {
  __typename?: 'TextImageTeaserMobileTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextImageTeaserMobileTextEntries = {
  __typename?: 'TextImageTeaserMobileTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextImageTeaserMobileTextLinks = {
  __typename?: 'TextImageTeaserMobileTextLinks';
  assets: TextImageTeaserMobileTextAssets;
  entries: TextImageTeaserMobileTextEntries;
  resources: TextImageTeaserMobileTextResources;
};

export type TextImageTeaserMobileTextResources = {
  __typename?: 'TextImageTeaserMobileTextResources';
  block: Array<TextImageTeaserMobileTextResourcesBlock>;
  hyperlink: Array<TextImageTeaserMobileTextResourcesHyperlink>;
  inline: Array<TextImageTeaserMobileTextResourcesInline>;
};

export type TextImageTeaserMobileTextResourcesBlock = ResourceLink & {
  __typename?: 'TextImageTeaserMobileTextResourcesBlock';
  sys: ResourceSys;
};

export type TextImageTeaserMobileTextResourcesHyperlink = ResourceLink & {
  __typename?: 'TextImageTeaserMobileTextResourcesHyperlink';
  sys: ResourceSys;
};

export type TextImageTeaserMobileTextResourcesInline = ResourceLink & {
  __typename?: 'TextImageTeaserMobileTextResourcesInline';
  sys: ResourceSys;
};

export enum TextImageTeaserOrder {
  CenterTextAlignmentAsc = 'centerTextAlignment_ASC',
  CenterTextAlignmentDesc = 'centerTextAlignment_DESC',
  HandleOrganicShapeAsc = 'handleOrganicShape_ASC',
  HandleOrganicShapeDesc = 'handleOrganicShape_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  ImageCaptionAsc = 'imageCaption_ASC',
  ImageCaptionDesc = 'imageCaption_DESC',
  ImageDesktopLeftAsc = 'imageDesktopLeft_ASC',
  ImageDesktopLeftDesc = 'imageDesktopLeft_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MobileImageBottomAsc = 'mobileImageBottom_ASC',
  MobileImageBottomDesc = 'mobileImageBottom_DESC',
  NoSidePaddingAsc = 'noSidePadding_ASC',
  NoSidePaddingDesc = 'noSidePadding_DESC',
  OrganicShapeColorAsc = 'organicShapeColor_ASC',
  OrganicShapeColorDesc = 'organicShapeColor_DESC',
  SelectShapeViewAsc = 'selectShapeView_ASC',
  SelectShapeViewDesc = 'selectShapeView_DESC',
  SubHeadlineAsc = 'subHeadline_ASC',
  SubHeadlineDesc = 'subHeadline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC'
}

export type TextImageTeaserText = {
  __typename?: 'TextImageTeaserText';
  json: Scalars['JSON'];
  links: TextImageTeaserTextLinks;
};

export type TextImageTeaserTextAssets = {
  __typename?: 'TextImageTeaserTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextImageTeaserTextEntries = {
  __typename?: 'TextImageTeaserTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextImageTeaserTextLinks = {
  __typename?: 'TextImageTeaserTextLinks';
  assets: TextImageTeaserTextAssets;
  entries: TextImageTeaserTextEntries;
  resources: TextImageTeaserTextResources;
};

export type TextImageTeaserTextResources = {
  __typename?: 'TextImageTeaserTextResources';
  block: Array<TextImageTeaserTextResourcesBlock>;
  hyperlink: Array<TextImageTeaserTextResourcesHyperlink>;
  inline: Array<TextImageTeaserTextResourcesInline>;
};

export type TextImageTeaserTextResourcesBlock = ResourceLink & {
  __typename?: 'TextImageTeaserTextResourcesBlock';
  sys: ResourceSys;
};

export type TextImageTeaserTextResourcesHyperlink = ResourceLink & {
  __typename?: 'TextImageTeaserTextResourcesHyperlink';
  sys: ResourceSys;
};

export type TextImageTeaserTextResourcesInline = ResourceLink & {
  __typename?: 'TextImageTeaserTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/TextPicModule) */
export type TextPicModule = Entry & _Node & {
  __typename?: 'TextPicModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle?: Maybe<Scalars['String']>;
  itemsCollection?: Maybe<TextPicModuleItemsCollection>;
  linkedFrom?: Maybe<TextPicModuleLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/TextPicModule) */
export type TextPicModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/TextPicModule) */
export type TextPicModuleItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextPicModuleItemsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextPicTeaserItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/TextPicModule) */
export type TextPicModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TextPicModuleCollection = {
  __typename?: 'TextPicModuleCollection';
  items: Array<Maybe<TextPicModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TextPicModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextPicModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextPicModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  items?: InputMaybe<CfTextPicTeaserItemNestedFilter>;
  itemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type TextPicModuleItemsCollection = {
  __typename?: 'TextPicModuleItemsCollection';
  items: Array<Maybe<TextPicTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TextPicModuleItemsCollectionOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  ButtonLinkAsc = 'buttonLink_ASC',
  ButtonLinkDesc = 'buttonLink_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MarginTopAsc = 'marginTop_ASC',
  MarginTopDesc = 'marginTop_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

export type TextPicModuleLinkingCollections = {
  __typename?: 'TextPicModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TextPicModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextPicModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextPicModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TextPicModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TextPicModuleOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItem = Entry & _Node & {
  __typename?: 'TextPicTeaserItem';
  _id: Scalars['ID'];
  backgroundColor?: Maybe<Scalars['String']>;
  buttonLink?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  bynderDesktopImage?: Maybe<Scalars['JSON']>;
  bynderMobileImage?: Maybe<Scalars['JSON']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  desktopImage?: Maybe<Asset>;
  headline?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TextPicTeaserItemLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginTop?: Maybe<Scalars['String']>;
  mobileImage?: Maybe<Asset>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  textColor?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  video?: Maybe<Asset>;
  videoMobile?: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemBackgroundColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemButtonLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemBynderDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemBynderMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemDesktopImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemMarginTopArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemMobileImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemTextColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemThemeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemVideoArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textPicTeaserItem) */
export type TextPicTeaserItemVideoMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};

export type TextPicTeaserItemCollection = {
  __typename?: 'TextPicTeaserItemCollection';
  items: Array<Maybe<TextPicTeaserItem>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TextPicTeaserItemFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextPicTeaserItemFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextPicTeaserItemFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonLink_contains?: InputMaybe<Scalars['String']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText?: InputMaybe<Scalars['String']>;
  buttonText_contains?: InputMaybe<Scalars['String']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText_not?: InputMaybe<Scalars['String']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bynderDesktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginTop?: InputMaybe<Scalars['String']>;
  marginTop_contains?: InputMaybe<Scalars['String']>;
  marginTop_exists?: InputMaybe<Scalars['Boolean']>;
  marginTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginTop_not?: InputMaybe<Scalars['String']>;
  marginTop_not_contains?: InputMaybe<Scalars['String']>;
  marginTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme?: InputMaybe<Scalars['String']>;
  theme_contains?: InputMaybe<Scalars['String']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme_not?: InputMaybe<Scalars['String']>;
  theme_not_contains?: InputMaybe<Scalars['String']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type TextPicTeaserItemLinkingCollections = {
  __typename?: 'TextPicTeaserItemLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  textPicModuleCollection?: Maybe<TextPicModuleCollection>;
};


export type TextPicTeaserItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextPicTeaserItemLinkingCollectionsTextPicModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextPicTeaserItemLinkingCollectionsTextPicModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TextPicTeaserItemLinkingCollectionsTextPicModuleCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextPicTeaserItemOrder {
  BackgroundColorAsc = 'backgroundColor_ASC',
  BackgroundColorDesc = 'backgroundColor_DESC',
  ButtonLinkAsc = 'buttonLink_ASC',
  ButtonLinkDesc = 'buttonLink_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MarginTopAsc = 'marginTop_ASC',
  MarginTopDesc = 'marginTop_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextColorAsc = 'textColor_ASC',
  TextColorDesc = 'textColor_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaser = Entry & _Node & {
  __typename?: 'TextTeaser';
  _id: Scalars['ID'];
  centerWithLeftAlign?: Maybe<Scalars['Boolean']>;
  contentfulMetadata: ContentfulMetadata;
  cta?: Maybe<Cta>;
  headline?: Maybe<Scalars['String']>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TextTeaserLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  subline?: Maybe<Scalars['String']>;
  sys: Sys;
  text?: Maybe<TextTeaserText>;
  textAlignment?: Maybe<Scalars['String']>;
  twoColumnLayout?: Maybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserCenterWithLeftAlignArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserCtaArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<CtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserSublineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserTextAlignmentArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/textTeaser) */
export type TextTeaserTwoColumnLayoutArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type TextTeaserCollection = {
  __typename?: 'TextTeaserCollection';
  items: Array<Maybe<TextTeaser>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TextTeaserFilter = {
  AND?: InputMaybe<Array<InputMaybe<TextTeaserFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TextTeaserFilter>>>;
  centerWithLeftAlign?: InputMaybe<Scalars['Boolean']>;
  centerWithLeftAlign_exists?: InputMaybe<Scalars['Boolean']>;
  centerWithLeftAlign_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta?: InputMaybe<CfCtaNestedFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  textAlignment?: InputMaybe<Scalars['String']>;
  textAlignment_contains?: InputMaybe<Scalars['String']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  twoColumnLayout?: InputMaybe<Scalars['Boolean']>;
  twoColumnLayout_exists?: InputMaybe<Scalars['Boolean']>;
  twoColumnLayout_not?: InputMaybe<Scalars['Boolean']>;
};

export type TextTeaserLinkingCollections = {
  __typename?: 'TextTeaserLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
  tocModuleCollection?: Maybe<TocModuleCollection>;
};


export type TextTeaserLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextTeaserLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextTeaserLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextTeaserLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextTeaserLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextTeaserLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextTeaserLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TextTeaserLinkingCollectionsTocModuleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TextTeaserLinkingCollectionsTocModuleCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TextTeaserLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TextTeaserLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TextTeaserLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TextTeaserLinkingCollectionsTocModuleCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TextTeaserOrder {
  CenterWithLeftAlignAsc = 'centerWithLeftAlign_ASC',
  CenterWithLeftAlignDesc = 'centerWithLeftAlign_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC',
  TwoColumnLayoutAsc = 'twoColumnLayout_ASC',
  TwoColumnLayoutDesc = 'twoColumnLayout_DESC'
}

export type TextTeaserText = {
  __typename?: 'TextTeaserText';
  json: Scalars['JSON'];
  links: TextTeaserTextLinks;
};

export type TextTeaserTextAssets = {
  __typename?: 'TextTeaserTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type TextTeaserTextEntries = {
  __typename?: 'TextTeaserTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type TextTeaserTextLinks = {
  __typename?: 'TextTeaserTextLinks';
  assets: TextTeaserTextAssets;
  entries: TextTeaserTextEntries;
  resources: TextTeaserTextResources;
};

export type TextTeaserTextResources = {
  __typename?: 'TextTeaserTextResources';
  block: Array<TextTeaserTextResourcesBlock>;
  hyperlink: Array<TextTeaserTextResourcesHyperlink>;
  inline: Array<TextTeaserTextResourcesInline>;
};

export type TextTeaserTextResourcesBlock = ResourceLink & {
  __typename?: 'TextTeaserTextResourcesBlock';
  sys: ResourceSys;
};

export type TextTeaserTextResourcesHyperlink = ResourceLink & {
  __typename?: 'TextTeaserTextResourcesHyperlink';
  sys: ResourceSys;
};

export type TextTeaserTextResourcesInline = ResourceLink & {
  __typename?: 'TextTeaserTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tocModule) */
export type TocModule = Entry & _Node & {
  __typename?: 'TocModule';
  _id: Scalars['ID'];
  contentfulMetadata: ContentfulMetadata;
  excludedEntriesCollection?: Maybe<TocModuleExcludedEntriesCollection>;
  internalTitle?: Maybe<Scalars['String']>;
  linkedFrom?: Maybe<TocModuleLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tocModule) */
export type TocModuleExcludedEntriesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TocModuleExcludedEntriesCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TextTeaserFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tocModule) */
export type TocModuleInternalTitleArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/tocModule) */
export type TocModuleLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TocModuleCollection = {
  __typename?: 'TocModuleCollection';
  items: Array<Maybe<TocModule>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type TocModuleExcludedEntriesCollection = {
  __typename?: 'TocModuleExcludedEntriesCollection';
  items: Array<Maybe<TextTeaser>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export enum TocModuleExcludedEntriesCollectionOrder {
  CenterWithLeftAlignAsc = 'centerWithLeftAlign_ASC',
  CenterWithLeftAlignDesc = 'centerWithLeftAlign_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  SublineAsc = 'subline_ASC',
  SublineDesc = 'subline_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAlignmentAsc = 'textAlignment_ASC',
  TextAlignmentDesc = 'textAlignment_DESC',
  TwoColumnLayoutAsc = 'twoColumnLayout_ASC',
  TwoColumnLayoutDesc = 'twoColumnLayout_DESC'
}

export type TocModuleFilter = {
  AND?: InputMaybe<Array<InputMaybe<TocModuleFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TocModuleFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  excludedEntries?: InputMaybe<CfTextTeaserNestedFilter>;
  excludedEntriesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type TocModuleLinkingCollections = {
  __typename?: 'TocModuleLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type TocModuleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TocModuleLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<TocModuleLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum TocModuleLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum TocModuleOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type Video = Entry & _Node & {
  __typename?: 'Video';
  _id: Scalars['ID'];
  autoPlay?: Maybe<Scalars['Boolean']>;
  bynderPlaceholderImage?: Maybe<Scalars['JSON']>;
  clickableLink?: Maybe<Scalars['String']>;
  contentfulMetadata: ContentfulMetadata;
  desktopVideoLeft?: Maybe<Scalars['Boolean']>;
  handleOrganicShape?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  hideControls?: Maybe<Scalars['Boolean']>;
  linkedFrom?: Maybe<VideoLinkingCollections>;
  marginBottom?: Maybe<Scalars['String']>;
  marginBottomMobile?: Maybe<Scalars['String']>;
  mobileVideoAboveText?: Maybe<Scalars['Boolean']>;
  organicShapeColor?: Maybe<Scalars['String']>;
  placeholderImage?: Maybe<Asset>;
  rte?: Maybe<VideoRte>;
  sys: Sys;
  titleInternal?: Maybe<Scalars['String']>;
  unmuted?: Maybe<Scalars['Boolean']>;
  videoFile?: Maybe<Asset>;
  videoWidth?: Maybe<Scalars['Int']>;
  youTubeUrl?: Maybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoAutoPlayArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoBynderPlaceholderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoClickableLinkArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoDesktopVideoLeftArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoHandleOrganicShapeArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoHeadlineArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoHideControlsArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoMarginBottomArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoMarginBottomMobileArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoMobileVideoAboveTextArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoOrganicShapeColorArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoPlaceholderImageArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoRteArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoTitleInternalArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoUnmutedArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoVideoFileArgs = {
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoVideoWidthArgs = {
  locale?: InputMaybe<Scalars['String']>;
};


/** [See type definition](https://app.contentful.com/spaces/vo1gpye17gm3/content_types/video) */
export type VideoYouTubeUrlArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type VideoCollection = {
  __typename?: 'VideoCollection';
  items: Array<Maybe<Video>>;
  limit: Scalars['Int'];
  skip: Scalars['Int'];
  total: Scalars['Int'];
};

export type VideoFilter = {
  AND?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<VideoFilter>>>;
  autoPlay?: InputMaybe<Scalars['Boolean']>;
  autoPlay_exists?: InputMaybe<Scalars['Boolean']>;
  autoPlay_not?: InputMaybe<Scalars['Boolean']>;
  bynderPlaceholderImage_exists?: InputMaybe<Scalars['Boolean']>;
  clickableLink?: InputMaybe<Scalars['String']>;
  clickableLink_contains?: InputMaybe<Scalars['String']>;
  clickableLink_exists?: InputMaybe<Scalars['Boolean']>;
  clickableLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clickableLink_not?: InputMaybe<Scalars['String']>;
  clickableLink_not_contains?: InputMaybe<Scalars['String']>;
  clickableLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopVideoLeft?: InputMaybe<Scalars['Boolean']>;
  desktopVideoLeft_exists?: InputMaybe<Scalars['Boolean']>;
  desktopVideoLeft_not?: InputMaybe<Scalars['Boolean']>;
  handleOrganicShape?: InputMaybe<Scalars['String']>;
  handleOrganicShape_contains?: InputMaybe<Scalars['String']>;
  handleOrganicShape_exists?: InputMaybe<Scalars['Boolean']>;
  handleOrganicShape_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  handleOrganicShape_not?: InputMaybe<Scalars['String']>;
  handleOrganicShape_not_contains?: InputMaybe<Scalars['String']>;
  handleOrganicShape_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hideControls?: InputMaybe<Scalars['Boolean']>;
  hideControls_exists?: InputMaybe<Scalars['Boolean']>;
  hideControls_not?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileVideoAboveText?: InputMaybe<Scalars['Boolean']>;
  mobileVideoAboveText_exists?: InputMaybe<Scalars['Boolean']>;
  mobileVideoAboveText_not?: InputMaybe<Scalars['Boolean']>;
  organicShapeColor?: InputMaybe<Scalars['String']>;
  organicShapeColor_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_exists?: InputMaybe<Scalars['Boolean']>;
  organicShapeColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  organicShapeColor_not?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_contains?: InputMaybe<Scalars['String']>;
  organicShapeColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeholderImage_exists?: InputMaybe<Scalars['Boolean']>;
  rte_contains?: InputMaybe<Scalars['String']>;
  rte_exists?: InputMaybe<Scalars['Boolean']>;
  rte_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  unmuted?: InputMaybe<Scalars['Boolean']>;
  unmuted_exists?: InputMaybe<Scalars['Boolean']>;
  unmuted_not?: InputMaybe<Scalars['Boolean']>;
  videoFile_exists?: InputMaybe<Scalars['Boolean']>;
  videoWidth?: InputMaybe<Scalars['Int']>;
  videoWidth_exists?: InputMaybe<Scalars['Boolean']>;
  videoWidth_gt?: InputMaybe<Scalars['Int']>;
  videoWidth_gte?: InputMaybe<Scalars['Int']>;
  videoWidth_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  videoWidth_lt?: InputMaybe<Scalars['Int']>;
  videoWidth_lte?: InputMaybe<Scalars['Int']>;
  videoWidth_not?: InputMaybe<Scalars['Int']>;
  videoWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  youTubeUrl?: InputMaybe<Scalars['String']>;
  youTubeUrl_contains?: InputMaybe<Scalars['String']>;
  youTubeUrl_exists?: InputMaybe<Scalars['Boolean']>;
  youTubeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  youTubeUrl_not?: InputMaybe<Scalars['String']>;
  youTubeUrl_not_contains?: InputMaybe<Scalars['String']>;
  youTubeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VideoLinkingCollections = {
  __typename?: 'VideoLinkingCollections';
  corporatePageCollection?: Maybe<CorporatePageCollection>;
  ctaCollection?: Maybe<CtaCollection>;
  entryCollection?: Maybe<EntryCollection>;
  pageCollection?: Maybe<PageCollection>;
};


export type VideoLinkingCollectionsCorporatePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsCorporatePageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type VideoLinkingCollectionsCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsCtaCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type VideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type VideoLinkingCollectionsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Array<InputMaybe<VideoLinkingCollectionsPageCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export enum VideoLinkingCollectionsCorporatePageCollectionOrder {
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum VideoLinkingCollectionsCtaCollectionOrder {
  CtaStyleAsc = 'ctaStyle_ASC',
  CtaStyleDesc = 'ctaStyle_DESC',
  CtaTextAsc = 'ctaText_ASC',
  CtaTextDesc = 'ctaText_DESC',
  EMailLinkAsc = 'eMailLink_ASC',
  EMailLinkDesc = 'eMailLink_DESC',
  InternTitleAsc = 'internTitle_ASC',
  InternTitleDesc = 'internTitle_DESC',
  LinkExternalPageAsc = 'linkExternalPage_ASC',
  LinkExternalPageDesc = 'linkExternalPage_DESC',
  LinkInternalUrlAsc = 'linkInternalUrl_ASC',
  LinkInternalUrlDesc = 'linkInternalUrl_DESC',
  NewCtaStyleAsc = 'newCtaStyle_ASC',
  NewCtaStyleDesc = 'newCtaStyle_DESC',
  PhoneLinkAsc = 'phoneLink_ASC',
  PhoneLinkDesc = 'phoneLink_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum VideoLinkingCollectionsPageCollectionOrder {
  ChatEnabledAsc = 'chatEnabled_ASC',
  ChatEnabledDesc = 'chatEnabled_DESC',
  CioCollectionIdAsc = 'cioCollectionId_ASC',
  CioCollectionIdDesc = 'cioCollectionId_DESC',
  CioGroupIdAsc = 'cioGroupId_ASC',
  CioGroupIdDesc = 'cioGroupId_DESC',
  CioShowVariationsStrategyAsc = 'cioShowVariationsStrategy_ASC',
  CioShowVariationsStrategyDesc = 'cioShowVariationsStrategy_DESC',
  DeliveryDaysAsc = 'deliveryDays_ASC',
  DeliveryDaysDesc = 'deliveryDays_DESC',
  NavigationThemeAsc = 'navigationTheme_ASC',
  NavigationThemeDesc = 'navigationTheme_DESC',
  PreventIndexingAsc = 'preventIndexing_ASC',
  PreventIndexingDesc = 'preventIndexing_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum VideoOrder {
  AutoPlayAsc = 'autoPlay_ASC',
  AutoPlayDesc = 'autoPlay_DESC',
  ClickableLinkAsc = 'clickableLink_ASC',
  ClickableLinkDesc = 'clickableLink_DESC',
  DesktopVideoLeftAsc = 'desktopVideoLeft_ASC',
  DesktopVideoLeftDesc = 'desktopVideoLeft_DESC',
  HandleOrganicShapeAsc = 'handleOrganicShape_ASC',
  HandleOrganicShapeDesc = 'handleOrganicShape_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  HideControlsAsc = 'hideControls_ASC',
  HideControlsDesc = 'hideControls_DESC',
  MarginBottomMobileAsc = 'marginBottomMobile_ASC',
  MarginBottomMobileDesc = 'marginBottomMobile_DESC',
  MarginBottomAsc = 'marginBottom_ASC',
  MarginBottomDesc = 'marginBottom_DESC',
  MobileVideoAboveTextAsc = 'mobileVideoAboveText_ASC',
  MobileVideoAboveTextDesc = 'mobileVideoAboveText_DESC',
  OrganicShapeColorAsc = 'organicShapeColor_ASC',
  OrganicShapeColorDesc = 'organicShapeColor_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleInternalAsc = 'titleInternal_ASC',
  TitleInternalDesc = 'titleInternal_DESC',
  UnmutedAsc = 'unmuted_ASC',
  UnmutedDesc = 'unmuted_DESC',
  VideoWidthAsc = 'videoWidth_ASC',
  VideoWidthDesc = 'videoWidth_DESC',
  YouTubeUrlAsc = 'youTubeUrl_ASC',
  YouTubeUrlDesc = 'youTubeUrl_DESC'
}

export type VideoRte = {
  __typename?: 'VideoRte';
  json: Scalars['JSON'];
  links: VideoRteLinks;
};

export type VideoRteAssets = {
  __typename?: 'VideoRteAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type VideoRteEntries = {
  __typename?: 'VideoRteEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type VideoRteLinks = {
  __typename?: 'VideoRteLinks';
  assets: VideoRteAssets;
  entries: VideoRteEntries;
  resources: VideoRteResources;
};

export type VideoRteResources = {
  __typename?: 'VideoRteResources';
  block: Array<VideoRteResourcesBlock>;
  hyperlink: Array<VideoRteResourcesHyperlink>;
  inline: Array<VideoRteResourcesInline>;
};

export type VideoRteResourcesBlock = ResourceLink & {
  __typename?: 'VideoRteResourcesBlock';
  sys: ResourceSys;
};

export type VideoRteResourcesHyperlink = ResourceLink & {
  __typename?: 'VideoRteResourcesHyperlink';
  sys: ResourceSys;
};

export type VideoRteResourcesInline = ResourceLink & {
  __typename?: 'VideoRteResourcesInline';
  sys: ResourceSys;
};

export type _Node = {
  _id: Scalars['ID'];
};

export type CfAccordionItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAccordionItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAccordionItemNestedFilter>>>;
  content_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfAccordionNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAccordionNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAccordionNestedFilter>>>;
  accountFaqPage?: InputMaybe<Scalars['String']>;
  accountFaqPage_contains?: InputMaybe<Scalars['String']>;
  accountFaqPage_exists?: InputMaybe<Scalars['Boolean']>;
  accountFaqPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  accountFaqPage_not?: InputMaybe<Scalars['String']>;
  accountFaqPage_not_contains?: InputMaybe<Scalars['String']>;
  accountFaqPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  tabsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfArPdpBoxNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfArPdpBoxNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfArPdpBoxNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfAugmentedRealityNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfAugmentedRealityNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfAugmentedRealityNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaText?: InputMaybe<Scalars['String']>;
  ctaText_contains?: InputMaybe<Scalars['String']>;
  ctaText_exists?: InputMaybe<Scalars['Boolean']>;
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaText_not?: InputMaybe<Scalars['String']>;
  ctaText_not_contains?: InputMaybe<Scalars['String']>;
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rte_contains?: InputMaybe<Scalars['String']>;
  rte_exists?: InputMaybe<Scalars['Boolean']>;
  rte_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBanderoleCountDownNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBanderoleCountDownNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBanderoleCountDownNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countDownDate?: InputMaybe<Scalars['DateTime']>;
  countDownDate_exists?: InputMaybe<Scalars['Boolean']>;
  countDownDate_gt?: InputMaybe<Scalars['DateTime']>;
  countDownDate_gte?: InputMaybe<Scalars['DateTime']>;
  countDownDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  countDownDate_lt?: InputMaybe<Scalars['DateTime']>;
  countDownDate_lte?: InputMaybe<Scalars['DateTime']>;
  countDownDate_not?: InputMaybe<Scalars['DateTime']>;
  countDownDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  disableNewsletterPopup?: InputMaybe<Scalars['Boolean']>;
  disableNewsletterPopup_exists?: InputMaybe<Scalars['Boolean']>;
  disableNewsletterPopup_not?: InputMaybe<Scalars['Boolean']>;
  discountCode?: InputMaybe<Scalars['String']>;
  discountCode_contains?: InputMaybe<Scalars['String']>;
  discountCode_exists?: InputMaybe<Scalars['Boolean']>;
  discountCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  discountCode_not?: InputMaybe<Scalars['String']>;
  discountCode_not_contains?: InputMaybe<Scalars['String']>;
  discountCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullClick?: InputMaybe<Scalars['String']>;
  fullClick_contains?: InputMaybe<Scalars['String']>;
  fullClick_exists?: InputMaybe<Scalars['Boolean']>;
  fullClick_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fullClick_not?: InputMaybe<Scalars['String']>;
  fullClick_not_contains?: InputMaybe<Scalars['String']>;
  fullClick_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hideCountDown?: InputMaybe<Scalars['Boolean']>;
  hideCountDown_exists?: InputMaybe<Scalars['Boolean']>;
  hideCountDown_not?: InputMaybe<Scalars['Boolean']>;
  hidePdpCountdown?: InputMaybe<Scalars['Boolean']>;
  hidePdpCountdown_exists?: InputMaybe<Scalars['Boolean']>;
  hidePdpCountdown_not?: InputMaybe<Scalars['Boolean']>;
  hidePromoCode?: InputMaybe<Scalars['Boolean']>;
  hidePromoCode_exists?: InputMaybe<Scalars['Boolean']>;
  hidePromoCode_not?: InputMaybe<Scalars['Boolean']>;
  hideStageCountdown?: InputMaybe<Scalars['Boolean']>;
  hideStageCountdown_exists?: InputMaybe<Scalars['Boolean']>;
  hideStageCountdown_not?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText?: InputMaybe<Scalars['String']>;
  newsletterText_contains?: InputMaybe<Scalars['String']>;
  newsletterText_exists?: InputMaybe<Scalars['Boolean']>;
  newsletterText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText_not?: InputMaybe<Scalars['String']>;
  newsletterText_not_contains?: InputMaybe<Scalars['String']>;
  newsletterText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpCategory?: InputMaybe<Scalars['String']>;
  pdpCategory_contains?: InputMaybe<Scalars['String']>;
  pdpCategory_exists?: InputMaybe<Scalars['Boolean']>;
  pdpCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpCategory_not?: InputMaybe<Scalars['String']>;
  pdpCategory_not_contains?: InputMaybe<Scalars['String']>;
  pdpCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpText?: InputMaybe<Scalars['String']>;
  pdpText_contains?: InputMaybe<Scalars['String']>;
  pdpText_exists?: InputMaybe<Scalars['Boolean']>;
  pdpText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pdpText_not?: InputMaybe<Scalars['String']>;
  pdpText_not_contains?: InputMaybe<Scalars['String']>;
  pdpText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  promoText?: InputMaybe<Scalars['String']>;
  promoText_contains?: InputMaybe<Scalars['String']>;
  promoText_exists?: InputMaybe<Scalars['Boolean']>;
  promoText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  promoText_not?: InputMaybe<Scalars['String']>;
  promoText_not_contains?: InputMaybe<Scalars['String']>;
  promoText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBanderoleNesletterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBanderoleNesletterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBanderoleNesletterNestedFilter>>>;
  activeNewsletterBlockId?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_contains?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_exists?: InputMaybe<Scalars['Boolean']>;
  activeNewsletterBlockId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  activeNewsletterBlockId_not?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_not_contains?: InputMaybe<Scalars['String']>;
  activeNewsletterBlockId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderoleNewsletterImage_exists?: InputMaybe<Scalars['Boolean']>;
  banderoleNewsletterTitle?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_contains?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_exists?: InputMaybe<Scalars['Boolean']>;
  banderoleNewsletterTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderoleNewsletterTitle_not?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_not_contains?: InputMaybe<Scalars['String']>;
  banderoleNewsletterTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderolePopupCloseIconColor?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_contains?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_exists?: InputMaybe<Scalars['Boolean']>;
  banderolePopupCloseIconColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderolePopupCloseIconColor_not?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_not_contains?: InputMaybe<Scalars['String']>;
  banderolePopupCloseIconColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfBanderoleNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBanderoleNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBanderoleNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countDown_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  sticky_exists?: InputMaybe<Scalars['Boolean']>;
  sticky_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfBlogCategoryNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfBlogCategoryNestedFilter>>>;
  categoryName?: InputMaybe<Scalars['String']>;
  categoryName_contains?: InputMaybe<Scalars['String']>;
  categoryName_exists?: InputMaybe<Scalars['Boolean']>;
  categoryName_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryName_not?: InputMaybe<Scalars['String']>;
  categoryName_not_contains?: InputMaybe<Scalars['String']>;
  categoryName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfCategorySliderModuleItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCategorySliderModuleItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCategorySliderModuleItemNestedFilter>>>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  link?: InputMaybe<Scalars['String']>;
  linkExistingPage_exists?: InputMaybe<Scalars['Boolean']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCorporateNavigationListElementNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCorporateNavigationListElementNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCorporateNavigationListElementNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  navigationListItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCorporateNavigationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCorporateNavigationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCorporateNavigationNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCorporatePageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCorporatePageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCorporatePageNestedFilter>>>;
  contentModulesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  footerColumns_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mainNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  meta_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCounterElementNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCounterElementNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCounterElementNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  numberCounter?: InputMaybe<Scalars['Int']>;
  numberCounter_exists?: InputMaybe<Scalars['Boolean']>;
  numberCounter_gt?: InputMaybe<Scalars['Int']>;
  numberCounter_gte?: InputMaybe<Scalars['Int']>;
  numberCounter_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  numberCounter_lt?: InputMaybe<Scalars['Int']>;
  numberCounter_lte?: InputMaybe<Scalars['Int']>;
  numberCounter_not?: InputMaybe<Scalars['Int']>;
  numberCounter_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfCtaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCtaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCtaNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  ctaStyle?: InputMaybe<Scalars['String']>;
  ctaStyle_contains?: InputMaybe<Scalars['String']>;
  ctaStyle_exists?: InputMaybe<Scalars['Boolean']>;
  ctaStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaStyle_not?: InputMaybe<Scalars['String']>;
  ctaStyle_not_contains?: InputMaybe<Scalars['String']>;
  ctaStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaText?: InputMaybe<Scalars['String']>;
  ctaText_contains?: InputMaybe<Scalars['String']>;
  ctaText_exists?: InputMaybe<Scalars['Boolean']>;
  ctaText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ctaText_not?: InputMaybe<Scalars['String']>;
  ctaText_not_contains?: InputMaybe<Scalars['String']>;
  ctaText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailLink?: InputMaybe<Scalars['String']>;
  eMailLink_contains?: InputMaybe<Scalars['String']>;
  eMailLink_exists?: InputMaybe<Scalars['Boolean']>;
  eMailLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailLink_not?: InputMaybe<Scalars['String']>;
  eMailLink_not_contains?: InputMaybe<Scalars['String']>;
  eMailLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkExistingPage_exists?: InputMaybe<Scalars['Boolean']>;
  linkExternalPage?: InputMaybe<Scalars['String']>;
  linkExternalPage_contains?: InputMaybe<Scalars['String']>;
  linkExternalPage_exists?: InputMaybe<Scalars['Boolean']>;
  linkExternalPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkExternalPage_not?: InputMaybe<Scalars['String']>;
  linkExternalPage_not_contains?: InputMaybe<Scalars['String']>;
  linkExternalPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkInternalUrl?: InputMaybe<Scalars['String']>;
  linkInternalUrl_contains?: InputMaybe<Scalars['String']>;
  linkInternalUrl_exists?: InputMaybe<Scalars['Boolean']>;
  linkInternalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkInternalUrl_not?: InputMaybe<Scalars['String']>;
  linkInternalUrl_not_contains?: InputMaybe<Scalars['String']>;
  linkInternalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkToEntry_exists?: InputMaybe<Scalars['Boolean']>;
  newCtaStyle?: InputMaybe<Scalars['String']>;
  newCtaStyle_contains?: InputMaybe<Scalars['String']>;
  newCtaStyle_exists?: InputMaybe<Scalars['Boolean']>;
  newCtaStyle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newCtaStyle_not?: InputMaybe<Scalars['String']>;
  newCtaStyle_not_contains?: InputMaybe<Scalars['String']>;
  newCtaStyle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneLink?: InputMaybe<Scalars['String']>;
  phoneLink_contains?: InputMaybe<Scalars['String']>;
  phoneLink_exists?: InputMaybe<Scalars['Boolean']>;
  phoneLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneLink_not?: InputMaybe<Scalars['String']>;
  phoneLink_not_contains?: InputMaybe<Scalars['String']>;
  phoneLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfDataLayerMetaNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfDataLayerMetaNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfDataLayerMetaNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  dataLayerMetaContent?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_contains?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_exists?: InputMaybe<Scalars['Boolean']>;
  dataLayerMetaContent_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dataLayerMetaContent_not?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_not_contains?: InputMaybe<Scalars['String']>;
  dataLayerMetaContent_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFooterIconBarItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFooterIconBarItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFooterIconBarItemNestedFilter>>>;
  boldText?: InputMaybe<Scalars['String']>;
  boldText_contains?: InputMaybe<Scalars['String']>;
  boldText_exists?: InputMaybe<Scalars['Boolean']>;
  boldText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  boldText_not?: InputMaybe<Scalars['String']>;
  boldText_not_contains?: InputMaybe<Scalars['String']>;
  boldText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']>;
  icon_contains?: InputMaybe<Scalars['String']>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_not?: InputMaybe<Scalars['String']>;
  icon_not_contains?: InputMaybe<Scalars['String']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_exists?: InputMaybe<Scalars['Boolean']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  normalText?: InputMaybe<Scalars['String']>;
  normalText_contains?: InputMaybe<Scalars['String']>;
  normalText_exists?: InputMaybe<Scalars['Boolean']>;
  normalText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  normalText_not?: InputMaybe<Scalars['String']>;
  normalText_not_contains?: InputMaybe<Scalars['String']>;
  normalText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfFooterNewsletterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfFooterNewsletterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfFooterNewsletterNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  list_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfHeroStageItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeroStageItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeroStageItemNestedFilter>>>;
  bynderDesktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  copyText?: InputMaybe<Scalars['String']>;
  copyText_contains?: InputMaybe<Scalars['String']>;
  copyText_exists?: InputMaybe<Scalars['Boolean']>;
  copyText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  copyText_not?: InputMaybe<Scalars['String']>;
  copyText_not_contains?: InputMaybe<Scalars['String']>;
  copyText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  countdownDate?: InputMaybe<Scalars['DateTime']>;
  countdownDate_exists?: InputMaybe<Scalars['Boolean']>;
  countdownDate_gt?: InputMaybe<Scalars['DateTime']>;
  countdownDate_gte?: InputMaybe<Scalars['DateTime']>;
  countdownDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  countdownDate_lt?: InputMaybe<Scalars['DateTime']>;
  countdownDate_lte?: InputMaybe<Scalars['DateTime']>;
  countdownDate_not?: InputMaybe<Scalars['DateTime']>;
  countdownDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']>;
  theme_contains?: InputMaybe<Scalars['String']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme_not?: InputMaybe<Scalars['String']>;
  theme_not_contains?: InputMaybe<Scalars['String']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfHeroStageModuleNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfHeroStageModuleNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfHeroStageModuleNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  displayNavigation?: InputMaybe<Scalars['Boolean']>;
  displayNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  displayNavigation_not?: InputMaybe<Scalars['Boolean']>;
  heroStageItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfImageModuleItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfImageModuleItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfImageModuleItemNestedFilter>>>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageCaption_contains?: InputMaybe<Scalars['String']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rteField_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  textDirection?: InputMaybe<Scalars['String']>;
  textDirection_contains?: InputMaybe<Scalars['String']>;
  textDirection_exists?: InputMaybe<Scalars['Boolean']>;
  textDirection_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textDirection_not?: InputMaybe<Scalars['String']>;
  textDirection_not_contains?: InputMaybe<Scalars['String']>;
  textDirection_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfLogoGridNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfLogoGridNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfLogoGridNestedFilter>>>;
  bynderImages_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  imagesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfMegaNavigationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMegaNavigationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMegaNavigationNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  mobileFirstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  theme?: InputMaybe<Scalars['String']>;
  theme_contains?: InputMaybe<Scalars['String']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme_not?: InputMaybe<Scalars['String']>;
  theme_not_contains?: InputMaybe<Scalars['String']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfMultiTeaserItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfMultiTeaserItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfMultiTeaserItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfNavCategoryWithElementsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavCategoryWithElementsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavCategoryWithElementsNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  subElementsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNavigationColumnNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationColumnNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationColumnNestedFilter>>>;
  categoriesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNavigationElementNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationElementNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationElementNestedFilter>>>;
  colorHex?: InputMaybe<Scalars['String']>;
  colorHex_contains?: InputMaybe<Scalars['String']>;
  colorHex_exists?: InputMaybe<Scalars['Boolean']>;
  colorHex_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  colorHex_not?: InputMaybe<Scalars['String']>;
  colorHex_not_contains?: InputMaybe<Scalars['String']>;
  colorHex_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  colorful?: InputMaybe<Scalars['Boolean']>;
  colorful_exists?: InputMaybe<Scalars['Boolean']>;
  colorful_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  highlightedColor?: InputMaybe<Scalars['String']>;
  highlightedColor_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_exists?: InputMaybe<Scalars['Boolean']>;
  highlightedColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  highlightedColor_not?: InputMaybe<Scalars['String']>;
  highlightedColor_not_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNavigationElementWithSubElementsNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationElementWithSubElementsNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationElementWithSubElementsNestedFilter>>>;
  bottomElement_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  highlightedColor?: InputMaybe<Scalars['String']>;
  highlightedColor_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_exists?: InputMaybe<Scalars['Boolean']>;
  highlightedColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  highlightedColor_not?: InputMaybe<Scalars['String']>;
  highlightedColor_not_contains?: InputMaybe<Scalars['String']>;
  highlightedColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  subElementsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNavigationListElementNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationListElementNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationListElementNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  isBrandsItem?: InputMaybe<Scalars['Boolean']>;
  isBrandsItem_exists?: InputMaybe<Scalars['Boolean']>;
  isBrandsItem_not?: InputMaybe<Scalars['Boolean']>;
  isColorItem?: InputMaybe<Scalars['Boolean']>;
  isColorItem_exists?: InputMaybe<Scalars['Boolean']>;
  isColorItem_not?: InputMaybe<Scalars['Boolean']>;
  mobileThirdLevelMenuImage_exists?: InputMaybe<Scalars['Boolean']>;
  navigationListItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  pageContent_exists?: InputMaybe<Scalars['Boolean']>;
  portraitImage?: InputMaybe<Scalars['Boolean']>;
  portraitImage_exists?: InputMaybe<Scalars['Boolean']>;
  portraitImage_not?: InputMaybe<Scalars['Boolean']>;
  productImage_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  thirdLevelImage_exists?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNavigationNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNavigationNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNavigationNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  firstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  mobileFirstLevelItemsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  teaser_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal?: InputMaybe<Scalars['String']>;
  titleInternal_contains?: InputMaybe<Scalars['String']>;
  titleInternal_exists?: InputMaybe<Scalars['Boolean']>;
  titleInternal_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleInternal_not?: InputMaybe<Scalars['String']>;
  titleInternal_not_contains?: InputMaybe<Scalars['String']>;
  titleInternal_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfNewsletterNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfNewsletterNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfNewsletterNestedFilter>>>;
  bynderImageDesktop_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  disclaimer_contains?: InputMaybe<Scalars['String']>;
  disclaimer_exists?: InputMaybe<Scalars['Boolean']>;
  disclaimer_not_contains?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageDesktop_exists?: InputMaybe<Scalars['Boolean']>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom?: InputMaybe<Scalars['String']>;
  spacingBottom_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_exists?: InputMaybe<Scalars['Boolean']>;
  spacingBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingBottom_not?: InputMaybe<Scalars['String']>;
  spacingBottom_not_contains?: InputMaybe<Scalars['String']>;
  spacingBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop?: InputMaybe<Scalars['String']>;
  spacingTop_contains?: InputMaybe<Scalars['String']>;
  spacingTop_exists?: InputMaybe<Scalars['Boolean']>;
  spacingTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spacingTop_not?: InputMaybe<Scalars['String']>;
  spacingTop_not_contains?: InputMaybe<Scalars['String']>;
  spacingTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subscriptionBenefits_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfPageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfPageNestedFilter>>>;
  arBox_exists?: InputMaybe<Scalars['Boolean']>;
  banderoleNewsletter_exists?: InputMaybe<Scalars['Boolean']>;
  banderole_exists?: InputMaybe<Scalars['Boolean']>;
  chatEnabled?: InputMaybe<Scalars['Boolean']>;
  chatEnabled_exists?: InputMaybe<Scalars['Boolean']>;
  chatEnabled_not?: InputMaybe<Scalars['Boolean']>;
  checkoutFooterLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  cioCollectionId?: InputMaybe<Scalars['String']>;
  cioCollectionId_contains?: InputMaybe<Scalars['String']>;
  cioCollectionId_exists?: InputMaybe<Scalars['Boolean']>;
  cioCollectionId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioCollectionId_not?: InputMaybe<Scalars['String']>;
  cioCollectionId_not_contains?: InputMaybe<Scalars['String']>;
  cioCollectionId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioGroupId?: InputMaybe<Scalars['String']>;
  cioGroupId_contains?: InputMaybe<Scalars['String']>;
  cioGroupId_exists?: InputMaybe<Scalars['Boolean']>;
  cioGroupId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioGroupId_not?: InputMaybe<Scalars['String']>;
  cioGroupId_not_contains?: InputMaybe<Scalars['String']>;
  cioGroupId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioShowVariationsStrategy?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_contains?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_exists?: InputMaybe<Scalars['Boolean']>;
  cioShowVariationsStrategy_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cioShowVariationsStrategy_not?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_not_contains?: InputMaybe<Scalars['String']>;
  cioShowVariationsStrategy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentModulesCollection_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  crossSellProducts_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellProducts_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellProducts_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  crossSellProducts_exists?: InputMaybe<Scalars['Boolean']>;
  deliveryDays?: InputMaybe<Scalars['String']>;
  deliveryDays_contains?: InputMaybe<Scalars['String']>;
  deliveryDays_exists?: InputMaybe<Scalars['Boolean']>;
  deliveryDays_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryDays_not?: InputMaybe<Scalars['String']>;
  deliveryDays_not_contains?: InputMaybe<Scalars['String']>;
  deliveryDays_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  faqAccountCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerColumnsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerIconBarCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerMetaLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  footerNewsletterText_exists?: InputMaybe<Scalars['Boolean']>;
  footerNote_exists?: InputMaybe<Scalars['Boolean']>;
  logoGridNewsletterSuccessPage_exists?: InputMaybe<Scalars['Boolean']>;
  mainMegaNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  mainNavigation_exists?: InputMaybe<Scalars['Boolean']>;
  meta_exists?: InputMaybe<Scalars['Boolean']>;
  navigationTheme?: InputMaybe<Scalars['String']>;
  navigationTheme_contains?: InputMaybe<Scalars['String']>;
  navigationTheme_exists?: InputMaybe<Scalars['Boolean']>;
  navigationTheme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  navigationTheme_not?: InputMaybe<Scalars['String']>;
  navigationTheme_not_contains?: InputMaybe<Scalars['String']>;
  navigationTheme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterConfirmationHelpLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  pageNewsletter_exists?: InputMaybe<Scalars['Boolean']>;
  preventIndexing?: InputMaybe<Scalars['Boolean']>;
  preventIndexing_exists?: InputMaybe<Scalars['Boolean']>;
  preventIndexing_not?: InputMaybe<Scalars['Boolean']>;
  productAugmentedReality_exists?: InputMaybe<Scalars['Boolean']>;
  productBenefitsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  relatedPage_exists?: InputMaybe<Scalars['Boolean']>;
  searchHelpLinksCollection_exists?: InputMaybe<Scalars['Boolean']>;
  secondaryBanderole_exists?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_exists?: InputMaybe<Scalars['Boolean']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  socialFooterIconsCollection_exists?: InputMaybe<Scalars['Boolean']>;
  stageModule_exists?: InputMaybe<Scalars['Boolean']>;
  stage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfProductBenefitNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProductBenefitNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProductBenefitNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headlineIntern?: InputMaybe<Scalars['String']>;
  headlineIntern_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_exists?: InputMaybe<Scalars['Boolean']>;
  headlineIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headlineIntern_not?: InputMaybe<Scalars['String']>;
  headlineIntern_not_contains?: InputMaybe<Scalars['String']>;
  headlineIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfProductListPageTeaserItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfProductListPageTeaserItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfProductListPageTeaserItemNestedFilter>>>;
  bynderDesktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  categoryUrl?: InputMaybe<Scalars['String']>;
  categoryUrl_contains?: InputMaybe<Scalars['String']>;
  categoryUrl_exists?: InputMaybe<Scalars['Boolean']>;
  categoryUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  categoryUrl_not?: InputMaybe<Scalars['String']>;
  categoryUrl_not_contains?: InputMaybe<Scalars['String']>;
  categoryUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  linkExistingPage_exists?: InputMaybe<Scalars['Boolean']>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfRteNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfRteNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfRteNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  rte_contains?: InputMaybe<Scalars['String']>;
  rte_exists?: InputMaybe<Scalars['Boolean']>;
  rte_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
  titleIntern?: InputMaybe<Scalars['String']>;
  titleIntern_contains?: InputMaybe<Scalars['String']>;
  titleIntern_exists?: InputMaybe<Scalars['Boolean']>;
  titleIntern_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  titleIntern_not?: InputMaybe<Scalars['String']>;
  titleIntern_not_contains?: InputMaybe<Scalars['String']>;
  titleIntern_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfSecondaryBanderoleItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSecondaryBanderoleItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSecondaryBanderoleItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText?: InputMaybe<Scalars['String']>;
  newsletterText_contains?: InputMaybe<Scalars['String']>;
  newsletterText_exists?: InputMaybe<Scalars['Boolean']>;
  newsletterText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newsletterText_not?: InputMaybe<Scalars['String']>;
  newsletterText_not_contains?: InputMaybe<Scalars['String']>;
  newsletterText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CfSecondaryBanderoleNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSecondaryBanderoleNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSecondaryBanderoleNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  banderoleContent_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sticky?: InputMaybe<Scalars['Boolean']>;
  sticky_exists?: InputMaybe<Scalars['Boolean']>;
  sticky_not?: InputMaybe<Scalars['Boolean']>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfSeoNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSeoNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSeoNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eMailSubject?: InputMaybe<Scalars['String']>;
  eMailSubject_contains?: InputMaybe<Scalars['String']>;
  eMailSubject_exists?: InputMaybe<Scalars['Boolean']>;
  eMailSubject_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailSubject_not?: InputMaybe<Scalars['String']>;
  eMailSubject_not_contains?: InputMaybe<Scalars['String']>;
  eMailSubject_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailText?: InputMaybe<Scalars['String']>;
  eMailText_contains?: InputMaybe<Scalars['String']>;
  eMailText_exists?: InputMaybe<Scalars['Boolean']>;
  eMailText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  eMailText_not?: InputMaybe<Scalars['String']>;
  eMailText_not_contains?: InputMaybe<Scalars['String']>;
  eMailText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogImage_exists?: InputMaybe<Scalars['Boolean']>;
  ogLocale?: InputMaybe<Scalars['String']>;
  ogLocale_contains?: InputMaybe<Scalars['String']>;
  ogLocale_exists?: InputMaybe<Scalars['Boolean']>;
  ogLocale_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogLocale_not?: InputMaybe<Scalars['String']>;
  ogLocale_not_contains?: InputMaybe<Scalars['String']>;
  ogLocale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogSitename?: InputMaybe<Scalars['String']>;
  ogSitename_contains?: InputMaybe<Scalars['String']>;
  ogSitename_exists?: InputMaybe<Scalars['Boolean']>;
  ogSitename_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogSitename_not?: InputMaybe<Scalars['String']>;
  ogSitename_not_contains?: InputMaybe<Scalars['String']>;
  ogSitename_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterDescription?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_contains?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_exists?: InputMaybe<Scalars['Boolean']>;
  ogTwitterDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterDescription_not?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_not_contains?: InputMaybe<Scalars['String']>;
  ogTwitterDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterTitle?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_contains?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_exists?: InputMaybe<Scalars['Boolean']>;
  ogTwitterTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogTwitterTitle_not?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_not_contains?: InputMaybe<Scalars['String']>;
  ogTwitterTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogUrl?: InputMaybe<Scalars['String']>;
  ogUrl_contains?: InputMaybe<Scalars['String']>;
  ogUrl_exists?: InputMaybe<Scalars['Boolean']>;
  ogUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ogUrl_not?: InputMaybe<Scalars['String']>;
  ogUrl_not_contains?: InputMaybe<Scalars['String']>;
  ogUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_contains?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_exists?: InputMaybe<Scalars['Boolean']>;
  seoCanonicalUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoCanonicalUrl_not?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_not_contains?: InputMaybe<Scalars['String']>;
  seoCanonicalUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoDescription?: InputMaybe<Scalars['String']>;
  seoDescription_contains?: InputMaybe<Scalars['String']>;
  seoDescription_exists?: InputMaybe<Scalars['Boolean']>;
  seoDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoDescription_not?: InputMaybe<Scalars['String']>;
  seoDescription_not_contains?: InputMaybe<Scalars['String']>;
  seoDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoKeywords_exists?: InputMaybe<Scalars['Boolean']>;
  seoNoFollow?: InputMaybe<Scalars['Boolean']>;
  seoNoFollow_exists?: InputMaybe<Scalars['Boolean']>;
  seoNoFollow_not?: InputMaybe<Scalars['Boolean']>;
  seoNoIndex?: InputMaybe<Scalars['Boolean']>;
  seoNoIndex_exists?: InputMaybe<Scalars['Boolean']>;
  seoNoIndex_not?: InputMaybe<Scalars['Boolean']>;
  seoTitle?: InputMaybe<Scalars['String']>;
  seoTitle_contains?: InputMaybe<Scalars['String']>;
  seoTitle_exists?: InputMaybe<Scalars['Boolean']>;
  seoTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoTitle_not?: InputMaybe<Scalars['String']>;
  seoTitle_not_contains?: InputMaybe<Scalars['String']>;
  seoTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  twitterCreatorId?: InputMaybe<Scalars['String']>;
  twitterCreatorId_contains?: InputMaybe<Scalars['String']>;
  twitterCreatorId_exists?: InputMaybe<Scalars['Boolean']>;
  twitterCreatorId_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterCreatorId_not?: InputMaybe<Scalars['String']>;
  twitterCreatorId_not_contains?: InputMaybe<Scalars['String']>;
  twitterCreatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterImage_exists?: InputMaybe<Scalars['Boolean']>;
  twitterTweetText?: InputMaybe<Scalars['String']>;
  twitterTweetText_contains?: InputMaybe<Scalars['String']>;
  twitterTweetText_exists?: InputMaybe<Scalars['Boolean']>;
  twitterTweetText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  twitterTweetText_not?: InputMaybe<Scalars['String']>;
  twitterTweetText_not_contains?: InputMaybe<Scalars['String']>;
  twitterTweetText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whatsappImage_exists?: InputMaybe<Scalars['Boolean']>;
  whatsappText?: InputMaybe<Scalars['String']>;
  whatsappText_contains?: InputMaybe<Scalars['String']>;
  whatsappText_exists?: InputMaybe<Scalars['Boolean']>;
  whatsappText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whatsappText_not?: InputMaybe<Scalars['String']>;
  whatsappText_not_contains?: InputMaybe<Scalars['String']>;
  whatsappText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfSeoTextNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSeoTextNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSeoTextNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seoText_contains?: InputMaybe<Scalars['String']>;
  seoText_exists?: InputMaybe<Scalars['Boolean']>;
  seoText_not_contains?: InputMaybe<Scalars['String']>;
  sys?: InputMaybe<SysFilter>;
};

export type CfShopTheLookItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfShopTheLookItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfShopTheLookItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sku?: InputMaybe<Scalars['String']>;
  sku_contains?: InputMaybe<Scalars['String']>;
  sku_exists?: InputMaybe<Scalars['Boolean']>;
  sku_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sku_not?: InputMaybe<Scalars['String']>;
  sku_not_contains?: InputMaybe<Scalars['String']>;
  sku_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  xAxis?: InputMaybe<Scalars['Int']>;
  xAxisMobile?: InputMaybe<Scalars['Int']>;
  xAxisMobile_exists?: InputMaybe<Scalars['Boolean']>;
  xAxisMobile_gt?: InputMaybe<Scalars['Int']>;
  xAxisMobile_gte?: InputMaybe<Scalars['Int']>;
  xAxisMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  xAxisMobile_lt?: InputMaybe<Scalars['Int']>;
  xAxisMobile_lte?: InputMaybe<Scalars['Int']>;
  xAxisMobile_not?: InputMaybe<Scalars['Int']>;
  xAxisMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  xAxis_exists?: InputMaybe<Scalars['Boolean']>;
  xAxis_gt?: InputMaybe<Scalars['Int']>;
  xAxis_gte?: InputMaybe<Scalars['Int']>;
  xAxis_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  xAxis_lt?: InputMaybe<Scalars['Int']>;
  xAxis_lte?: InputMaybe<Scalars['Int']>;
  xAxis_not?: InputMaybe<Scalars['Int']>;
  xAxis_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxis?: InputMaybe<Scalars['Int']>;
  yAxisMobile?: InputMaybe<Scalars['Int']>;
  yAxisMobile_exists?: InputMaybe<Scalars['Boolean']>;
  yAxisMobile_gt?: InputMaybe<Scalars['Int']>;
  yAxisMobile_gte?: InputMaybe<Scalars['Int']>;
  yAxisMobile_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxisMobile_lt?: InputMaybe<Scalars['Int']>;
  yAxisMobile_lte?: InputMaybe<Scalars['Int']>;
  yAxisMobile_not?: InputMaybe<Scalars['Int']>;
  yAxisMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxis_exists?: InputMaybe<Scalars['Boolean']>;
  yAxis_gt?: InputMaybe<Scalars['Int']>;
  yAxis_gte?: InputMaybe<Scalars['Int']>;
  yAxis_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  yAxis_lt?: InputMaybe<Scalars['Int']>;
  yAxis_lte?: InputMaybe<Scalars['Int']>;
  yAxis_not?: InputMaybe<Scalars['Int']>;
  yAxis_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CfSocialIconNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfSocialIconNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfSocialIconNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon?: InputMaybe<Scalars['String']>;
  icon_contains?: InputMaybe<Scalars['String']>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  icon_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_not?: InputMaybe<Scalars['String']>;
  icon_not_contains?: InputMaybe<Scalars['String']>;
  icon_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitile?: InputMaybe<Scalars['String']>;
  internTitile_contains?: InputMaybe<Scalars['String']>;
  internTitile_exists?: InputMaybe<Scalars['Boolean']>;
  internTitile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitile_not?: InputMaybe<Scalars['String']>;
  internTitile_not_contains?: InputMaybe<Scalars['String']>;
  internTitile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link?: InputMaybe<Scalars['String']>;
  link_contains?: InputMaybe<Scalars['String']>;
  link_exists?: InputMaybe<Scalars['Boolean']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  link_not?: InputMaybe<Scalars['String']>;
  link_not_contains?: InputMaybe<Scalars['String']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_exists?: InputMaybe<Scalars['Boolean']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfStageNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfStageNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfStageNestedFilter>>>;
  alignment?: InputMaybe<Scalars['String']>;
  alignment_contains?: InputMaybe<Scalars['String']>;
  alignment_exists?: InputMaybe<Scalars['Boolean']>;
  alignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alignment_not?: InputMaybe<Scalars['String']>;
  alignment_not_contains?: InputMaybe<Scalars['String']>;
  alignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bynderImageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  bynderImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  countDown_exists?: InputMaybe<Scalars['Boolean']>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  darkText?: InputMaybe<Scalars['Boolean']>;
  darkText_exists?: InputMaybe<Scalars['Boolean']>;
  darkText_not?: InputMaybe<Scalars['Boolean']>;
  halfWidthText?: InputMaybe<Scalars['Boolean']>;
  halfWidthText_exists?: InputMaybe<Scalars['Boolean']>;
  halfWidthText_not?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_exists?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocusMobile?: InputMaybe<Scalars['String']>;
  imageFocusMobile_contains?: InputMaybe<Scalars['String']>;
  imageFocusMobile_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocusMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocusMobile_not?: InputMaybe<Scalars['String']>;
  imageFocusMobile_not_contains?: InputMaybe<Scalars['String']>;
  imageFocusMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isFramed?: InputMaybe<Scalars['Boolean']>;
  isFramed_exists?: InputMaybe<Scalars['Boolean']>;
  isFramed_not?: InputMaybe<Scalars['Boolean']>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaContentName_exists?: InputMaybe<Scalars['Boolean']>;
  metaContentType_exists?: InputMaybe<Scalars['Boolean']>;
  miniHeadline?: InputMaybe<Scalars['String']>;
  miniHeadline_contains?: InputMaybe<Scalars['String']>;
  miniHeadline_exists?: InputMaybe<Scalars['Boolean']>;
  miniHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  miniHeadline_not?: InputMaybe<Scalars['String']>;
  miniHeadline_not_contains?: InputMaybe<Scalars['String']>;
  miniHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileAlignment?: InputMaybe<Scalars['String']>;
  mobileAlignment_contains?: InputMaybe<Scalars['String']>;
  mobileAlignment_exists?: InputMaybe<Scalars['Boolean']>;
  mobileAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileAlignment_not?: InputMaybe<Scalars['String']>;
  mobileAlignment_not_contains?: InputMaybe<Scalars['String']>;
  mobileAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  newStage?: InputMaybe<Scalars['Boolean']>;
  newStage_exists?: InputMaybe<Scalars['Boolean']>;
  newStage_not?: InputMaybe<Scalars['Boolean']>;
  promoCreativeName_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  type?: InputMaybe<Scalars['String']>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_exists?: InputMaybe<Scalars['Boolean']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type_not?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfTeaserItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTeaserItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTeaserItemNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  darkText?: InputMaybe<Scalars['Boolean']>;
  darkText_exists?: InputMaybe<Scalars['Boolean']>;
  darkText_not?: InputMaybe<Scalars['Boolean']>;
  gradientDirection?: InputMaybe<Scalars['Boolean']>;
  gradientDirection_exists?: InputMaybe<Scalars['Boolean']>;
  gradientDirection_not?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_exists?: InputMaybe<Scalars['Boolean']>;
  hasBackgroundGradient_not?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  icon_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption?: InputMaybe<Scalars['String']>;
  imageCaption_contains?: InputMaybe<Scalars['String']>;
  imageCaption_exists?: InputMaybe<Scalars['Boolean']>;
  imageCaption_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageCaption_not?: InputMaybe<Scalars['String']>;
  imageCaption_not_contains?: InputMaybe<Scalars['String']>;
  imageCaption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus?: InputMaybe<Scalars['String']>;
  imageFocus_contains?: InputMaybe<Scalars['String']>;
  imageFocus_exists?: InputMaybe<Scalars['Boolean']>;
  imageFocus_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageFocus_not?: InputMaybe<Scalars['String']>;
  imageFocus_not_contains?: InputMaybe<Scalars['String']>;
  imageFocus_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  imageMobile_exists?: InputMaybe<Scalars['Boolean']>;
  image_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle?: InputMaybe<Scalars['String']>;
  internTitle_contains?: InputMaybe<Scalars['String']>;
  internTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internTitle_not?: InputMaybe<Scalars['String']>;
  internTitle_not_contains?: InputMaybe<Scalars['String']>;
  internTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metaContentName_exists?: InputMaybe<Scalars['Boolean']>;
  metaContentType_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CfTextPicTeaserItemNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTextPicTeaserItemNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTextPicTeaserItemNestedFilter>>>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  backgroundColor_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_exists?: InputMaybe<Scalars['Boolean']>;
  backgroundColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  backgroundColor_not?: InputMaybe<Scalars['String']>;
  backgroundColor_not_contains?: InputMaybe<Scalars['String']>;
  backgroundColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonLink_contains?: InputMaybe<Scalars['String']>;
  buttonLink_exists?: InputMaybe<Scalars['Boolean']>;
  buttonLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonLink_not?: InputMaybe<Scalars['String']>;
  buttonLink_not_contains?: InputMaybe<Scalars['String']>;
  buttonLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText?: InputMaybe<Scalars['String']>;
  buttonText_contains?: InputMaybe<Scalars['String']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buttonText_not?: InputMaybe<Scalars['String']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bynderDesktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  bynderMobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  desktopImage_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginTop?: InputMaybe<Scalars['String']>;
  marginTop_contains?: InputMaybe<Scalars['String']>;
  marginTop_exists?: InputMaybe<Scalars['Boolean']>;
  marginTop_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginTop_not?: InputMaybe<Scalars['String']>;
  marginTop_not_contains?: InputMaybe<Scalars['String']>;
  marginTop_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mobileImage_exists?: InputMaybe<Scalars['Boolean']>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  textColor?: InputMaybe<Scalars['String']>;
  textColor_contains?: InputMaybe<Scalars['String']>;
  textColor_exists?: InputMaybe<Scalars['Boolean']>;
  textColor_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textColor_not?: InputMaybe<Scalars['String']>;
  textColor_not_contains?: InputMaybe<Scalars['String']>;
  textColor_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme?: InputMaybe<Scalars['String']>;
  theme_contains?: InputMaybe<Scalars['String']>;
  theme_exists?: InputMaybe<Scalars['Boolean']>;
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  theme_not?: InputMaybe<Scalars['String']>;
  theme_not_contains?: InputMaybe<Scalars['String']>;
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  videoMobile_exists?: InputMaybe<Scalars['Boolean']>;
  video_exists?: InputMaybe<Scalars['Boolean']>;
};

export type CfTextTeaserNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfTextTeaserNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfTextTeaserNestedFilter>>>;
  centerWithLeftAlign?: InputMaybe<Scalars['Boolean']>;
  centerWithLeftAlign_exists?: InputMaybe<Scalars['Boolean']>;
  centerWithLeftAlign_not?: InputMaybe<Scalars['Boolean']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  cta_exists?: InputMaybe<Scalars['Boolean']>;
  headline?: InputMaybe<Scalars['String']>;
  headline_contains?: InputMaybe<Scalars['String']>;
  headline_exists?: InputMaybe<Scalars['Boolean']>;
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  headline_not?: InputMaybe<Scalars['String']>;
  headline_not_contains?: InputMaybe<Scalars['String']>;
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle?: InputMaybe<Scalars['String']>;
  internalTitle_contains?: InputMaybe<Scalars['String']>;
  internalTitle_exists?: InputMaybe<Scalars['Boolean']>;
  internalTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalTitle_not?: InputMaybe<Scalars['String']>;
  internalTitle_not_contains?: InputMaybe<Scalars['String']>;
  internalTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom?: InputMaybe<Scalars['String']>;
  marginBottomMobile?: InputMaybe<Scalars['String']>;
  marginBottomMobile_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottomMobile_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottomMobile_not?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_contains?: InputMaybe<Scalars['String']>;
  marginBottomMobile_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_contains?: InputMaybe<Scalars['String']>;
  marginBottom_exists?: InputMaybe<Scalars['Boolean']>;
  marginBottom_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  marginBottom_not?: InputMaybe<Scalars['String']>;
  marginBottom_not_contains?: InputMaybe<Scalars['String']>;
  marginBottom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline?: InputMaybe<Scalars['String']>;
  subline_contains?: InputMaybe<Scalars['String']>;
  subline_exists?: InputMaybe<Scalars['Boolean']>;
  subline_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subline_not?: InputMaybe<Scalars['String']>;
  subline_not_contains?: InputMaybe<Scalars['String']>;
  subline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sys?: InputMaybe<SysFilter>;
  textAlignment?: InputMaybe<Scalars['String']>;
  textAlignment_contains?: InputMaybe<Scalars['String']>;
  textAlignment_exists?: InputMaybe<Scalars['Boolean']>;
  textAlignment_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textAlignment_not?: InputMaybe<Scalars['String']>;
  textAlignment_not_contains?: InputMaybe<Scalars['String']>;
  textAlignment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_exists?: InputMaybe<Scalars['Boolean']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  twoColumnLayout?: InputMaybe<Scalars['Boolean']>;
  twoColumnLayout_exists?: InputMaybe<Scalars['Boolean']>;
  twoColumnLayout_not?: InputMaybe<Scalars['Boolean']>;
};

export type CfcontentModulesMultiTypeNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfcontentModulesMultiTypeNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfcontentModulesMultiTypeNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export type AccountFaqQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type AccountFaqQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', faqAccountCollection?: { __typename?: 'PageFaqAccountCollection', items: Array<{ __typename: 'Accordion', accountFaqPage?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null } | null> } | null };

export type CtaFrFragment = { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } };

export type TiFrFragment = { __typename: 'TeaserItem', headline?: string | null, subline?: string | null, text?: string | null, darkText?: boolean | null, imageFocus?: string | null, imageCaption?: string | null, hasBackgroundGradient?: boolean | null, gradientDirection?: boolean | null, icon?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null } | null, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } };

export type RteFrFragment = { __typename: 'Rte', sys: { __typename?: 'Sys', id: string }, rte?: { __typename?: 'RteRte', json: any, links: { __typename?: 'RteRteLinks', assets: { __typename?: 'RteRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'RteRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null };

export type SeoFrFragment = { __typename?: 'Seo', seoTitle?: string | null, seoDescription?: string | null, seoCanonicalUrl?: string | null, seoKeywords?: Array<string | null> | null, seoNoIndex?: boolean | null, seoNoFollow?: boolean | null, ogLocale?: string | null, ogUrl?: string | null, ogSitename?: string | null, twitterCreatorId?: string | null, ogTwitterTitle?: string | null, ogTwitterDescription?: string | null, twitterTweetText?: string | null, whatsappText?: string | null, eMailSubject?: string | null, eMailText?: string | null, ogImage?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, twitterImage?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, whatsappImage?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null };

export type LocalizedSlugsQueryVariables = Exact<{
  slug: Scalars['String'];
  locale: Scalars['String'];
}>;


export type LocalizedSlugsQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', slugs: Array<{ __typename?: 'Page', deDE?: string | null, deAT?: string | null, frFR?: string | null, deCH?: string | null, frCH?: string | null, itCH?: string | null, itIT?: string | null, esES?: string | null, enEU?: string | null, enGB?: string | null, plPL?: string | null, svSE?: string | null, daDK?: string | null, nlNL?: string | null, csCZ?: string | null, ptPT?: string | null, fiFI?: string | null, nnNO?: string | null, relatedPage?: { __typename?: 'Page', slug?: string | null } | null } | null> } | null };

export type NavigationQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type NavigationQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', deliveryDays?: string | null, chatEnabled?: boolean | null, crossSellProducts?: Array<string | null> | null, arBox?: { __typename?: 'ArPdpBox', headline?: string | null, text?: string | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null } | null, searchHelpLinksCollection?: { __typename?: 'PageSearchHelpLinksCollection', items: Array<{ __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, footerColumnsCollection?: { __typename?: 'PageFooterColumnsCollection', items: Array<{ __typename?: 'Navigation', firstLevelItemsCollection?: { __typename?: 'NavigationFirstLevelItemsCollection', items: Array<{ __typename?: 'NavigationListElement', title?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, navigationListItemsCollection?: { __typename?: 'NavigationListElementNavigationListItemsCollection', items: Array<{ __typename?: 'NavigationListElement', title?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null } | null> } | null } | null> } | null } | null> } | null, footerNewsletterText?: { __typename?: 'FooterNewsletter', headline?: string | null, list?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string } } | null, footerIconBarCollection?: { __typename?: 'PageFooterIconBarCollection', items: Array<{ __typename?: 'FooterIconBarItem', icon?: string | null, boldText?: string | null, normalText?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, socialFooterIconsCollection?: { __typename?: 'PageSocialFooterIconsCollection', items: Array<{ __typename?: 'SocialIcon', title?: string | null, link?: string | null, icon?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, footerMetaLinksCollection?: { __typename?: 'PageFooterMetaLinksCollection', items: Array<{ __typename?: 'Cta', ctaText?: string | null, title?: string | null, linkInternalUrl?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, checkoutFooterLinksCollection?: { __typename?: 'PageCheckoutFooterLinksCollection', items: Array<{ __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, productBenefitsCollection?: { __typename?: 'PageProductBenefitsCollection', items: Array<{ __typename?: 'ProductBenefit', title?: string | null, sys: { __typename?: 'Sys', id: string }, icon?: { __typename?: 'Asset', url?: string | null, title?: string | null } | null } | null> } | null, productAugmentedReality?: { __typename?: 'AugmentedReality', headline?: string | null, ctaText?: string | null, sys: { __typename?: 'Sys', id: string }, rte?: { __typename?: 'AugmentedRealityRte', json: any, links: { __typename?: 'AugmentedRealityRteLinks', assets: { __typename?: 'AugmentedRealityRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'AugmentedRealityRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null } | null> } | null };

export type PageSeoQueryVariables = Exact<{
  locale: Scalars['String'];
  limit: Scalars['Int'];
  skip: Scalars['Int'];
}>;


export type PageSeoQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', total: number, items: Array<{ __typename?: 'Page', slug?: string | null } | null> } | null };

export type PreContentQueryVariables = Exact<{
  slug: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type PreContentQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', navigationTheme?: string | null, title?: string | null, cioCollectionId?: string | null, cioGroupId?: string | null, cioShowVariationsStrategy?: string | null, preventIndexing?: boolean | null, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> }, meta?: { __typename?: 'Seo', seoTitle?: string | null, seoDescription?: string | null, seoCanonicalUrl?: string | null, seoKeywords?: Array<string | null> | null, seoNoIndex?: boolean | null, seoNoFollow?: boolean | null, ogLocale?: string | null, ogUrl?: string | null, ogSitename?: string | null, twitterCreatorId?: string | null, ogTwitterTitle?: string | null, ogTwitterDescription?: string | null, twitterTweetText?: string | null, whatsappText?: string | null, eMailSubject?: string | null, eMailText?: string | null, ogImage?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, twitterImage?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, whatsappImage?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null } | null, stageModule?: { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | null, stage?: { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | null, contentModulesCollection?: { __typename?: 'PageContentModulesCollection', items: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory' } | { __typename: 'BlogContent' } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter' } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser' } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule' } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } | null } | null> } | null };

export type AccordionQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type AccordionQuery = { __typename?: 'Query', accordion?: { __typename: 'Accordion', headline?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, tabsCollection?: { __typename?: 'AccordionTabsCollection', items: Array<{ __typename?: 'AccordionItem', headline?: string | null, content?: { __typename: 'Rte', sys: { __typename?: 'Sys', id: string }, rte?: { __typename?: 'RteRte', json: any, links: { __typename?: 'RteRteLinks', assets: { __typename?: 'RteRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'RteRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null } | null };

export type AcTFrFragment = { __typename?: 'AccordionItem', headline?: string | null, content?: { __typename: 'Rte', sys: { __typename?: 'Sys', id: string }, rte?: { __typename?: 'RteRte', json: any, links: { __typename?: 'RteRteLinks', assets: { __typename?: 'RteRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'RteRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null, sys: { __typename?: 'Sys', id: string } };

export type BlackfridayNewsletterModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type BlackfridayNewsletterModuleQuery = { __typename?: 'Query', blackfridayNewsletterModule?: { __typename: 'BlackfridayNewsletterModule', headline?: string | null, text?: string | null, subline?: string | null, emailPlaceholder?: string | null, ctaButton?: string | null, textDirection?: boolean | null, imageHeadline?: string | null, imageSubline?: string | null, theme?: boolean | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, disclaimerOne?: { __typename?: 'BlackfridayNewsletterModuleDisclaimerOne', json: any, links: { __typename?: 'BlackfridayNewsletterModuleDisclaimerOneLinks', assets: { __typename?: 'BlackfridayNewsletterModuleDisclaimerOneAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'BlackfridayNewsletterModuleDisclaimerOneEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null, disclaimerTwo?: { __typename?: 'BlackfridayNewsletterModuleDisclaimerTwo', json: any, links: { __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoLinks', assets: { __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'BlackfridayNewsletterModuleDisclaimerTwoEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null, desktopBackground?: { __typename?: 'Asset', url?: string | null } | null, mobileBackground?: { __typename?: 'Asset', url?: string | null } | null } | null };

export type BlogOverviewModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type BlogOverviewModuleQuery = { __typename?: 'Query', blogOverviewModule?: { __typename: 'BlogOverviewModule', headline?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, categorysCollection?: { __typename?: 'BlogOverviewModuleCategorysCollection', items: Array<{ __typename: 'BlogCategory', categoryName?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null, pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', slug?: string | null, contentfulMetadata: { __typename?: 'ContentfulMetadata', tags: Array<{ __typename?: 'ContentfulTag', id?: string | null } | null> }, sys: { __typename?: 'Sys', id: string }, stage?: { __typename?: 'Stage', headline?: string | null, image?: { __typename?: 'Asset', url?: string | null, title?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', url?: string | null, title?: string | null, width?: number | null, height?: number | null, description?: string | null } | null } | null, contentModulesCollection?: { __typename?: 'PageContentModulesCollection', items: Array<{ __typename?: 'Accordion' } | { __typename?: 'BlackfridayNewsletterModule' } | { __typename: 'BlogCategory', categoryName?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent' } | { __typename?: 'BlogOverviewModule' } | { __typename?: 'CategorySliderModule' } | { __typename?: 'CustomNewsletter' } | { __typename?: 'EditorialGallery' } | { __typename?: 'HiddenHeadingH1' } | { __typename?: 'ImageModule' } | { __typename?: 'InstagramModule' } | { __typename?: 'LogoGrid' } | { __typename?: 'Lookbook' } | { __typename?: 'Newsletter' } | { __typename?: 'NewsletterModule' } | { __typename?: 'ProductListPageTeaser' } | { __typename?: 'ProductTeaser' } | { __typename?: 'ProductsSlider' } | { __typename?: 'Quote' } | { __typename?: 'SeoHeadingModule' } | { __typename?: 'SeoTextModule' } | { __typename?: 'ShopTheLook' } | { __typename?: 'Stage' } | { __typename?: 'TabModule' } | { __typename?: 'TeaserModule' } | { __typename?: 'TextImageTeaser' } | { __typename?: 'TextPicModule' } | { __typename?: 'TextTeaser' } | { __typename?: 'TocModule' } | { __typename?: 'Video' } | null> } | null } | null> } | null };

export type CatFrFragment = { __typename: 'BlogCategory', categoryName?: string | null, sys: { __typename?: 'Sys', id: string } };

export type CategorySliderModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type CategorySliderModuleQuery = { __typename?: 'Query', categorySliderModule?: { __typename: 'CategorySliderModule', title?: string | null, spacingTop?: string | null, spacingBottom?: string | null, sys: { __typename?: 'Sys', id: string }, itemsCollection?: { __typename?: 'CategorySliderModuleItemsCollection', items: Array<{ __typename?: 'CategorySliderModuleItem', title?: string | null, link?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, image?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, mobileImage?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null, title?: string | null } | null } | null> } | null } | null };

export type EditorialGalleryQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type EditorialGalleryQuery = { __typename?: 'Query', editorialGallery?: { __typename: 'EditorialGallery', headline?: string | null, text?: string | null, backgroundText?: string | null, backgroundColor?: string | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, image1?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, image2?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, image3?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, image4?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, image5?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, image6?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type BanderoleQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type BanderoleQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', deliveryDays?: string | null, banderole?: { __typename?: 'Banderole', textColor?: string | null, backgroundColor?: string | null, sticky?: boolean | null, countDown?: { __typename?: 'BanderoleCountDown', countDownDate?: any | null, promoText?: string | null, newsletterText?: string | null, pdpText?: string | null, pdpCategory?: string | null, discountCode?: string | null, disableNewsletterPopup?: boolean | null, hideCountDown?: boolean | null, hideStageCountdown?: boolean | null, hidePdpCountdown?: boolean | null, fullClick?: string | null } | null } | null, secondaryBanderole?: { __typename?: 'SecondaryBanderole', textColor?: string | null, backgroundColor?: string | null, sticky?: boolean | null, banderoleContent?: { __typename?: 'SecondaryBanderoleItem', newsletterText?: string | null } | null } | null, banderoleNewsletter?: { __typename: 'BanderoleNesletter', banderoleNewsletterTitle?: string | null, activeNewsletterBlockId?: string | null, banderolePopupCloseIconColor?: string | null, sys: { __typename?: 'Sys', id: string }, banderoleNewsletterImage?: { __typename?: 'Asset', url?: string | null } | null } | null, footerNote?: { __typename: 'Rte', sys: { __typename?: 'Sys', id: string }, rte?: { __typename?: 'RteRte', json: any, links: { __typename?: 'RteRteLinks', assets: { __typename?: 'RteRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'RteRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null } | null> } | null };

export type HeaderQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type HeaderQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', mainMegaNavigation?: { __typename?: 'MegaNavigation', firstLevelItemsCollection?: { __typename?: 'MegaNavigationFirstLevelItemsCollection', items: Array<{ __typename?: 'NavigationElementWithSubElements', title?: string | null, subline?: string | null, highlightedColor?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null, subElementsCollection?: { __typename?: 'NavigationElementWithSubElementsSubElementsCollection', items: Array<{ __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string }, categoriesCollection?: { __typename?: 'NavigationColumnCategoriesCollection', items: Array<{ __typename?: 'NavCategoryWithElements', title?: string | null, subline?: string | null, sys: { __typename?: 'Sys', id: string }, subElementsCollection?: { __typename?: 'NavCategoryWithElementsSubElementsCollection', items: Array<{ __typename?: 'NavigationElement', title?: string | null, subline?: string | null, highlightedColor?: string | null, colorHex?: string | null, colorful?: boolean | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null } | null> } | null, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null } | null> } | null } | null> } | null, bottomElement?: { __typename?: 'NavigationElement', title?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', slug?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type MobileHeaderQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type MobileHeaderQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', mainMegaNavigation?: { __typename?: 'MegaNavigation', mobileFirstLevelItemsCollection?: { __typename?: 'MegaNavigationMobileFirstLevelItemsCollection', items: Array<{ __typename?: 'NavigationElementWithSubElements', title?: string | null, subline?: string | null, highlightedColor?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null, subElementsCollection?: { __typename?: 'NavigationElementWithSubElementsSubElementsCollection', items: Array<{ __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string }, categoriesCollection?: { __typename?: 'NavigationColumnCategoriesCollection', items: Array<{ __typename?: 'NavCategoryWithElements', title?: string | null, subline?: string | null, sys: { __typename?: 'Sys', id: string }, subElementsCollection?: { __typename?: 'NavCategoryWithElementsSubElementsCollection', items: Array<{ __typename?: 'NavigationElement', title?: string | null, subline?: string | null, highlightedColor?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null } | null> } | null, pageContent?: { __typename?: 'Page', title?: string | null, slug?: string | null } | null } | null> } | null } | null> } | null, bottomElement?: { __typename?: 'NavigationElement', title?: string | null, sys: { __typename?: 'Sys', id: string }, pageContent?: { __typename?: 'Page', slug?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type HeroStageModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type HeroStageModuleQuery = { __typename?: 'Query', heroStageModule?: { __typename: 'HeroStageModule', displayNavigation?: boolean | null, sys: { __typename?: 'Sys', id: string }, heroStageItemsCollection?: { __typename?: 'HeroStageModuleHeroStageItemsCollection', items: Array<{ __typename?: 'HeroStageItem', headline?: string | null, theme?: string | null, subline?: string | null, countdownDate?: any | null, copyText?: string | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, video?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, videoMobile?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, desktopImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, mobileImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null } | null> } | null } | null };

export type HiddenH1QueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type HiddenH1Query = { __typename?: 'Query', hiddenHeadingH1?: { __typename: 'HiddenHeadingH1', hiddenH1Item?: string | null, sys: { __typename?: 'Sys', id: string } } | null };

export type ImageModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type ImageModuleQuery = { __typename?: 'Query', imageModule?: { __typename: 'ImageModule', headline?: string | null, imageCaption?: string | null, imageAspectRatio?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, richText?: { __typename?: 'ImageModuleRichText', json: any, links: { __typename?: 'ImageModuleRichTextLinks', assets: { __typename?: 'ImageModuleRichTextAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'ImageModuleRichTextEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, imagesCollection?: { __typename?: 'ImageModuleImagesCollection', items: Array<{ __typename?: 'ImageModuleItem', imageCaption?: string | null, imageFocus?: string | null, textDirection?: string | null, sys: { __typename?: 'Sys', id: string }, image?: { __typename?: 'Asset', url?: string | null, description?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, imageMobile?: { __typename?: 'Asset', url?: string | null, description?: string | null, width?: number | null, height?: number | null, title?: string | null } | null, rteField?: { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | null } | null> } | null } | null };

export type InstagramModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type InstagramModuleQuery = { __typename?: 'Query', instagramModule?: { __typename: 'InstagramModule', headline?: string | null, subline?: string | null, spacingTop?: string | null, spacingBottom?: string | null, sys: { __typename?: 'Sys', id: string }, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null } | null };

export type LogoGridQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type LogoGridQuery = { __typename?: 'Query', logoGrid?: { __typename: 'LogoGrid', marginBottom?: string | null, marginBottomMobile?: string | null, imagesCollection?: { __typename?: 'AssetCollection', items: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type LookbookQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type LookbookQuery = { __typename?: 'Query', lookbook?: { __typename: 'Lookbook', width?: number | null, height?: number | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, pagesCollection?: { __typename?: 'AssetCollection', total: number, items: Array<{ __typename?: 'Asset', url?: string | null } | null> } | null } | null };

export type NewsletterQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type NewsletterQuery = { __typename?: 'Query', newsletter?: { __typename: 'Newsletter', headline?: string | null, subscriptionBenefits?: Array<string | null> | null, spacingTop?: string | null, spacingBottom?: string | null, sys: { __typename?: 'Sys', id: string }, imageDesktop?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, disclaimer?: { __typename?: 'NewsletterDisclaimer', json: any, links: { __typename?: 'NewsletterDisclaimerLinks', assets: { __typename?: 'NewsletterDisclaimerAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'NewsletterDisclaimerEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null };

export type PageNewsletterQueryVariables = Exact<{
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type PageNewsletterQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', pageNewsletter?: { __typename: 'Newsletter', headline?: string | null, subscriptionBenefits?: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, imageDesktop?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, disclaimer?: { __typename?: 'NewsletterDisclaimer', json: any, links: { __typename?: 'NewsletterDisclaimerLinks', entries: { __typename?: 'NewsletterDisclaimerEntries', hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null } | null> } | null };

export type ProductPageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ProductPageQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<{ __typename?: 'Page', sys: { __typename?: 'Sys', id: string } } | null> } | null };

export type ProductTeaserQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type ProductTeaserQuery = { __typename?: 'Query', productTeaser?: { __typename: 'ProductTeaser', headline?: string | null, urlKey?: Array<string | null> | null, descriptionHeadline?: string | null, descriptionText?: string | null, imageIsRight?: boolean | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null } | null };

export type QuoteQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type QuoteQuery = { __typename?: 'Query', quote?: { __typename: 'Quote', isSimpleVariant?: boolean | null, quoteText?: string | null, quoteAuthorName?: string | null, quoteAuthorInfo?: string | null, organicShapeColor?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type RteFieldQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type RteFieldQuery = { __typename?: 'Query', rte?: { __typename?: 'Rte', rte?: { __typename?: 'RteRte', json: any, links: { __typename?: 'RteRteLinks', assets: { __typename?: 'RteRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'RteRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null };

export type ProductsSliderQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type ProductsSliderQuery = { __typename?: 'Query', productsSlider?: { __typename: 'ProductsSlider', urlKey?: Array<string | null> | null, skus?: Array<string | null> | null, cioRecommendationsId?: string | null, cioRecommendationsFilterName?: string | null, cioRecommendationsFilterValue?: string | null, cioRecommendationsResultsLimit?: number | null, headline?: string | null, spacingTop?: string | null, spacingBottom?: string | null, link?: string | null, sys: { __typename?: 'Sys', id: string }, firstTeaser?: { __typename: 'TeaserItem', headline?: string | null, subline?: string | null, text?: string | null, darkText?: boolean | null, imageFocus?: string | null, imageCaption?: string | null, hasBackgroundGradient?: boolean | null, gradientDirection?: boolean | null, icon?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null } | null, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, lastTeaser?: { __typename: 'TeaserItem', headline?: string | null, subline?: string | null, text?: string | null, darkText?: boolean | null, imageFocus?: string | null, imageCaption?: string | null, hasBackgroundGradient?: boolean | null, gradientDirection?: boolean | null, icon?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null } | null, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null } | null };

export type SeoHeadingModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type SeoHeadingModuleQuery = { __typename?: 'Query', seoHeadingModule?: { __typename: 'SeoHeadingModule', headline?: string | null, subline?: string | null, description?: string | null, spacingTop?: string | null, spacingBottom?: string | null, sys: { __typename?: 'Sys', id: string } } | null };

export type SeoTextModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type SeoTextModuleQuery = { __typename?: 'Query', seoTextModule?: { __typename?: 'SeoTextModule', spacingTop?: string | null, spacingBottom?: string | null, sys: { __typename?: 'Sys', id: string }, seoTextsCollection?: { __typename?: 'SeoTextModuleSeoTextsCollection', items: Array<{ __typename?: 'SeoText', headline?: string | null, sys: { __typename?: 'Sys', id: string }, seoText?: { __typename?: 'SeoTextSeoText', json: any, links: { __typename?: 'SeoTextSeoTextLinks', entries: { __typename?: 'SeoTextSeoTextEntries', inline: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoText', headline?: string | null, seoText?: { __typename?: 'SeoTextSeoText', json: any } | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, block: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoText', headline?: string | null, seoText?: { __typename?: 'SeoTextSeoText', json: any } | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null> }, assets: { __typename?: 'SeoTextSeoTextAssets', block: Array<{ __typename?: 'Asset', url?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Asset', url?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null> } | null } | null };

export type SeoTextFieldsFragment = { __typename?: 'SeoText', headline?: string | null, sys: { __typename?: 'Sys', id: string }, seoText?: { __typename?: 'SeoTextSeoText', json: any, links: { __typename?: 'SeoTextSeoTextLinks', entries: { __typename?: 'SeoTextSeoTextEntries', inline: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoText', headline?: string | null, seoText?: { __typename?: 'SeoTextSeoText', json: any } | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, block: Array<{ __typename: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Page', title?: string | null, slug?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoText', headline?: string | null, seoText?: { __typename?: 'SeoTextSeoText', json: any } | null, sys: { __typename?: 'Sys', id: string } } | { __typename: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Video', sys: { __typename?: 'Sys', id: string } } | null> }, assets: { __typename?: 'SeoTextSeoTextAssets', block: Array<{ __typename?: 'Asset', url?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Asset', url?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null };

export type ShopTheLookQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type ShopTheLookQuery = { __typename?: 'Query', shopTheLook?: { __typename: 'ShopTheLook', headline?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, firstImageFocus?: string | null, firstImageFocusMobile?: string | null, secondImageFocus?: string | null, secondImageFocusMobile?: string | null, thirdImageFocus?: string | null, thirdImageFocusMobile?: string | null, fourthImageFocus?: string | null, fourthImageFocusMobile?: string | null, firstImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, firstImageProductButtonsCollection?: { __typename?: 'ShopTheLookFirstImageProductButtonsCollection', items: Array<{ __typename?: 'ShopTheLookItem', sku?: string | null, xAxis?: number | null, yAxis?: number | null, xAxisMobile?: number | null, yAxisMobile?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, secondImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, secondImageProductButtonsCollection?: { __typename?: 'ShopTheLookSecondImageProductButtonsCollection', items: Array<{ __typename?: 'ShopTheLookItem', sku?: string | null, xAxis?: number | null, yAxis?: number | null, xAxisMobile?: number | null, yAxisMobile?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, thirdImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, thirdImageProductButtonsCollection?: { __typename?: 'ShopTheLookThirdImageProductButtonsCollection', items: Array<{ __typename?: 'ShopTheLookItem', sku?: string | null, xAxis?: number | null, yAxis?: number | null, xAxisMobile?: number | null, yAxisMobile?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, fourthImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, fourthImageProductButtonsCollection?: { __typename?: 'ShopTheLookFourthImageProductButtonsCollection', items: Array<{ __typename?: 'ShopTheLookItem', sku?: string | null, xAxis?: number | null, yAxis?: number | null, xAxisMobile?: number | null, yAxisMobile?: number | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type StlItemFrFragment = { __typename?: 'ShopTheLookItem', sku?: string | null, xAxis?: number | null, yAxis?: number | null, xAxisMobile?: number | null, yAxisMobile?: number | null, sys: { __typename?: 'Sys', id: string } };

export type StageQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type StageQuery = { __typename?: 'Query', stage?: { __typename: 'Stage', type?: string | null, miniHeadline?: string | null, headline?: string | null, subline?: string | null, isFramed?: boolean | null, alignment?: string | null, imageFocus?: string | null, darkText?: boolean | null, imageFocusMobile?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, hasBackgroundGradient?: boolean | null, halfWidthText?: boolean | null, newStage?: boolean | null, mobileAlignment?: string | null, sys: { __typename?: 'Sys', id: string }, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, video?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, videoMobile?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, countDown?: { __typename?: 'BanderoleCountDown', countDownDate?: any | null, promoText?: string | null, newsletterText?: string | null, pdpText?: string | null, pdpCategory?: string | null, discountCode?: string | null, hideCountDown?: boolean | null, hideStageCountdown?: boolean | null, hidePdpCountdown?: boolean | null, hidePromoCode?: boolean | null } | null, promoCreativeName?: { __typename?: 'DataLayerMeta', dataLayerMetaContent?: string | null } | null, metaContentType?: { __typename?: 'DataLayerMeta', dataLayerMetaContent?: string | null } | null, metaContentName?: { __typename?: 'DataLayerMeta', dataLayerMetaContent?: string | null } | null } | null };

export type TabModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type TabModuleQuery = { __typename?: 'Query', tabModule?: { __typename: 'TabModule', marginBottom?: string | null, marginBottomMobile?: string | null, tabsCollection?: { __typename?: 'TabModuleTabsCollection', items: Array<{ __typename?: 'AccordionItem', headline?: string | null, content?: { __typename: 'Rte', sys: { __typename?: 'Sys', id: string }, rte?: { __typename?: 'RteRte', json: any, links: { __typename?: 'RteRteLinks', assets: { __typename?: 'RteRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'RteRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null, sys: { __typename?: 'Sys', id: string } } | null };

export type TeaserModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type TeaserModuleQuery = { __typename?: 'Query', teaserModule?: { __typename: 'TeaserModule', headline?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, teaserItemsCollection?: { __typename?: 'TeaserModuleTeaserItemsCollection', items: Array<{ __typename: 'TeaserItem', headline?: string | null, subline?: string | null, text?: string | null, darkText?: boolean | null, imageFocus?: string | null, imageCaption?: string | null, hasBackgroundGradient?: boolean | null, gradientDirection?: boolean | null, icon?: { __typename?: 'Asset', url?: string | null, width?: number | null, height?: number | null } | null, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null> } | null } | null };

export type TextImageTeaserQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type TextImageTeaserQuery = { __typename?: 'Query', textImageTeaser?: { __typename: 'TextImageTeaser', imageCaption?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, organicShapeColor?: string | null, handleOrganicShape?: string | null, selectShapeView?: string | null, mobileImageBottom?: boolean | null, imageDesktopLeft?: boolean | null, subHeadline?: string | null, headline?: string | null, centerTextAlignment?: boolean | null, noSidePadding?: boolean | null, sys: { __typename?: 'Sys', id: string }, image?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, imageMobile?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, text?: { __typename?: 'TextImageTeaserText', json: any, links: { __typename?: 'TextImageTeaserTextLinks', assets: { __typename?: 'TextImageTeaserTextAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'TextImageTeaserTextEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null, mobileText?: { __typename?: 'TextImageTeaserMobileText', json: any, links: { __typename?: 'TextImageTeaserMobileTextLinks', assets: { __typename?: 'TextImageTeaserMobileTextAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'TextImageTeaserMobileTextEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null, icon?: { __typename?: 'Asset', title?: string | null } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null } | null };

export type TextPicTeaserModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type TextPicTeaserModuleQuery = { __typename?: 'Query', textPicModule?: { __typename: 'TextPicModule', sys: { __typename?: 'Sys', id: string }, itemsCollection?: { __typename?: 'TextPicModuleItemsCollection', items: Array<{ __typename?: 'TextPicTeaserItem', headline?: string | null, subline?: string | null, backgroundColor?: string | null, textColor?: string | null, theme?: string | null, video?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, videoMobile?: { __typename?: 'Asset', url?: string | null, description?: string | null, title?: string | null, contentType?: string | null } | null, desktopImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, mobileImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, description?: string | null } | null, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null } | null> } | null } | null };

export type TextTeaserQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type TextTeaserQuery = { __typename?: 'Query', textTeaser?: { __typename: 'TextTeaser', headline?: string | null, subline?: string | null, textAlignment?: string | null, centerWithLeftAlign?: boolean | null, twoColumnLayout?: boolean | null, marginBottom?: string | null, marginBottomMobile?: string | null, sys: { __typename?: 'Sys', id: string }, cta?: { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null, sys: { __typename?: 'Sys', id: string } } | null, text?: { __typename?: 'TextTeaserText', json: any, links: { __typename?: 'TextTeaserTextLinks', assets: { __typename?: 'TextTeaserTextAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'TextTeaserTextEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null } | null };

export type VideoModuleQueryVariables = Exact<{
  id: Scalars['String'];
  preview: Scalars['Boolean'];
  locale: Scalars['String'];
}>;


export type VideoModuleQuery = { __typename?: 'Query', video?: { __typename: 'Video', headline?: string | null, organicShapeColor?: string | null, handleOrganicShape?: string | null, marginBottom?: string | null, marginBottomMobile?: string | null, youTubeUrl?: string | null, autoPlay?: boolean | null, unmuted?: boolean | null, videoWidth?: number | null, hideControls?: boolean | null, mobileVideoAboveText?: boolean | null, desktopVideoLeft?: boolean | null, rte?: { __typename?: 'VideoRte', json: any, links: { __typename?: 'VideoRteLinks', assets: { __typename?: 'VideoRteAssets', block: Array<{ __typename?: 'Asset', title?: string | null, url?: string | null, width?: number | null, height?: number | null, sys: { __typename?: 'Sys', id: string } } | null> }, entries: { __typename?: 'VideoRteEntries', block: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, hyperlink: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null>, inline: Array<{ __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AccordionItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ArPdpBox', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'AugmentedReality', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Banderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleCountDown', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BanderoleNesletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlackfridayNewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogCategory', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogContent', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CategorySliderModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporateNavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CorporatePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'CounterModule', sys: { __typename?: 'Sys', id: string } } | { __typename: 'Cta', ctaText?: string | null, ctaStyle?: string | null, newCtaStyle?: string | null, linkExternalPage?: string | null, linkInternalUrl?: string | null, phoneLink?: string | null, eMailLink?: string | null, sys: { __typename?: 'Sys', id: string }, linkExistingPage?: { __typename?: 'Page', slug?: string | null, title?: string | null } | null, linkToEntry?: { __typename?: 'Accordion', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BlogOverviewModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null } | { __typename?: 'CustomNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'DataLayerMeta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'EditorialGallery', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterIconBarItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'FooterNewsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HeroStageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HiddenHeadingH1', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ImageModuleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'InstagramModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JavascriptModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LogoGrid', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Lookbook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MegaNavigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MultiTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavCategoryWithElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Navigation', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationElementWithSubElements', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NavigationListElement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Newsletter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'NewsletterModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Page', slug?: string | null, title?: string | null, sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductBenefit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductListPageTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ProductsSlider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Quote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Rte', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderole', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SecondaryBanderoleItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Seo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoHeadingModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SeoTextModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLook', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ShopTheLookItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SocialIcon', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Stage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TabModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeaserModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextImageTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextPicTeaserItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TextTeaser', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TocModule', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Video', sys: { __typename?: 'Sys', id: string } } | null> } } } | null, videoFile?: { __typename?: 'Asset', url?: string | null, contentType?: string | null } | null, placeholderImage?: { __typename?: 'Asset', title?: string | null, url?: string | null, contentType?: string | null } | null, sys: { __typename?: 'Sys', id: string } } | null };

export const CtaFrFragmentDoc = `
    fragment CtaFr on Cta {
  ctaText
  ctaStyle
  newCtaStyle
  linkExistingPage {
    slug
    title
  }
  linkExternalPage
  linkInternalUrl
  linkToEntry {
    ... on Entry {
      sys {
        id
      }
    }
  }
  phoneLink
  eMailLink
  __typename
  sys {
    id
  }
}
    `;
export const TiFrFragmentDoc = `
    fragment TIFr on TeaserItem {
  headline
  subline
  text
  darkText
  imageFocus
  imageCaption
  hasBackgroundGradient
  gradientDirection
  icon {
    url
    width
    height
  }
  image {
    title
    url
    width
    height
    description
  }
  imageMobile {
    title
    url
    width
    height
    description
  }
  cta {
    ...CtaFr
  }
  __typename
  sys {
    id
  }
}
    `;
export const SeoFrFragmentDoc = `
    fragment SeoFr on Seo {
  seoTitle
  seoDescription
  seoCanonicalUrl
  seoKeywords
  seoNoIndex
  seoNoFollow
  ogLocale
  ogUrl
  ogSitename
  twitterCreatorId
  ogTwitterTitle
  ogTwitterDescription
  ogImage {
    url
    description
    title
    contentType
  }
  twitterImage {
    url
    description
    title
    contentType
  }
  twitterTweetText
  whatsappImage {
    url
    description
    title
    contentType
  }
  whatsappText
  eMailSubject
  eMailText
}
    `;
export const RteFrFragmentDoc = `
    fragment rteFr on Rte {
  __typename
  sys {
    id
  }
  rte {
    json
    links {
      assets {
        block {
          title
          url
          width
          height
          sys {
            id
          }
        }
      }
      entries {
        block {
          ... on Cta {
            ...CtaFr
          }
          ... on Page {
            slug
            title
          }
          sys {
            id
          }
        }
        hyperlink {
          ... on Cta {
            ...CtaFr
          }
          ... on Page {
            slug
            title
          }
          sys {
            id
          }
        }
        inline {
          ... on Cta {
            ...CtaFr
          }
          ... on Page {
            slug
            title
          }
          sys {
            id
          }
        }
      }
    }
  }
}
    `;
export const AcTFrFragmentDoc = `
    fragment AcTFr on AccordionItem {
  headline
  content {
    ...rteFr
  }
  sys {
    id
  }
}
    `;
export const CatFrFragmentDoc = `
    fragment CatFr on BlogCategory {
  categoryName
  __typename
  sys {
    id
  }
}
    `;
export const SeoTextFieldsFragmentDoc = `
    fragment SeoTextFields on SeoText {
  sys {
    id
  }
  headline
  seoText {
    json
    links {
      entries {
        inline {
          sys {
            id
          }
          __typename
          ... on Page {
            title
            slug
          }
          ... on SeoText {
            headline
            seoText {
              json
            }
          }
        }
        hyperlink {
          sys {
            id
          }
          __typename
          ... on Page {
            title
            slug
          }
        }
        block {
          sys {
            id
          }
          __typename
          ... on Page {
            title
            slug
          }
          ... on SeoText {
            headline
            seoText {
              json
            }
          }
        }
      }
      assets {
        block {
          sys {
            id
          }
          url
          title
        }
        hyperlink {
          sys {
            id
          }
          url
          title
        }
      }
    }
  }
}
    `;
export const StlItemFrFragmentDoc = `
    fragment StlItemFr on ShopTheLookItem {
  sku
  xAxis
  yAxis
  xAxisMobile
  yAxisMobile
  sys {
    id
  }
}
    `;
export const AccountFaqDocument = `
    query AccountFaq($preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: "home"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      faqAccountCollection {
        items {
          ... on Accordion {
            __typename
            accountFaqPage
            sys {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const useAccountFaqQuery = <
      TData = AccountFaqQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: AccountFaqQueryVariables,
      options?: UseQueryOptions<AccountFaqQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccountFaqQuery, TError, TData>(
      ['AccountFaq', variables],
      fetcher<AccountFaqQuery, AccountFaqQueryVariables>(client, AccountFaqDocument, variables, headers),
      options
    );
useAccountFaqQuery.document = AccountFaqDocument;


useAccountFaqQuery.getKey = (variables: AccountFaqQueryVariables) => ['AccountFaq', variables];
;

export const LocalizedSlugsDocument = `
    query localizedSlugs($slug: String!, $locale: String!) {
  pageCollection(where: {slug: $slug}, locale: $locale, limit: 1) {
    slugs: items {
      deDE: slug(locale: "de-DE")
      deAT: slug(locale: "de-AT")
      frFR: slug(locale: "fr-FR")
      deCH: slug(locale: "de-CH")
      frCH: slug(locale: "fr-CH")
      itCH: slug(locale: "it-CH")
      itIT: slug(locale: "it-IT")
      esES: slug(locale: "es-ES")
      enEU: slug(locale: "en-EU")
      enGB: slug(locale: "en-GB")
      plPL: slug(locale: "pl-PL")
      svSE: slug(locale: "sv-SE")
      daDK: slug(locale: "da-DK")
      nlNL: slug(locale: "nl-NL")
      csCZ: slug(locale: "cs-CZ")
      ptPT: slug(locale: "pt-PT")
      fiFI: slug(locale: "fi-FI")
      nnNO: slug(locale: "nn-NO")
      relatedPage {
        slug
      }
    }
  }
}
    `;
export const useLocalizedSlugsQuery = <
      TData = LocalizedSlugsQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: LocalizedSlugsQueryVariables,
      options?: UseQueryOptions<LocalizedSlugsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LocalizedSlugsQuery, TError, TData>(
      ['localizedSlugs', variables],
      fetcher<LocalizedSlugsQuery, LocalizedSlugsQueryVariables>(client, LocalizedSlugsDocument, variables, headers),
      options
    );
useLocalizedSlugsQuery.document = LocalizedSlugsDocument;


useLocalizedSlugsQuery.getKey = (variables: LocalizedSlugsQueryVariables) => ['localizedSlugs', variables];
;

export const NavigationDocument = `
    query navigation($preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: "home"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      deliveryDays
      chatEnabled
      arBox {
        headline
        text
        cta {
          ...CtaFr
        }
      }
      searchHelpLinksCollection(limit: 8) {
        items {
          ...CtaFr
        }
      }
      crossSellProducts
      footerColumnsCollection {
        items {
          firstLevelItemsCollection(limit: 3) {
            items {
              sys {
                id
              }
              title
              pageContent {
                slug
                title
              }
              navigationListItemsCollection(limit: 7) {
                items {
                  sys {
                    id
                  }
                  title
                  pageContent {
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      }
      footerNewsletterText {
        sys {
          id
        }
        headline
        list
      }
      footerIconBarCollection(limit: 6) {
        items {
          ... on FooterIconBarItem {
            icon
            boldText
            normalText
            sys {
              id
            }
          }
        }
      }
      socialFooterIconsCollection(limit: 6) {
        items {
          sys {
            id
          }
          title
          link
          icon
        }
      }
      footerMetaLinksCollection(limit: 6) {
        items {
          sys {
            id
          }
          ctaText
          title
          linkInternalUrl
        }
      }
      checkoutFooterLinksCollection(limit: 3) {
        items {
          ...CtaFr
        }
      }
      productBenefitsCollection {
        items {
          sys {
            id
          }
          title
          icon {
            url
            title
          }
        }
      }
      productAugmentedReality {
        sys {
          id
        }
        headline
        ctaText
        rte {
          json
          links {
            assets {
              block {
                title
                url
                width
                height
                sys {
                  id
                }
              }
            }
            entries {
              block {
                ... on Cta {
                  ...CtaFr
                }
                ... on Page {
                  slug
                  title
                }
                sys {
                  id
                }
              }
              hyperlink {
                ... on Cta {
                  ...CtaFr
                }
                ... on Page {
                  slug
                  title
                }
                sys {
                  id
                }
              }
              inline {
                ... on Cta {
                  ...CtaFr
                }
                ... on Page {
                  slug
                  title
                }
                sys {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useNavigationQuery = <
      TData = NavigationQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: NavigationQueryVariables,
      options?: UseQueryOptions<NavigationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<NavigationQuery, TError, TData>(
      ['navigation', variables],
      fetcher<NavigationQuery, NavigationQueryVariables>(client, NavigationDocument, variables, headers),
      options
    );
useNavigationQuery.document = NavigationDocument;


useNavigationQuery.getKey = (variables: NavigationQueryVariables) => ['navigation', variables];
;

export const PageSeoDocument = `
    query pageSeo($locale: String!, $limit: Int!, $skip: Int!) {
  pageCollection(limit: $limit, locale: $locale, skip: $skip) {
    items {
      slug
    }
    total
  }
}
    `;
export const usePageSeoQuery = <
      TData = PageSeoQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: PageSeoQueryVariables,
      options?: UseQueryOptions<PageSeoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PageSeoQuery, TError, TData>(
      ['pageSeo', variables],
      fetcher<PageSeoQuery, PageSeoQueryVariables>(client, PageSeoDocument, variables, headers),
      options
    );
usePageSeoQuery.document = PageSeoDocument;


usePageSeoQuery.getKey = (variables: PageSeoQueryVariables) => ['pageSeo', variables];
;

export const PreContentDocument = `
    query preContent($slug: String!, $preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: $slug}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      navigationTheme
      title
      contentfulMetadata {
        tags {
          id
        }
      }
      meta {
        ...SeoFr
      }
      stageModule {
        ... on HeroStageModule {
          __typename
          sys {
            id
          }
        }
      }
      stage {
        ... on Stage {
          __typename
          sys {
            id
          }
        }
      }
      cioCollectionId
      cioGroupId
      cioShowVariationsStrategy
      preventIndexing
      contentModulesCollection {
        ... on PageContentModulesCollection {
          items {
            __typename
            ... on TextImageTeaser {
              __typename
              sys {
                id
              }
            }
            ... on Accordion {
              __typename
              sys {
                id
              }
            }
            ... on TextPicModule {
              __typename
              sys {
                id
              }
            }
            ... on SeoHeadingModule {
              __typename
              sys {
                id
              }
            }
            ... on CategorySliderModule {
              __typename
              sys {
                id
              }
            }
            ... on Quote {
              __typename
              sys {
                id
              }
            }
            ... on LogoGrid {
              __typename
              sys {
                id
              }
            }
            ... on Video {
              __typename
              sys {
                id
              }
            }
            ... on TextTeaser {
              __typename
              sys {
                id
              }
            }
            ... on SeoTextModule {
              __typename
              sys {
                id
              }
            }
            ... on Stage {
              __typename
              sys {
                id
              }
            }
            ... on ImageModule {
              __typename
              sys {
                id
              }
            }
            ... on TeaserModule {
              __typename
              sys {
                id
              }
            }
            ... on Accordion {
              __typename
              sys {
                id
              }
            }
            ... on EditorialGallery {
              __typename
              sys {
                id
              }
            }
            ... on NewsletterModule {
              __typename
              sys {
                id
              }
            }
            ... on Newsletter {
              __typename
              sys {
                id
              }
            }
            ... on ShopTheLook {
              __typename
              sys {
                id
              }
            }
            ... on ProductsSlider {
              __typename
              sys {
                id
              }
            }
            ... on ProductTeaser {
              __typename
              sys {
                id
              }
            }
            ... on BlogOverviewModule {
              __typename
              sys {
                id
              }
            }
            ... on TabModule {
              __typename
              sys {
                id
              }
            }
            ... on InstagramModule {
              __typename
              sys {
                id
              }
            }
            ... on BlackfridayNewsletterModule {
              __typename
              sys {
                id
              }
            }
            ... on Lookbook {
              __typename
              sys {
                id
              }
            }
            ... on HiddenHeadingH1 {
              __typename
              sys {
                id
              }
            }
          }
        }
      }
    }
  }
}
    ${SeoFrFragmentDoc}`;
export const usePreContentQuery = <
      TData = PreContentQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: PreContentQueryVariables,
      options?: UseQueryOptions<PreContentQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PreContentQuery, TError, TData>(
      ['preContent', variables],
      fetcher<PreContentQuery, PreContentQueryVariables>(client, PreContentDocument, variables, headers),
      options
    );
usePreContentQuery.document = PreContentDocument;


usePreContentQuery.getKey = (variables: PreContentQueryVariables) => ['preContent', variables];
;

export const AccordionDocument = `
    query Accordion($id: String!, $preview: Boolean!, $locale: String!) {
  accordion(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    tabsCollection(limit: 5) {
      items {
        ...AcTFr
      }
    }
    marginBottom
    marginBottomMobile
  }
}
    ${AcTFrFragmentDoc}
${RteFrFragmentDoc}
${CtaFrFragmentDoc}`;
export const useAccordionQuery = <
      TData = AccordionQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: AccordionQueryVariables,
      options?: UseQueryOptions<AccordionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<AccordionQuery, TError, TData>(
      ['Accordion', variables],
      fetcher<AccordionQuery, AccordionQueryVariables>(client, AccordionDocument, variables, headers),
      options
    );
useAccordionQuery.document = AccordionDocument;


useAccordionQuery.getKey = (variables: AccordionQueryVariables) => ['Accordion', variables];
;

export const BlackfridayNewsletterModuleDocument = `
    query BlackfridayNewsletterModule($id: String!, $preview: Boolean!, $locale: String!) {
  blackfridayNewsletterModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    text
    subline
    emailPlaceholder
    ctaButton
    disclaimerOne {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    disclaimerTwo {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    textDirection
    imageHeadline
    imageSubline
    desktopBackground {
      url
    }
    mobileBackground {
      url
    }
    theme
    marginBottom
    marginBottomMobile
  }
}
    ${CtaFrFragmentDoc}`;
export const useBlackfridayNewsletterModuleQuery = <
      TData = BlackfridayNewsletterModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: BlackfridayNewsletterModuleQueryVariables,
      options?: UseQueryOptions<BlackfridayNewsletterModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BlackfridayNewsletterModuleQuery, TError, TData>(
      ['BlackfridayNewsletterModule', variables],
      fetcher<BlackfridayNewsletterModuleQuery, BlackfridayNewsletterModuleQueryVariables>(client, BlackfridayNewsletterModuleDocument, variables, headers),
      options
    );
useBlackfridayNewsletterModuleQuery.document = BlackfridayNewsletterModuleDocument;


useBlackfridayNewsletterModuleQuery.getKey = (variables: BlackfridayNewsletterModuleQueryVariables) => ['BlackfridayNewsletterModule', variables];
;

export const BlogOverviewModuleDocument = `
    query BlogOverviewModule($id: String!, $preview: Boolean!, $locale: String!) {
  blogOverviewModule(id: $id, preview: $preview, locale: $locale) {
    categorysCollection {
      items {
        ...CatFr
      }
    }
    __typename
    sys {
      id
    }
    headline
    marginBottom
    marginBottomMobile
  }
  pageCollection(
    where: {contentfulMetadata: {tags: {id_contains_all: "blog"}}}
    limit: 200
    preview: $preview
    locale: $locale
  ) {
    items {
      contentfulMetadata {
        tags {
          id
        }
      }
      sys {
        id
      }
      slug
      stage {
        ... on Stage {
          headline
          image {
            url
            title
            width
            height
            description
          }
          imageMobile {
            url
            title
            width
            height
            description
          }
        }
      }
      contentModulesCollection(limit: 25) {
        items {
          ...CatFr
        }
      }
    }
  }
}
    ${CatFrFragmentDoc}`;
export const useBlogOverviewModuleQuery = <
      TData = BlogOverviewModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: BlogOverviewModuleQueryVariables,
      options?: UseQueryOptions<BlogOverviewModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BlogOverviewModuleQuery, TError, TData>(
      ['BlogOverviewModule', variables],
      fetcher<BlogOverviewModuleQuery, BlogOverviewModuleQueryVariables>(client, BlogOverviewModuleDocument, variables, headers),
      options
    );
useBlogOverviewModuleQuery.document = BlogOverviewModuleDocument;


useBlogOverviewModuleQuery.getKey = (variables: BlogOverviewModuleQueryVariables) => ['BlogOverviewModule', variables];
;

export const CategorySliderModuleDocument = `
    query CategorySliderModule($id: String!, $preview: Boolean!, $locale: String!) {
  categorySliderModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    title
    spacingTop
    spacingBottom
    itemsCollection {
      items {
        linkExistingPage {
          slug
          title
        }
        title
        image {
          url
          width
          height
          title
        }
        mobileImage {
          url
          width
          height
          title
        }
        link
      }
    }
  }
}
    `;
export const useCategorySliderModuleQuery = <
      TData = CategorySliderModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: CategorySliderModuleQueryVariables,
      options?: UseQueryOptions<CategorySliderModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CategorySliderModuleQuery, TError, TData>(
      ['CategorySliderModule', variables],
      fetcher<CategorySliderModuleQuery, CategorySliderModuleQueryVariables>(client, CategorySliderModuleDocument, variables, headers),
      options
    );
useCategorySliderModuleQuery.document = CategorySliderModuleDocument;


useCategorySliderModuleQuery.getKey = (variables: CategorySliderModuleQueryVariables) => ['CategorySliderModule', variables];
;

export const EditorialGalleryDocument = `
    query EditorialGallery($id: String!, $preview: Boolean!, $locale: String!) {
  editorialGallery(id: $id, preview: $preview, locale: $locale) {
    headline
    text
    backgroundText
    backgroundColor
    cta {
      ...CtaFr
    }
    image1 {
      title
      url
      width
      height
      description
    }
    image2 {
      title
      url
      width
      height
      description
    }
    image3 {
      title
      url
      width
      height
      description
    }
    image4 {
      title
      url
      width
      height
      description
    }
    image5 {
      title
      url
      width
      height
      description
    }
    image6 {
      title
      url
      width
      height
      description
    }
    __typename
    sys {
      id
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useEditorialGalleryQuery = <
      TData = EditorialGalleryQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: EditorialGalleryQueryVariables,
      options?: UseQueryOptions<EditorialGalleryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<EditorialGalleryQuery, TError, TData>(
      ['EditorialGallery', variables],
      fetcher<EditorialGalleryQuery, EditorialGalleryQueryVariables>(client, EditorialGalleryDocument, variables, headers),
      options
    );
useEditorialGalleryQuery.document = EditorialGalleryDocument;


useEditorialGalleryQuery.getKey = (variables: EditorialGalleryQueryVariables) => ['EditorialGallery', variables];
;

export const BanderoleDocument = `
    query banderole($preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: "home"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      deliveryDays
      banderole {
        textColor
        backgroundColor
        sticky
        countDown {
          countDownDate
          promoText
          newsletterText
          pdpText
          pdpCategory
          discountCode
          disableNewsletterPopup
          hideCountDown
          hideStageCountdown
          hidePdpCountdown
          fullClick
        }
      }
      secondaryBanderole {
        textColor
        backgroundColor
        sticky
        banderoleContent {
          newsletterText
        }
      }
      banderoleNewsletter {
        __typename
        ... on BanderoleNesletter {
          sys {
            id
          }
          banderoleNewsletterTitle
          banderoleNewsletterImage {
            url
          }
          activeNewsletterBlockId
          banderolePopupCloseIconColor
        }
      }
      footerNote {
        ...rteFr
      }
    }
  }
}
    ${RteFrFragmentDoc}
${CtaFrFragmentDoc}`;
export const useBanderoleQuery = <
      TData = BanderoleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: BanderoleQueryVariables,
      options?: UseQueryOptions<BanderoleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<BanderoleQuery, TError, TData>(
      ['banderole', variables],
      fetcher<BanderoleQuery, BanderoleQueryVariables>(client, BanderoleDocument, variables, headers),
      options
    );
useBanderoleQuery.document = BanderoleDocument;


useBanderoleQuery.getKey = (variables: BanderoleQueryVariables) => ['banderole', variables];
;

export const HeaderDocument = `
    query header($preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: "home"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      mainMegaNavigation {
        firstLevelItemsCollection(limit: 5) {
          items {
            sys {
              id
            }
            title
            subline
            highlightedColor
            pageContent {
              title
              slug
            }
            subElementsCollection(limit: 6) {
              items {
                sys {
                  id
                }
                categoriesCollection(limit: 6) {
                  items {
                    sys {
                      id
                    }
                    title
                    subline
                    subElementsCollection(limit: 16) {
                      items {
                        sys {
                          id
                        }
                        title
                        subline
                        highlightedColor
                        colorHex
                        colorful
                        pageContent {
                          title
                          slug
                        }
                      }
                    }
                    pageContent {
                      title
                      slug
                    }
                  }
                }
                sys {
                  id
                }
              }
            }
            bottomElement {
              sys {
                id
              }
              title
              pageContent {
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useHeaderQuery = <
      TData = HeaderQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: HeaderQueryVariables,
      options?: UseQueryOptions<HeaderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HeaderQuery, TError, TData>(
      ['header', variables],
      fetcher<HeaderQuery, HeaderQueryVariables>(client, HeaderDocument, variables, headers),
      options
    );
useHeaderQuery.document = HeaderDocument;


useHeaderQuery.getKey = (variables: HeaderQueryVariables) => ['header', variables];
;

export const MobileHeaderDocument = `
    query mobileHeader($preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: "home"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      mainMegaNavigation {
        mobileFirstLevelItemsCollection(limit: 5) {
          items {
            sys {
              id
            }
            title
            subline
            highlightedColor
            pageContent {
              title
              slug
            }
            subElementsCollection(limit: 6) {
              items {
                sys {
                  id
                }
                categoriesCollection(limit: 6) {
                  items {
                    sys {
                      id
                    }
                    title
                    subline
                    subElementsCollection(limit: 16) {
                      items {
                        sys {
                          id
                        }
                        title
                        subline
                        highlightedColor
                        pageContent {
                          title
                          slug
                        }
                      }
                    }
                    pageContent {
                      title
                      slug
                    }
                  }
                }
                sys {
                  id
                }
              }
            }
            bottomElement {
              sys {
                id
              }
              title
              pageContent {
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useMobileHeaderQuery = <
      TData = MobileHeaderQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: MobileHeaderQueryVariables,
      options?: UseQueryOptions<MobileHeaderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MobileHeaderQuery, TError, TData>(
      ['mobileHeader', variables],
      fetcher<MobileHeaderQuery, MobileHeaderQueryVariables>(client, MobileHeaderDocument, variables, headers),
      options
    );
useMobileHeaderQuery.document = MobileHeaderDocument;


useMobileHeaderQuery.getKey = (variables: MobileHeaderQueryVariables) => ['mobileHeader', variables];
;

export const HeroStageModuleDocument = `
    query HeroStageModule($id: String!, $preview: Boolean!, $locale: String!) {
  heroStageModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    displayNavigation
    heroStageItemsCollection(limit: 5) {
      items {
        headline
        theme
        subline
        countdownDate
        cta {
          ...CtaFr
        }
        copyText
        video {
          url
          description
          title
          contentType
        }
        videoMobile {
          url
          description
          title
          contentType
        }
        desktopImage {
          title
          url
          width
          height
          description
        }
        mobileImage {
          title
          url
          width
          height
          description
        }
      }
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useHeroStageModuleQuery = <
      TData = HeroStageModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: HeroStageModuleQueryVariables,
      options?: UseQueryOptions<HeroStageModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HeroStageModuleQuery, TError, TData>(
      ['HeroStageModule', variables],
      fetcher<HeroStageModuleQuery, HeroStageModuleQueryVariables>(client, HeroStageModuleDocument, variables, headers),
      options
    );
useHeroStageModuleQuery.document = HeroStageModuleDocument;


useHeroStageModuleQuery.getKey = (variables: HeroStageModuleQueryVariables) => ['HeroStageModule', variables];
;

export const HiddenH1Document = `
    query HiddenH1($id: String!, $preview: Boolean!, $locale: String!) {
  hiddenHeadingH1(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    hiddenH1Item
  }
}
    `;
export const useHiddenH1Query = <
      TData = HiddenH1Query,
      TError = Error
    >(
      client: GraphQLClient,
      variables: HiddenH1QueryVariables,
      options?: UseQueryOptions<HiddenH1Query, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<HiddenH1Query, TError, TData>(
      ['HiddenH1', variables],
      fetcher<HiddenH1Query, HiddenH1QueryVariables>(client, HiddenH1Document, variables, headers),
      options
    );
useHiddenH1Query.document = HiddenH1Document;


useHiddenH1Query.getKey = (variables: HiddenH1QueryVariables) => ['HiddenH1', variables];
;

export const ImageModuleDocument = `
    query ImageModule($id: String!, $preview: Boolean!, $locale: String!) {
  imageModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    richText {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    imageCaption
    imageAspectRatio
    cta {
      ...CtaFr
    }
    marginBottom
    marginBottomMobile
    imagesCollection(limit: 16) {
      items {
        sys {
          id
        }
        imageCaption
        imageFocus
        image {
          url
          description
          width
          height
          title
        }
        imageMobile {
          url
          description
          width
          height
          title
        }
        textDirection
        rteField {
          sys {
            id
          }
        }
      }
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useImageModuleQuery = <
      TData = ImageModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ImageModuleQueryVariables,
      options?: UseQueryOptions<ImageModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ImageModuleQuery, TError, TData>(
      ['ImageModule', variables],
      fetcher<ImageModuleQuery, ImageModuleQueryVariables>(client, ImageModuleDocument, variables, headers),
      options
    );
useImageModuleQuery.document = ImageModuleDocument;


useImageModuleQuery.getKey = (variables: ImageModuleQueryVariables) => ['ImageModule', variables];
;

export const InstagramModuleDocument = `
    query InstagramModule($id: String!, $preview: Boolean!, $locale: String!) {
  instagramModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    subline
    cta {
      ...CtaFr
    }
    spacingTop
    spacingBottom
  }
}
    ${CtaFrFragmentDoc}`;
export const useInstagramModuleQuery = <
      TData = InstagramModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: InstagramModuleQueryVariables,
      options?: UseQueryOptions<InstagramModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<InstagramModuleQuery, TError, TData>(
      ['InstagramModule', variables],
      fetcher<InstagramModuleQuery, InstagramModuleQueryVariables>(client, InstagramModuleDocument, variables, headers),
      options
    );
useInstagramModuleQuery.document = InstagramModuleDocument;


useInstagramModuleQuery.getKey = (variables: InstagramModuleQueryVariables) => ['InstagramModule', variables];
;

export const LogoGridDocument = `
    query LogoGrid($id: String!, $preview: Boolean!, $locale: String!) {
  logoGrid(id: $id, preview: $preview, locale: $locale) {
    imagesCollection {
      items {
        sys {
          id
        }
        title
        url
        width
        height
        description
      }
    }
    marginBottom
    marginBottomMobile
    __typename
    sys {
      id
    }
  }
}
    `;
export const useLogoGridQuery = <
      TData = LogoGridQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: LogoGridQueryVariables,
      options?: UseQueryOptions<LogoGridQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LogoGridQuery, TError, TData>(
      ['LogoGrid', variables],
      fetcher<LogoGridQuery, LogoGridQueryVariables>(client, LogoGridDocument, variables, headers),
      options
    );
useLogoGridQuery.document = LogoGridDocument;


useLogoGridQuery.getKey = (variables: LogoGridQueryVariables) => ['LogoGrid', variables];
;

export const LookbookDocument = `
    query Lookbook($id: String!, $preview: Boolean!, $locale: String!) {
  lookbook(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    pagesCollection {
      total
      items {
        url
      }
    }
    width
    height
    marginBottom
    marginBottomMobile
  }
}
    `;
export const useLookbookQuery = <
      TData = LookbookQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: LookbookQueryVariables,
      options?: UseQueryOptions<LookbookQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<LookbookQuery, TError, TData>(
      ['Lookbook', variables],
      fetcher<LookbookQuery, LookbookQueryVariables>(client, LookbookDocument, variables, headers),
      options
    );
useLookbookQuery.document = LookbookDocument;


useLookbookQuery.getKey = (variables: LookbookQueryVariables) => ['Lookbook', variables];
;

export const NewsletterDocument = `
    query Newsletter($id: String!, $preview: Boolean!, $locale: String!) {
  newsletter(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    imageDesktop {
      title
      url
      width
      height
      description
    }
    imageMobile {
      title
      url
      width
      height
      description
    }
    subscriptionBenefits
    disclaimer {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    spacingTop
    spacingBottom
  }
}
    ${CtaFrFragmentDoc}`;
export const useNewsletterQuery = <
      TData = NewsletterQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: NewsletterQueryVariables,
      options?: UseQueryOptions<NewsletterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<NewsletterQuery, TError, TData>(
      ['Newsletter', variables],
      fetcher<NewsletterQuery, NewsletterQueryVariables>(client, NewsletterDocument, variables, headers),
      options
    );
useNewsletterQuery.document = NewsletterDocument;


useNewsletterQuery.getKey = (variables: NewsletterQueryVariables) => ['Newsletter', variables];
;

export const PageNewsletterDocument = `
    query PageNewsletter($preview: Boolean!, $locale: String!) {
  pageCollection(
    where: {slug: "home"}
    limit: 1
    preview: $preview
    locale: $locale
  ) {
    items {
      pageNewsletter {
        __typename
        ... on Newsletter {
          sys {
            id
          }
          headline
          imageDesktop {
            title
            url
            width
            height
            description
          }
          imageMobile {
            title
            url
            width
            height
            description
          }
          subscriptionBenefits
          disclaimer {
            json
            links {
              entries {
                hyperlink {
                  ... on Page {
                    slug
                    title
                  }
                  sys {
                    id
                  }
                }
                inline {
                  sys {
                    id
                  }
                  ... on Page {
                    title
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const usePageNewsletterQuery = <
      TData = PageNewsletterQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: PageNewsletterQueryVariables,
      options?: UseQueryOptions<PageNewsletterQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<PageNewsletterQuery, TError, TData>(
      ['PageNewsletter', variables],
      fetcher<PageNewsletterQuery, PageNewsletterQueryVariables>(client, PageNewsletterDocument, variables, headers),
      options
    );
usePageNewsletterQuery.document = PageNewsletterDocument;


usePageNewsletterQuery.getKey = (variables: PageNewsletterQueryVariables) => ['PageNewsletter', variables];
;

export const ProductPageDocument = `
    query ProductPage($slug: String!) {
  pageCollection(where: {slug: $slug}, limit: 1) {
    items {
      sys {
        id
      }
    }
  }
}
    `;
export const useProductPageQuery = <
      TData = ProductPageQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductPageQueryVariables,
      options?: UseQueryOptions<ProductPageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductPageQuery, TError, TData>(
      ['ProductPage', variables],
      fetcher<ProductPageQuery, ProductPageQueryVariables>(client, ProductPageDocument, variables, headers),
      options
    );
useProductPageQuery.document = ProductPageDocument;


useProductPageQuery.getKey = (variables: ProductPageQueryVariables) => ['ProductPage', variables];
;

export const ProductTeaserDocument = `
    query ProductTeaser($id: String!, $preview: Boolean!, $locale: String!) {
  productTeaser(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    image {
      title
      url
      width
      height
      description
    }
    urlKey
    descriptionHeadline
    descriptionText
    imageIsRight
    marginBottom
    marginBottomMobile
  }
}
    `;
export const useProductTeaserQuery = <
      TData = ProductTeaserQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductTeaserQueryVariables,
      options?: UseQueryOptions<ProductTeaserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductTeaserQuery, TError, TData>(
      ['ProductTeaser', variables],
      fetcher<ProductTeaserQuery, ProductTeaserQueryVariables>(client, ProductTeaserDocument, variables, headers),
      options
    );
useProductTeaserQuery.document = ProductTeaserDocument;


useProductTeaserQuery.getKey = (variables: ProductTeaserQueryVariables) => ['ProductTeaser', variables];
;

export const QuoteDocument = `
    query Quote($id: String!, $preview: Boolean!, $locale: String!) {
  quote(id: $id, preview: $preview, locale: $locale) {
    isSimpleVariant
    quoteText
    quoteAuthorName
    quoteAuthorInfo
    organicShapeColor
    image {
      title
      url
      width
      height
      description
    }
    marginBottom
    marginBottomMobile
    __typename
    sys {
      id
    }
  }
}
    `;
export const useQuoteQuery = <
      TData = QuoteQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: QuoteQueryVariables,
      options?: UseQueryOptions<QuoteQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<QuoteQuery, TError, TData>(
      ['Quote', variables],
      fetcher<QuoteQuery, QuoteQueryVariables>(client, QuoteDocument, variables, headers),
      options
    );
useQuoteQuery.document = QuoteDocument;


useQuoteQuery.getKey = (variables: QuoteQueryVariables) => ['Quote', variables];
;

export const RteFieldDocument = `
    query RteField($id: String!, $preview: Boolean!, $locale: String!) {
  rte(id: $id, preview: $preview, locale: $locale) {
    rte {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useRteFieldQuery = <
      TData = RteFieldQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: RteFieldQueryVariables,
      options?: UseQueryOptions<RteFieldQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<RteFieldQuery, TError, TData>(
      ['RteField', variables],
      fetcher<RteFieldQuery, RteFieldQueryVariables>(client, RteFieldDocument, variables, headers),
      options
    );
useRteFieldQuery.document = RteFieldDocument;


useRteFieldQuery.getKey = (variables: RteFieldQueryVariables) => ['RteField', variables];
;

export const ProductsSliderDocument = `
    query ProductsSlider($id: String!, $preview: Boolean!, $locale: String!) {
  productsSlider(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    urlKey
    skus
    cioRecommendationsId
    cioRecommendationsFilterName
    cioRecommendationsFilterValue
    cioRecommendationsResultsLimit
    headline
    spacingTop
    spacingBottom
    link
    firstTeaser {
      ...TIFr
    }
    lastTeaser {
      ...TIFr
    }
  }
}
    ${TiFrFragmentDoc}
${CtaFrFragmentDoc}`;
export const useProductsSliderQuery = <
      TData = ProductsSliderQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ProductsSliderQueryVariables,
      options?: UseQueryOptions<ProductsSliderQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProductsSliderQuery, TError, TData>(
      ['ProductsSlider', variables],
      fetcher<ProductsSliderQuery, ProductsSliderQueryVariables>(client, ProductsSliderDocument, variables, headers),
      options
    );
useProductsSliderQuery.document = ProductsSliderDocument;


useProductsSliderQuery.getKey = (variables: ProductsSliderQueryVariables) => ['ProductsSlider', variables];
;

export const SeoHeadingModuleDocument = `
    query SeoHeadingModule($id: String!, $preview: Boolean!, $locale: String!) {
  seoHeadingModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    subline
    description
    spacingTop
    spacingBottom
  }
}
    `;
export const useSeoHeadingModuleQuery = <
      TData = SeoHeadingModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: SeoHeadingModuleQueryVariables,
      options?: UseQueryOptions<SeoHeadingModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SeoHeadingModuleQuery, TError, TData>(
      ['SeoHeadingModule', variables],
      fetcher<SeoHeadingModuleQuery, SeoHeadingModuleQueryVariables>(client, SeoHeadingModuleDocument, variables, headers),
      options
    );
useSeoHeadingModuleQuery.document = SeoHeadingModuleDocument;


useSeoHeadingModuleQuery.getKey = (variables: SeoHeadingModuleQueryVariables) => ['SeoHeadingModule', variables];
;

export const SeoTextModuleDocument = `
    query SeoTextModule($id: String!, $preview: Boolean!, $locale: String!) {
  seoTextModule(id: $id, preview: $preview, locale: $locale) {
    sys {
      id
    }
    seoTextsCollection(limit: 5) {
      items {
        ...SeoTextFields
      }
    }
    spacingTop
    spacingBottom
  }
}
    ${SeoTextFieldsFragmentDoc}`;
export const useSeoTextModuleQuery = <
      TData = SeoTextModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: SeoTextModuleQueryVariables,
      options?: UseQueryOptions<SeoTextModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SeoTextModuleQuery, TError, TData>(
      ['SeoTextModule', variables],
      fetcher<SeoTextModuleQuery, SeoTextModuleQueryVariables>(client, SeoTextModuleDocument, variables, headers),
      options
    );
useSeoTextModuleQuery.document = SeoTextModuleDocument;


useSeoTextModuleQuery.getKey = (variables: SeoTextModuleQueryVariables) => ['SeoTextModule', variables];
;

export const ShopTheLookDocument = `
    query ShopTheLook($id: String!, $preview: Boolean!, $locale: String!) {
  shopTheLook(id: $id, preview: $preview, locale: $locale) {
    headline
    marginBottom
    marginBottomMobile
    firstImage {
      title
      url
      width
      height
      description
    }
    firstImageFocus
    firstImageFocusMobile
    firstImageProductButtonsCollection(limit: 5) {
      items {
        ...StlItemFr
      }
    }
    secondImage {
      title
      url
      width
      height
      description
    }
    secondImageFocus
    secondImageFocusMobile
    secondImageProductButtonsCollection(limit: 5) {
      items {
        ...StlItemFr
      }
    }
    thirdImage {
      title
      url
      width
      height
      description
    }
    thirdImageFocus
    thirdImageFocusMobile
    thirdImageProductButtonsCollection(limit: 5) {
      items {
        ...StlItemFr
      }
    }
    fourthImage {
      title
      url
      width
      height
      description
    }
    fourthImageFocus
    fourthImageFocusMobile
    fourthImageProductButtonsCollection(limit: 5) {
      items {
        ...StlItemFr
      }
    }
    __typename
    sys {
      id
    }
  }
}
    ${StlItemFrFragmentDoc}`;
export const useShopTheLookQuery = <
      TData = ShopTheLookQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: ShopTheLookQueryVariables,
      options?: UseQueryOptions<ShopTheLookQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ShopTheLookQuery, TError, TData>(
      ['ShopTheLook', variables],
      fetcher<ShopTheLookQuery, ShopTheLookQueryVariables>(client, ShopTheLookDocument, variables, headers),
      options
    );
useShopTheLookQuery.document = ShopTheLookDocument;


useShopTheLookQuery.getKey = (variables: ShopTheLookQueryVariables) => ['ShopTheLook', variables];
;

export const StageDocument = `
    query Stage($id: String!, $preview: Boolean!, $locale: String!) {
  stage(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    type
    miniHeadline
    headline
    subline
    isFramed
    alignment
    imageFocus
    darkText
    imageFocusMobile
    marginBottom
    marginBottomMobile
    hasBackgroundGradient
    halfWidthText
    newStage
    mobileAlignment
    cta {
      ...CtaFr
    }
    image {
      title
      url
      width
      height
      description
    }
    imageMobile {
      title
      url
      width
      height
      description
    }
    video {
      url
      description
      title
      contentType
    }
    videoMobile {
      url
      description
      title
      contentType
    }
    countDown {
      countDownDate
      promoText
      newsletterText
      pdpText
      pdpCategory
      discountCode
      hideCountDown
      hideStageCountdown
      hidePdpCountdown
      hidePromoCode
    }
    promoCreativeName {
      dataLayerMetaContent
    }
    metaContentType {
      dataLayerMetaContent
    }
    metaContentName {
      dataLayerMetaContent
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useStageQuery = <
      TData = StageQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: StageQueryVariables,
      options?: UseQueryOptions<StageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<StageQuery, TError, TData>(
      ['Stage', variables],
      fetcher<StageQuery, StageQueryVariables>(client, StageDocument, variables, headers),
      options
    );
useStageQuery.document = StageDocument;


useStageQuery.getKey = (variables: StageQueryVariables) => ['Stage', variables];
;

export const TabModuleDocument = `
    query TabModule($id: String!, $preview: Boolean!, $locale: String!) {
  tabModule(id: $id, preview: $preview, locale: $locale) {
    tabsCollection {
      items {
        ...AcTFr
      }
    }
    marginBottom
    marginBottomMobile
    __typename
    sys {
      id
    }
  }
}
    ${AcTFrFragmentDoc}
${RteFrFragmentDoc}
${CtaFrFragmentDoc}`;
export const useTabModuleQuery = <
      TData = TabModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: TabModuleQueryVariables,
      options?: UseQueryOptions<TabModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TabModuleQuery, TError, TData>(
      ['TabModule', variables],
      fetcher<TabModuleQuery, TabModuleQueryVariables>(client, TabModuleDocument, variables, headers),
      options
    );
useTabModuleQuery.document = TabModuleDocument;


useTabModuleQuery.getKey = (variables: TabModuleQueryVariables) => ['TabModule', variables];
;

export const TeaserModuleDocument = `
    query TeaserModule($id: String!, $preview: Boolean!, $locale: String!) {
  teaserModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    headline
    teaserItemsCollection(limit: 5) {
      items {
        ...TIFr
      }
    }
    marginBottom
    marginBottomMobile
  }
}
    ${TiFrFragmentDoc}
${CtaFrFragmentDoc}`;
export const useTeaserModuleQuery = <
      TData = TeaserModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: TeaserModuleQueryVariables,
      options?: UseQueryOptions<TeaserModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TeaserModuleQuery, TError, TData>(
      ['TeaserModule', variables],
      fetcher<TeaserModuleQuery, TeaserModuleQueryVariables>(client, TeaserModuleDocument, variables, headers),
      options
    );
useTeaserModuleQuery.document = TeaserModuleDocument;


useTeaserModuleQuery.getKey = (variables: TeaserModuleQueryVariables) => ['TeaserModule', variables];
;

export const TextImageTeaserDocument = `
    query TextImageTeaser($id: String!, $preview: Boolean!, $locale: String!) {
  textImageTeaser(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    image {
      title
      url
      width
      height
      description
    }
    imageCaption
    marginBottom
    marginBottomMobile
    organicShapeColor
    handleOrganicShape
    selectShapeView
    imageMobile {
      title
      url
      width
      height
      description
    }
    mobileImageBottom
    imageDesktopLeft
    subHeadline
    headline
    centerTextAlignment
    noSidePadding
    text {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    mobileText {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    icon {
      title
    }
    cta {
      ...CtaFr
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useTextImageTeaserQuery = <
      TData = TextImageTeaserQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: TextImageTeaserQueryVariables,
      options?: UseQueryOptions<TextImageTeaserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TextImageTeaserQuery, TError, TData>(
      ['TextImageTeaser', variables],
      fetcher<TextImageTeaserQuery, TextImageTeaserQueryVariables>(client, TextImageTeaserDocument, variables, headers),
      options
    );
useTextImageTeaserQuery.document = TextImageTeaserDocument;


useTextImageTeaserQuery.getKey = (variables: TextImageTeaserQueryVariables) => ['TextImageTeaser', variables];
;

export const TextPicTeaserModuleDocument = `
    query TextPicTeaserModule($id: String!, $preview: Boolean!, $locale: String!) {
  textPicModule(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    itemsCollection {
      items {
        headline
        subline
        backgroundColor
        textColor
        theme
        video {
          url
          description
          title
          contentType
        }
        videoMobile {
          url
          description
          title
          contentType
        }
        desktopImage {
          title
          url
          width
          height
          description
        }
        mobileImage {
          title
          url
          width
          height
          description
        }
        cta {
          ...CtaFr
        }
      }
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useTextPicTeaserModuleQuery = <
      TData = TextPicTeaserModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: TextPicTeaserModuleQueryVariables,
      options?: UseQueryOptions<TextPicTeaserModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TextPicTeaserModuleQuery, TError, TData>(
      ['TextPicTeaserModule', variables],
      fetcher<TextPicTeaserModuleQuery, TextPicTeaserModuleQueryVariables>(client, TextPicTeaserModuleDocument, variables, headers),
      options
    );
useTextPicTeaserModuleQuery.document = TextPicTeaserModuleDocument;


useTextPicTeaserModuleQuery.getKey = (variables: TextPicTeaserModuleQueryVariables) => ['TextPicTeaserModule', variables];
;

export const TextTeaserDocument = `
    query TextTeaser($id: String!, $preview: Boolean!, $locale: String!) {
  textTeaser(id: $id, preview: $preview, locale: $locale) {
    __typename
    sys {
      id
    }
    cta {
      ...CtaFr
    }
    headline
    subline
    textAlignment
    centerWithLeftAlign
    twoColumnLayout
    text {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    marginBottom
    marginBottomMobile
  }
}
    ${CtaFrFragmentDoc}`;
export const useTextTeaserQuery = <
      TData = TextTeaserQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: TextTeaserQueryVariables,
      options?: UseQueryOptions<TextTeaserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<TextTeaserQuery, TError, TData>(
      ['TextTeaser', variables],
      fetcher<TextTeaserQuery, TextTeaserQueryVariables>(client, TextTeaserDocument, variables, headers),
      options
    );
useTextTeaserQuery.document = TextTeaserDocument;


useTextTeaserQuery.getKey = (variables: TextTeaserQueryVariables) => ['TextTeaser', variables];
;

export const VideoModuleDocument = `
    query VideoModule($id: String!, $preview: Boolean!, $locale: String!) {
  video(id: $id, preview: $preview, locale: $locale) {
    headline
    organicShapeColor
    handleOrganicShape
    marginBottom
    marginBottomMobile
    youTubeUrl
    autoPlay
    unmuted
    videoWidth
    hideControls
    mobileVideoAboveText
    desktopVideoLeft
    rte {
      json
      links {
        assets {
          block {
            title
            url
            width
            height
            sys {
              id
            }
          }
        }
        entries {
          block {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          hyperlink {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
          inline {
            ... on Cta {
              ...CtaFr
            }
            ... on Page {
              slug
              title
            }
            sys {
              id
            }
          }
        }
      }
    }
    videoFile {
      url
      contentType
    }
    placeholderImage {
      title
      url
      contentType
    }
    __typename
    sys {
      id
    }
  }
}
    ${CtaFrFragmentDoc}`;
export const useVideoModuleQuery = <
      TData = VideoModuleQuery,
      TError = Error
    >(
      client: GraphQLClient,
      variables: VideoModuleQueryVariables,
      options?: UseQueryOptions<VideoModuleQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<VideoModuleQuery, TError, TData>(
      ['VideoModule', variables],
      fetcher<VideoModuleQuery, VideoModuleQueryVariables>(client, VideoModuleDocument, variables, headers),
      options
    );
useVideoModuleQuery.document = VideoModuleDocument;


useVideoModuleQuery.getKey = (variables: VideoModuleQueryVariables) => ['VideoModule', variables];
;
